export enum Pkm {
  ABOMASNOW = "ABOMASNOW",
  ABRA = "ABRA",
  ABSOL = "ABSOL",
  AEGISLASH = "AEGISLASH",
  AEGISLASH_BLADE = "AEGISLASH_BLADE",
  AERODACTYL = "AERODACTYL",
  AGGRON = "AGGRON",
  AIPOM = "AIPOM",
  ALAKAZAM = "ALAKAZAM",
  ALCREMIE_VANILLA = "ALCREMIE_VANILLA",
  ALCREMIE_RUBY = "ALCREMIE_RUBY",
  ALCREMIE_MATCHA = "ALCREMIE_MATCHA",
  ALCREMIE_MINT = "ALCREMIE_MINT",
  ALCREMIE_LEMON = "ALCREMIE_LEMON",
  ALCREMIE_SALTED = "ALCREMIE_SALTED",
  ALCREMIE_RUBY_SWIRL = "ALCREMIE_RUBY_SWIRL",
  ALCREMIE_CARAMEL_SWIRL = "ALCREMIE_CARAMEL_SWIRL",
  ALCREMIE_RAINBOW_SWIRL = "ALCREMIE_RAINBOW_SWIRL",
  ALOLAN_DIGLETT = "ALOLAN_DIGLETT",
  ALOLAN_DUGTRIO = "ALOLAN_DUGTRIO",
  ALOLAN_EXEGGUTOR = "ALOLAN_EXEGGUTOR",
  ALOLAN_GEODUDE = "ALOLAN_GEODUDE",
  ALOLAN_GOLEM = "ALOLAN_GOLEM",
  ALOLAN_GRAVELER = "ALOLAN_GRAVELER",
  ALOLAN_GRIMER = "ALOLAN_GRIMER",
  ALOLAN_MAROWAK = "ALOLAN_MAROWAK",
  ALOLAN_MEOWTH = "ALOLAN_MEOWTH",
  ALOLAN_MUK = "ALOLAN_MUK",
  ALOLAN_NINETALES = "ALOLAN_NINETALES",
  ALOLAN_PERSIAN = "ALOLAN_PERSIAN",
  ALOLAN_RAICHU = "ALOLAN_RAICHU",
  ALOLAN_RATICATE = "ALOLAN_RATICATE",
  ALOLAN_RATTATA = "ALOLAN_RATTATA",
  ALOLAN_SANDSHREW = "ALOLAN_SANDSHREW",
  ALOLAN_SANDSLASH = "ALOLAN_SANDSLASH",
  ALOLAN_VULPIX = "ALOLAN_VULPIX",
  ALTARIA = "ALTARIA",
  AMAURA = "AMAURA",
  AMBIPOM = "AMBIPOM",
  AMPHAROS = "AMPHAROS",
  ANNIHILAPE = "ANNIHILAPE",
  ANORITH = "ANORITH",
  APPLETUN = "APPLETUN",
  APPLIN = "APPLIN",
  ARBOLIVA = "ARBOLIVA",
  ARAQUANID = "ARAQUANID",
  ARBOK = "ARBOK",
  ARCANINE = "ARCANINE",
  ARCEUS = "ARCEUS",
  ARCEUS_BUG = "ARCEUS_BUG",
  ARCEUS_DARK = "ARCEUS_DARK",
  ARCEUS_DRAGON = "ARCEUS_DRAGON",
  ARCEUS_ELECTRIC = "ARCEUS_ELECTRIC",
  ARCEUS_FIGHTING = "ARCEUS_FIGHTING",
  ARCEUS_FIRE = "ARCEUS_FIRE",
  ARCEUS_FLYING = "ARCEUS_FLYING",
  ARCEUS_GHOST = "ARCEUS_GHOST",
  ARCEUS_GRASS = "ARCEUS_GRASS",
  ARCEUS_GROUND = "ARCEUS_GROUND",
  ARCEUS_ICE = "ARCEUS_ICE",
  ARCEUS_POISON = "ARCEUS_POISON",
  ARCEUS_PSYCHIC = "ARCEUS_PSYCHIC",
  ARCEUS_ROCK = "ARCEUS_ROCK",
  ARCEUS_STEEL = "ARCEUS_STEEL",
  ARCEUS_WATER = "ARCEUS_WATER",
  ARCEUS_FAIRY = "ARCEUS_FAIRY",
  ARCHALUDON = "ARCHALUDON",
  ARCHEN = "ARCHEN",
  ARCHEOPS = "ARCHEOPS",
  ARCTIBAX = "ARCTIBAX",
  ARCTOVISH = "ARCTOVISH",
  ARCTOZOLT = "ARCTOZOLT",
  ARIADOS = "ARIADOS",
  ARMALDO = "ARMALDO",
  ARMAROUGE = "ARMAROUGE",
  ARON = "ARON",
  ARROKUDA = "ARROKUDA",
  ARTICUNO = "ARTICUNO",
  AUDINO = "AUDINO",
  AURORUS = "AURORUS",
  AVALUGG = "AVALUGG",
  AXEW = "AXEW",
  AZELF = "AZELF",
  AZUMARILL = "AZUMARILL",
  AZURILL = "AZURILL",
  BAGON = "BAGON",
  BALTOY = "BALTOY",
  BANETTE = "BANETTE",
  BARBARACLE = "BARBARACLE",
  BARBOACH = "BARBOACH",
  BASCULEGION_MALE = "BASCULEGION_MALE",
  BASCULEGION_FEMALE = "BASCULEGION_FEMALE",
  BASCULIN_RED = "BASCULIN_RED",
  BASCULIN_BLUE = "BASCULIN_BLUE",
  BASCULIN_WHITE = "BASCULIN_WHITE",
  BASTIODON = "BASTIODON",
  BAXCALIBUR = "BAXCALIBUR",
  BAYLEEF = "BAYLEEF",
  BEARTIC = "BEARTIC",
  BEAUTIFLY = "BEAUTIFLY",
  BEEDRILL = "BEEDRILL",
  BEHEEYEM = "BEHEEYEM",
  BELDUM = "BELDUM",
  BELLIBOLT = "BELLIBOLT",
  BELLOSSOM = "BELLOSSOM",
  BELLSPROUT = "BELLSPROUT",
  BERGMITE = "BERGMITE",
  BIBAREL = "BIBAREL",
  BIDOOF = "BIDOOF",
  BINACLE = "BINACLE",
  BISHARP = "BISHARP",
  BLACEPHALON = "BLACEPHALON",
  BLASTOISE = "BLASTOISE",
  BLAZIKEN = "BLAZIKEN",
  BLIPBUG = "BLIPBUG",
  BLISSEY = "BLISSEY",
  BOLDORE = "BOLDORE",
  BOLTUND = "BOLTUND",
  BONSLEY = "BONSLEY",
  BOUNSWEET = "BOUNSWEET",
  BRAIXEN = "BRAIXEN",
  BRAVIARY = "BRAVIARY",
  BRELOOM = "BRELOOM",
  BRIONNE = "BRIONNE",
  BRONZONG = "BRONZONG",
  BRONZOR = "BRONZOR",
  BRUXISH = "BRUXISH",
  BUDEW = "BUDEW",
  BUIZEL = "BUIZEL",
  BULBASAUR = "BULBASAUR",
  BUNEARY = "BUNEARY",
  BUNNELBY = "BUNNELBY",
  BURMY_PLANT = "BURMY_PLANT",
  BURMY_SANDY = "BURMY_SANDY",
  BURMY_TRASH = "BURMY_TRASH",
  BUTTERFREE = "BUTTERFREE",
  BUZZWOLE = "BUZZWOLE",
  CACNEA = "CACNEA",
  CACTURNE = "CACTURNE",
  CAMERUPT = "CAMERUPT",
  CAPSAKID = "CAPSAKID",
  CARBINK = "CARBINK",
  CARNIVINE = "CARNIVINE",
  //CARRACOSTA = "CARRACOSTA",
  CARVANHA = "CARVANHA",
  CASCOON = "CASCOON",
  CASTFORM = "CASTFORM",
  CASTFORM_HAIL = "CASTFORM_HAIL",
  CASTFORM_RAIN = "CASTFORM_RAIN",
  CASTFORM_SUN = "CASTFORM_SUN",
  CATERPIE = "CATERPIE",
  CELEBI = "CELEBI",
  CELESTEELA = "CELESTEELA",
  CENTISKORCH = "CENTISKORCH",
  CERULEDGE = "CERULEDGE",
  CETITAN = "CETITAN",
  CETODDLE = "CETODDLE",
  CHANDELURE = "CHANDELURE",
  CHANSEY = "CHANSEY",
  CHARCADET = "CHARCADET",
  CHARIZARD = "CHARIZARD",
  CHARJABUG = "CHARJABUG",
  CHARMANDER = "CHARMANDER",
  CHARMELEON = "CHARMELEON",
  CHATOT = "CHATOT",
  CHERRIM = "CHERRIM",
  CHERRIM_SUNLIGHT = "CHERRIM_SUNLIGHT",
  CHERUBI = "CHERUBI",
  CHESPIN = "CHESPIN",
  CHESNAUGHT = "CHESNAUGHT",
  CHEWTLE = "CHEWTLE",
  CHIKORITA = "CHIKORITA",
  CHIMCHAR = "CHIMCHAR",
  CHIMECHO = "CHIMECHO",
  CHINCHOU = "CHINCHOU",
  CHINGLING = "CHINGLING",
  CHI_YU = "CHI_YU",
  CINCCINO = "CINCCINO",
  CINDERACE = "CINDERACE",
  CLAMPERL = "CLAMPERL",
  CLAUNCHER = "CLAUNCHER",
  CLAWITZER = "CLAWITZER",
  CLAYDOL = "CLAYDOL",
  CLEFABLE = "CLEFABLE",
  CLEFAIRY = "CLEFAIRY",
  CLEFFA = "CLEFFA",
  CLOBBOPUS = "CLOBBOPUS",
  CLODSIRE = "CLODSIRE",
  CLOYSTER = "CLOYSTER",
  COBALION = "COBALION",
  COFAGRIGUS = "COFAGRIGUS",
  COMBEE = "COMBEE",
  COMBUSKEN = "COMBUSKEN",
  COMFEY = "COMFEY",
  CONKELDURR = "CONKELDURR",
  CORPHISH = "CORPHISH",
  CORSOLA = "CORSOLA",
  CORVIKNIGHT = "CORVIKNIGHT",
  CORVISQUIRE = "CORVISQUIRE",
  COSMOEM = "COSMOEM",
  COSMOG = "COSMOG",
  COTTONEE = "COTTONEE",
  CRABOMINABLE = "CRABOMINABLE",
  CRABRAWLER = "CRABRAWLER",
  CRADILY = "CRADILY",
  CRAMORANT = "CRAMORANT",
  CRANIDOS = "CRANIDOS",
  CRAWDAUNT = "CRAWDAUNT",
  CRESSELIA = "CRESSELIA",
  CROAGUNK = "CROAGUNK",
  CROBAT = "CROBAT",
  CROCALOR = "CROCALOR",
  CROCONAW = "CROCONAW",
  CRUSTLE = "CRUSTLE",
  CRYOGONAL = "CRYOGONAL",
  CUBCHOO = "CUBCHOO",
  CUBONE = "CUBONE",
  CURSOLA = "CURSOLA",
  CUTIEFLY = "CUTIEFLY",
  CYCLIZAR = "CYCLIZAR",
  CYNDAQUIL = "CYNDAQUIL",
  DACHSBUN = "DACHSBUN",
  DARKRAI = "DARKRAI",
  DARMANITAN = "DARMANITAN",
  DARMANITAN_ZEN = "DARMANITAN_ZEN",
  DARTIX = "DARTIX",
  DARUMAKA = "DARUMAKA",
  DECIDUEYE = "DECIDUEYE",
  DEDENNE = "DEDENNE",
  DEERLING_SPRING = "DEERLING_SPRING",
  DEERLING_SUMMER = "DEERLING_SUMMER",
  DEERLING_AUTUMN = "DEERLING_AUTUMN",
  DEERLING_WINTER = "DEERLING_WINTER",
  DEFAULT = "DEFAULT",
  DEINO = "DEINO",
  DELCATTY = "DELCATTY",
  DELIBIRD = "DELIBIRD",
  DELPHOX = "DELPHOX",
  DEOXYS = "DEOXYS",
  DEOXYS_ATTACK = "DEOXYS_ATTACK",
  DEOXYS_DEFENSE = "DEOXYS_DEFENSE",
  DEOXYS_SPEED = "DEOXYS_SPEED",
  DEWGONG = "DEWGONG",
  DEWOTT = "DEWOTT",
  DEWPIDER = "DEWPIDER",
  DHELMISE = "DHELMISE",
  DIALGA = "DIALGA",
  DIANCIE = "DIANCIE",
  DIGGERSBY = "DIGGERSBY",
  DIGLETT = "DIGLETT",
  DIPPLIN = "DIPPLIN",
  DITTO = "DITTO",
  DODRIO = "DODRIO",
  DODUO = "DODUO",
  DOLLIV = "DOLLIV",
  DONDOZO = "DONDOZO",
  DONPHAN = "DONPHAN",
  DOTTLER = "DOTTLER",
  DOUBLADE = "DOUBLADE",
  DRACOVISH = "DRACOVISH",
  DRACOZOLT = "DRACOZOLT",
  DRAGALGE = "DRAGALGE",
  DRAGAPULT = "DRAGAPULT",
  DRAGONAIR = "DRAGONAIR",
  DRAGONITE = "DRAGONITE",
  DRAKLOAK = "DRAKLOAK",
  DRAMPA = "DRAMPA",
  DRAPION = "DRAPION",
  DRATINI = "DRATINI",
  DREDNAW = "DREDNAW",
  DREEPY = "DREEPY",
  DRIFBLIM = "DRIFBLIM",
  DRIFLOON = "DRIFLOON",
  DRILBUR = "DRILBUR",
  DRIZZILE = "DRIZZILE",
  DROWZEE = "DROWZEE",
  DRUDDIGON = "DRUDDIGON",
  DUBWOOL = "DUBWOOL",
  DUCKLETT = "DUCKLETT",
  DUDUNSPARCE = "DUDUNSPARCE",
  DUGTRIO = "DUGTRIO",
  DUNSPARCE = "DUNSPARCE",
  DUOSION = "DUOSION",
  DURALUDON = "DURALUDON",
  DURANT = "DURANT",
  DUSCLOPS = "DUSCLOPS",
  DUSKNOIR = "DUSKNOIR",
  DUSKULL = "DUSKULL",
  DUSTOX = "DUSTOX",
  DWEBBLE = "DWEBBLE",
  EELEKTRIK = "EELEKTRIK",
  EELEKTROSS = "EELEKTROSS",
  EEVEE = "EEVEE",
  EGG = "EGG",
  EISCUE = "EISCUE",
  EISCUE_NOICE = "EISCUE_NOICE",
  EKANS = "EKANS",
  ELDEGOSS = "ELDEGOSS",
  ELECTABUZZ = "ELECTABUZZ",
  ELECTIVIRE = "ELECTIVIRE",
  ELECTRIKE = "ELECTRIKE",
  ELECTRODE = "ELECTRODE",
  ELEKID = "ELEKID",
  ELGYEM = "ELGYEM",
  EMBOAR = "EMBOAR",
  EMOLGA = "EMOLGA",
  EMPOLEON = "EMPOLEON",
  ENAMORUS = "ENAMORUS",
  ENTEI = "ENTEI",
  ESCAVALIER = "ESCAVALIER",
  ESPEON = "ESPEON",
  ESPURR = "ESPURR",
  ETERNATUS = "ETERNATUS",
  EXCADRILL = "EXCADRILL",
  EXEGGCUTE = "EXEGGCUTE",
  EXEGGUTOR = "EXEGGUTOR",
  EXPLOUD = "EXPLOUD",
  FALINKS_BRASS = "FALINKS_BRASS",
  FALINKS_TROOPER = "FALINKS_TROOPER",
  FARFETCH_D = "FARFETCH_D",
  FARIGIRAF = "FARIGIRAF",
  FEAROW = "FEAROW",
  FEEBAS = "FEEBAS",
  FENNEKIN = "FENNEKIN",
  FERALIGATR = "FERALIGATR",
  FERROSEED = "FERROSEED",
  FERROTHORN = "FERROTHORN",
  FEZANDIPITI = "FEZANDIPITI",
  FIDOUGH = "FIDOUGH",
  FINNEON = "FINNEON",
  FINIZEN = "FINIZEN",
  FLABEBE = "FLABEBE",
  FLABEBE_BLUE = "FLABEBE_BLUE",
  FLABEBE_ORANGE = "FLABEBE_ORANGE",
  FLABEBE_WHITE = "FLABEBE_WHITE",
  FLABEBE_YELLOW = "FLABEBE_YELLOW",
  FLAFFY = "FLAFFY",
  FLAPPLE = "FLAPPLE",
  FLAREON = "FLAREON",
  FLETCHINDER = "FLETCHINDER",
  FLETCHLING = "FLETCHLING",
  FLOATZEL = "FLOATZEL",
  FLOETTE = "FLOETTE",
  FLOETTE_BLUE = "FLOETTE_BLUE",
  FLOETTE_ORANGE = "FLOETTE_ORANGE",
  FLOETTE_WHITE = "FLOETTE_WHITE",
  FLOETTE_YELLOW = "FLOETTE_YELLOW",
  FLORAGATO = "FLORAGATO",
  FLORGES = "FLORGES",
  FLORGES_BLUE = "FLORGES_BLUE",
  FLORGES_ORANGE = "FLORGES_ORANGE",
  FLORGES_WHITE = "FLORGES_WHITE",
  FLORGES_YELLOW = "FLORGES_YELLOW",
  FLUTTER_MANE = "FLUTTER_MANE",
  FLYGON = "FLYGON",
  FOMANTIS = "FOMANTIS",
  FORRETRESS = "FORRETRESS",
  FRAXURE = "FRAXURE",
  FRIGIBAX = "FRIGIBAX",
  FROAKIE = "FROAKIE",
  FROGADIER = "FROGADIER",
  FROSLASS = "FROSLASS",
  FROSMOTH = "FROSMOTH",
  FUECOCO = "FUECOCO",
  FURFROU = "FURFROU",
  FURRET = "FURRET",
  GABITE = "GABITE",
  GALAR_CORSOLA = "GALAR_CORSOLA",
  GALARIAN_DARMANITAN = "GALARIAN_DARMANITAN",
  GALARIAN_DARMANITAN_ZEN = "GALARIAN_DARMANITAN_ZEN",
  GALARIAN_DARUMAKA = "GALARIAN_DARUMAKA",
  GALARIAN_ARTICUNO = "GALARIAN_ARTICUNO",
  GALARIAN_FARFETCH_D = "GALARIAN_FARFETCH_D",
  GALARIAN_LINOONE = "GALARIAN_LINOONE",
  GALARIAN_MOLTRES = "GALARIAN_MOLTRES",
  GALARIAN_PONYTA = "GALARIAN_PONYTA",
  GALARIAN_RAPIDASH = "GALARIAN_RAPIDASH",
  GALARIAN_SLOWPOKE = "GALARIAN_SLOWPOKE",
  GALARIAN_SLOWBRO = "GALARIAN_SLOWBRO",
  GALARIAN_SLOWKING = "GALARIAN_SLOWKING",
  GALARIAN_WEEZING = "GALARIAN_WEEZING",
  GALARIAN_YAMASK = "GALARIAN_YAMASK",
  GALARIAN_ZAPDOS = "GALARIAN_ZAPDOS",
  GALARIAN_ZIGZAGOON = "GALARIAN_ZIGZAGOON",
  GALLADE = "GALLADE",
  GALVANTULA = "GALVANTULA",
  GARBODOR = "GARBODOR",
  GARCHOMP = "GARCHOMP",
  GARDEVOIR = "GARDEVOIR",
  GARGANACL = "GARGANACL",
  GASTLY = "GASTLY",
  GASTRODON_EAST_SEA = "GASTRODON_EAST_SEA",
  GASTRODON_WEST_SEA = "GASTRODON_WEST_SEA",
  GENESECT = "GENESECT",
  GENGAR = "GENGAR",
  GEODUDE = "GEODUDE",
  GHOLDENGO = "GHOLDENGO",
  GIBLE = "GIBLE",
  GIGALITH = "GIGALITH",
  GIMMIGHOUL = "GIMMIGHOUL",
  GIRAFARIG = "GIRAFARIG",
  GIRATINA = "GIRATINA",
  GLACEON = "GLACEON",
  GLALIE = "GLALIE",
  GLAMEOW = "GLAMEOW",
  GLASTRIER = "GLASTRIER",
  GLIGAR = "GLIGAR",
  GLISCOR = "GLISCOR",
  GLIMMET = "GLIMMET",
  GLIMMORA = "GLIMMORA",
  GLOOM = "GLOOM",
  GOGOAT = "GOGOAT",
  GOLBAT = "GOLBAT",
  GOLDEEN = "GOLDEEN",
  GOLDUCK = "GOLDUCK",
  GOLEM = "GOLEM",
  GOLETT = "GOLETT",
  GOLISOPOD = "GOLISOPOD",
  GOLURK = "GOLURK",
  GOODRA = "GOODRA",
  GOOMY = "GOOMY",
  GOREBYSS = "GOREBYSS",
  GOSSIFLEUR = "GOSSIFLEUR",
  GOTHITA = "GOTHITA",
  GOTHITELLE = "GOTHITELLE",
  GOTHORITA = "GOTHORITA",
  GOURGEIST = "GOURGEIST",
  GRANBULL = "GRANBULL",
  GRAPPLOCT = "GRAPPLOCT",
  GRAVELER = "GRAVELER",
  GREAT_TUSK = "GREAT_TUSK",
  GREAVARD = "GREAVARD",
  GRENINJA = "GRENINJA",
  GRIMER = "GRIMER",
  GRIMMSNARL = "GRIMMSNARL",
  GROOKEY = "GROOKEY",
  GROTLE = "GROTLE",
  GROUDON = "GROUDON",
  GROVYLE = "GROVYLE",
  GROWLITHE = "GROWLITHE",
  GRUBBIN = "GRUBBIN",
  GRUMPIG = "GRUMPIG",
  GULPIN = "GULPIN",
  GURDURR = "GURDURR",
  GUZZLORD = "GUZZLORD",
  GYARADOS = "GYARADOS",
  HAKAMO_O = "HAKAMO_O",
  HAPPINY = "HAPPINY",
  HARIYAMA = "HARIYAMA",
  HATENNA = "HATENNA",
  HATTERENE = "HATTERENE",
  HATTREM = "HATTREM",
  HAUNTER = "HAUNTER",
  HAWLUCHA = "HAWLUCHA",
  HAXORUS = "HAXORUS",
  HEATMOR = "HEATMOR",
  HEATRAN = "HEATRAN",
  HELIOLISK = "HELIOLISK",
  HELIOPTILE = "HELIOPTILE",
  HERACROSS = "HERACROSS",
  HERDIER = "HERDIER",
  HIPPODOWN = "HIPPODOWN",
  HIPPOPOTAS = "HIPPOPOTAS",
  HISUI_ARCANINE = "HISUI_ARCANINE",
  HISUI_AVALUGG = "HISUI_AVALUGG",
  HISUI_ELECTRODE = "HISUI_ELECTRODE",
  HISUI_GOODRA = "HISUI_GOODRA",
  HISUI_GROWLITHE = "HISUI_GROWLITHE",
  HISUI_SLIGGOO = "HISUI_SLIGGOO",
  HISUI_SNEASEL = "HISUI_SNEASEL",
  HISUI_VOLTORB = "HISUI_VOLTORB",
  HISUI_ZOROARK = "HISUI_ZOROARK",
  HISUI_ZORUA = "HISUI_ZORUA",
  HISUIAN_LILLIGANT = "HISUIAN_LILLIGANT",
  HISUIAN_QWILFISH = "HISUIAN_QWILFISH",
  HISUI_SAMUROTT = "HISUI_SAMUROTT",
  HISUIAN_TYPHLOSION = "HISUIAN_TYPHLOSION",
  HITMONCHAN = "HITMONCHAN",
  HITMONLEE = "HITMONLEE",
  HITMONTOP = "HITMONTOP",
  HO_OH = "HO_OH",
  HONCHKROW = "HONCHKROW",
  HONEDGE = "HONEDGE",
  HOOPA = "HOOPA",
  HOOPA_UNBOUND = "HOOPA_UNBOUND",
  HOOTHOOT = "HOOTHOOT",
  HOPPIP = "HOPPIP",
  HORSEA = "HORSEA",
  HOUNDOOM = "HOUNDOOM",
  HOUNDOUR = "HOUNDOUR",
  HOUNDSTONE = "HOUNDSTONE",
  HUNTAIL = "HUNTAIL",
  HYDRAPPLE = "HYDRAPPLE",
  HYDREIGON = "HYDREIGON",
  HYPNO = "HYPNO",
  IGGLYBUFF = "IGGLYBUFF",
  ILLUMISE = "ILLUMISE",
  IMPIDIMP = "IMPIDIMP",
  INCINEROAR = "INCINEROAR",
  INDEEDEE_FEMALE = "INDEEDEE_FEMALE",
  INDEEDEE_MALE = "INDEEDEE_MALE",
  INFERNAPE = "INFERNAPE",
  INKAY = "INKAY",
  INTELEON = "INTELEON",
  IRON_BUNDLE = "IRON_BUNDLE",
  IRON_HANDS = "IRON_HANDS",
  IRON_THORNS = "IRON_THORNS",
  IRON_VALIANT = "IRON_VALIANT",
  IVYSAUR = "IVYSAUR",
  JANGMO_O = "JANGMO_O",
  JIGGLYPUFF = "JIGGLYPUFF",
  JIRACHI = "JIRACHI",
  JOLTEON = "JOLTEON",
  JOLTIK = "JOLTIK",
  JUMPLUFF = "JUMPLUFF",
  JYNX = "JYNX",
  KABUTO = "KABUTO",
  KABUTOPS = "KABUTOPS",
  KADABRA = "KADABRA",
  KAKUNA = "KAKUNA",
  KANGASKHAN = "KANGASKHAN",
  KARRABLAST = "KARRABLAST",
  KARTANA = "KARTANA",
  KECLEON = "KECLEON",
  KELDEO = "KELDEO",
  KILOWATTREL = "KILOWATTREL",
  KINGAMBIT = "KINGAMBIT",
  KINGDRA = "KINGDRA",
  KINGLER = "KINGLER",
  KIRLIA = "KIRLIA",
  KLANG = "KLANG",
  KLEAVOR = "KLEAVOR",
  KLEFKI = "KLEFKI",
  KLINK = "KLINK",
  KLINKLANG = "KLINKLANG",
  KOFFING = "KOFFING",
  KOMMO_O = "KOMMO_O",
  KRABBY = "KRABBY",
  KRICKETOT = "KRICKETOT",
  KRICKETUNE = "KRICKETUNE",
  KROKOROK = "KROKOROK",
  KROOKODILE = "KROOKODILE",
  KUBFU = "KUBFU",
  KYOGRE = "KYOGRE",
  KYUREM = "KYUREM",
  LAIRON = "LAIRON",
  LAMPENT = "LAMPENT",
  LANDORUS = "LANDORUS",
  LANTURN = "LANTURN",
  LAPRAS = "LAPRAS",
  LARVESTA = "LARVESTA",
  LARVITAR = "LARVITAR",
  LATIAS = "LATIAS",
  LATIOS = "LATIOS",
  LEAFEON = "LEAFEON",
  LEAVANNY = "LEAVANNY",
  LECHONK = "LECHONK",
  LEDYBA = "LEDYBA",
  LEDIAN = "LEDIAN",
  LICKILICKY = "LICKILICKY",
  LICKITUNG = "LICKITUNG",
  LIEPARD = "LIEPARD",
  LILEEP = "LILEEP",
  LILIGANT = "LILIGANT",
  LILLIPUP = "LILLIPUP",
  LINOONE = "LINOONE",
  LITTEN = "LITTEN",
  LITWICK = "LITWICK",
  LOKIX = "LOKIX",
  LOMBRE = "LOMBRE",
  LOPUNNY = "LOPUNNY",
  LOTAD = "LOTAD",
  LOUDRED = "LOUDRED",
  LUCARIO = "LUCARIO",
  LUDICOLO = "LUDICOLO",
  LUGIA = "LUGIA",
  LUMINEON = "LUMINEON",
  LUNALA = "LUNALA",
  LUNATONE = "LUNATONE",
  LURANTIS = "LURANTIS",
  LUVDISC = "LUVDISC",
  LUXIO = "LUXIO",
  LUXRAY = "LUXRAY",
  LYCANROC_DAY = "LYCANROC_DAY",
  LYCANROC_DUSK = "LYCANROC_DUSK",
  LYCANROC_NIGHT = "LYCANROC_NIGHT",
  MACHAMP = "MACHAMP",
  MACHOKE = "MACHOKE",
  MACHOP = "MACHOP",
  MAGBY = "MAGBY",
  MAGCARGO = "MAGCARGO",
  MAGEARNA = "MAGEARNA",
  MAGIKARP = "MAGIKARP",
  MAGMAR = "MAGMAR",
  MAGMORTAR = "MAGMORTAR",
  MAGNEMITE = "MAGNEMITE",
  MAGNETON = "MAGNETON",
  MAGNEZONE = "MAGNEZONE",
  MAKUHITA = "MAKUHITA",
  MALAMAR = "MALAMAR",
  MAMOSWINE = "MAMOSWINE",
  MANAPHY = "MANAPHY",
  MANDIBUZZ = "MANDIBUZZ",
  MANECTRIC = "MANECTRIC",
  MANKEY = "MANKEY",
  MANTINE = "MANTINE",
  MANTYKE = "MANTYKE",
  MARACTUS = "MARACTUS",
  MAREANIE = "MAREANIE",
  MAREEP = "MAREEP",
  MARILL = "MARILL",
  MAROWAK = "MAROWAK",
  MARSHADOW = "MARSHADOW",
  MARSHTOMP = "MARSHTOMP",
  MASQUERAIN = "MASQUERAIN",
  MAUSHOLD_FOUR = "MAUSHOLD_FOUR",
  MAUSHOLD_THREE = "MAUSHOLD_THREE",
  MAWILE = "MAWILE",
  MEDICHAM = "MEDICHAM",
  MEDITITE = "MEDITITE",
  //MEGA_ABOMASNOW = "MEGA_ABOMASNOW",
  //MEGA_ALTARIA = "MEGA_ALTARIA",
  //MEGA_BANETTE = "MEGA_BANETTE",
  //MEGA_CAMERUPT = "MEGA_CAMERUPT",
  //MEGA_HOUNDOOM = "MEGA_HOUNDOOM",
  //MEGA_LOPUNNY = "MEGA_LOPUNNY",
  //MEGA_MANECTRIC = "MEGA_MANECTRIC",
  MEGA_RAYQUAZA = "MEGA_RAYQUAZA",
  MEGA_SABLEYE = "MEGA_SABLEYE",
  //MEGA_STEELIX = "MEGA_STEELIX",
  MEGANIUM = "MEGANIUM",
  MELMETAL = "MELMETAL",
  MELOETTA = "MELOETTA",
  MELTAN = "MELTAN",
  MEOWSCARADA = "MEOWSCARADA",
  MEOWSTIC_FEMALE = "MEOWSTIC_FEMALE",
  MEOWSTIC_MALE = "MEOWSTIC_MALE",
  MEOWTH = "MEOWTH",
  MESPRIT = "MESPRIT",
  METAGROSS = "METAGROSS",
  METANG = "METANG",
  METAPOD = "METAPOD",
  MEW = "MEW",
  MEWTWO = "MEWTWO",
  MIENFOO = "MIENFOO",
  MIENSHAO = "MIENSHAO",
  MIGHTYENA = "MIGHTYENA",
  MILCERY = "MILCERY",
  MILOTIC = "MILOTIC",
  MILTANK = "MILTANK",
  MIME_JR = "MIME_JR",
  MIMIKYU = "MIMIKYU",
  MIMIKYU_BUSTED = "MIMIKYU_BUSTED",
  MINCCINO = "MINCCINO",
  MINIOR = "MINIOR",
  MINIOR_KERNEL_BLUE = "MINIOR_KERNEL_BLUE",
  MINIOR_KERNEL_GREEN = "MINIOR_KERNEL_GREEN",
  MINIOR_KERNEL_ORANGE = "MINIOR_KERNEL_ORANGE",
  MINIOR_KERNEL_RED = "MINIOR_KERNEL_RED",
  MINUN = "MINUN",
  MISDREAVUS = "MISDREAVUS",
  MISMAGIUS = "MISMAGIUS",
  MOLTRES = "MOLTRES",
  MONFERNO = "MONFERNO",
  MORGREM = "MORGREM",
  MORPEKO = "MORPEKO",
  MORPEKO_HANGRY = "MORPEKO_HANGRY",
  MOTHIM = "MOTHIM",
  MR_MIME = "MR_MIME",
  MUDBRAY = "MUDBRAY",
  MUDKIP = "MUDKIP",
  MUDSDALE = "MUDSDALE",
  MUK = "MUK",
  MUNCHLAX = "MUNCHLAX",
  MUNKIDORI = "MUNKIDORI",
  MUNNA = "MUNNA",
  MURKROW = "MURKROW",
  MUSHARNA = "MUSHARNA",
  NACLI = "NACLI",
  NACLSTACK = "NACLSTACK",
  NAGANADEL = "NAGANADEL",
  NATU = "NATU",
  NECROZMA = "NECROZMA",
  NICKIT = "NICKIT",
  NIDOKING = "NIDOKING",
  NIDOQUEEN = "NIDOQUEEN",
  NIDORANF = "NIDORANF",
  NIDORANM = "NIDORANM",
  NIDORINA = "NIDORINA",
  NIDORINO = "NIDORINO",
  NIHILEGO = "NIHILEGO",
  NINCADA = "NINCADA",
  NINETALES = "NINETALES",
  NINJASK = "NINJASK",
  NOCTOWL = "NOCTOWL",
  NOIBAT = "NOIBAT",
  NOIVERN = "NOIVERN",
  NOSEPASS = "NOSEPASS",
  NUMEL = "NUMEL",
  NUZLEAF = "NUZLEAF",
  NYMBLE = "NYMBLE",
  OBSTAGOON = "OBSTAGOON",
  OCTILLERY = "OCTILLERY",
  ODDISH = "ODDISH",
  OGERPON_CORNERSTONE = "OGERPON_CORNERSTONE",
  OGERPON_CORNERSTONE_MASK = "OGERPON_CORNERSTONE_MASK",
  OGERPON_HEARTHFLAME = "OGERPON_HEARTHFLAME",
  OGERPON_HEARTHFLAME_MASK = "OGERPON_HEARTHFLAME_MASK",
  OGERPON_TEAL = "OGERPON_TEAL",
  OGERPON_TEAL_MASK = "OGERPON_TEAL_MASK",
  OGERPON_WELLSPRING = "OGERPON_WELLSPRING",
  OGERPON_WELLSPRING_MASK = "OGERPON_WELLSPRING_MASK",
  OINKOLOGNE_MALE = "OINKOLOGNE_MALE",
  //OINKOLOGNE_FEMALE = "OINKOLOGNE_FEMALE",
  OKIDOGI = "OKIDOGI",
  OMANYTE = "OMANYTE",
  OMASTAR = "OMASTAR",
  ONIX = "ONIX",
  ORBEETLE = "ORBEETLE",
  ORIGIN_GIRATINA = "ORIGIN_GIRATINA",
  ORTHWORM = "ORTHWORM",
  OSHAWOTT = "OSHAWOTT",
  OVERQWIL = "OVERQWIL",
  PACHIRISU = "PACHIRISU",
  PALAFIN = "PALAFIN",
  PALAFIN_HERO = "PALAFIN_HERO",
  PALDEA_WOOPER = "PALDEA_WOOPER",
  PALKIA = "PALKIA",
  PALOSSAND = "PALOSSAND",
  PALPITOAD = "PALPITOAD",
  PANCHAM = "PANCHAM",
  PANGORO = "PANGORO",
  PARAS = "PARAS",
  PARASECT = "PARASECT",
  PATRAT = "PATRAT",
  PAWMI = "PAWMI",
  PAWMO = "PAWMO",
  PAWMOT = "PAWMOT",
  PAWNIARD = "PAWNIARD",
  PECHARUNT = "PECHARUNT",
  PELIPPER = "PELIPPER",
  PERSIAN = "PERSIAN",
  PETILIL = "PETILIL",
  PHANPY = "PHANPY",
  PHANTUMP = "PHANTUMP",
  PHEROMOSA = "PHEROMOSA",
  PHIONE = "PHIONE",
  PICHU = "PICHU",
  PIDGEOT = "PIDGEOT",
  PIDGEOTTO = "PIDGEOTTO",
  PIDGEY = "PIDGEY",
  PIDOVE = "PIDOVE",
  PIGNITE = "PIGNITE",
  PIKACHU = "PIKACHU",
  PIKACHU_SURFER = "PIKACHU_SURFER",
  //PIKIPEK = "PIKIPEK",
  PILLAR_WOOD = "PILLAR_WOOD",
  PILLAR_IRON = "PILLAR_IRON",
  PILLAR_CONCRETE = "PILLAR_CONCRETE",
  PILOSWINE = "PILOSWINE",
  PINCURCHIN = "PINCURCHIN",
  PINECO = "PINECO",
  PINSIR = "PINSIR",
  PIPLUP = "PIPLUP",
  PIROUETTE_MELOETTA = "PIROUETTE_MELOETTA",
  PLUSLE = "PLUSLE",
  POIPOLE = "POIPOLE",
  POLITOED = "POLITOED",
  POLIWAG = "POLIWAG",
  POLIWHIRL = "POLIWHIRL",
  POLIWRATH = "POLIWRATH",
  POLTEAGEIST = "POLTEAGEIST",
  PONYTA = "PONYTA",
  POOCHYENA = "POOCHYENA",
  POPPLIO = "POPPLIO",
  PORYGON = "PORYGON",
  PORYGON_2 = "PORYGON_2",
  PORYGON_Z = "PORYGON_Z",
  PRIMAL_GROUDON = "PRIMAL_GROUDON",
  PRIMAL_KYOGRE = "PRIMAL_KYOGRE",
  PRIMARINA = "PRIMARINA",
  PRIMEAPE = "PRIMEAPE",
  PRINPLUP = "PRINPLUP",
  PROBOPASS = "PROBOPASS",
  PSYDUCK = "PSYDUCK",
  PUMPKABOO = "PUMPKABOO",
  PUPITAR = "PUPITAR",
  PURRLOIN = "PURRLOIN",
  PURUGLY = "PURUGLY",
  PYUKUMUKU = "PYUKUMUKU",
  QUAGSIRE = "QUAGSIRE",
  QUILAVA = "QUILAVA",
  QUILLADIN = "QUILLADIN",
  QWILFISH = "QWILFISH",
  RABOOT = "RABOOT",
  RAICHU = "RAICHU",
  RAIKOU = "RAIKOU",
  RALTS = "RALTS",
  RAMPARDOS = "RAMPARDOS",
  RAPIDASH = "RAPIDASH",
  RATICATE = "RATICATE",
  RATTATA = "RATTATA",
  RAYQUAZA = "RAYQUAZA",
  REGICE = "REGICE",
  REGIDRAGO = "REGIDRAGO",
  REGIELEKI = "REGIELEKI",
  REGIGIGAS = "REGIGIGAS",
  REGIROCK = "REGIROCK",
  REGISTEEL = "REGISTEEL",
  RELICANTH = "RELICANTH",
  REMORAID = "REMORAID",
  RESHIRAM = "RESHIRAM",
  REUNICLUS = "REUNICLUS",
  REVAVROOM = "REVAVROOM",
  RHYDON = "RHYDON",
  RHYHORN = "RHYHORN",
  RHYPERIOR = "RHYPERIOR",
  RIBOMBEE = "RIBOMBEE",
  RILLABOOM = "RILLABOOM",
  RIOLU = "RIOLU",
  ROARING_MOON = "ROARING_MOON",
  ROCKRUFF = "ROCKRUFF",
  ROGGENROLA = "ROGGENROLA",
  ROOKIDEE = "ROOKIDEE",
  ROSELIA = "ROSELIA",
  ROSERADE = "ROSERADE",
  ROTOM = "ROTOM",
  ROTOM_HEAT = "ROTOM_HEAT",
  ROTOM_WASH = "ROTOM_WASH",
  ROTOM_FROST = "ROTOM_FROST",
  ROTOM_FAN = "ROTOM_FAN",
  ROTOM_MOW = "ROTOM_MOW",
  ROTOM_DRONE = "ROTOM_DRONE",
  ROWLET = "ROWLET",
  RUFFLET = "RUFFLET",
  RUNERIGUS = "RUNERIGUS",
  SABLEYE = "SABLEYE",
  SALAMENCE = "SALAMENCE",
  SALANDIT = "SALANDIT",
  SALAZZLE = "SALAZZLE",
  STUFFUL = "STUFFUL",
  BEWEAR = "BEWEAR",
  SAMUROTT = "SAMUROTT",
  SANDACONDA = "SANDACONDA",
  SANDILE = "SANDILE",
  SANDSHREW = "SANDSHREW",
  SANDSLASH = "SANDSLASH",
  SANDYGAST = "SANDYGAST",
  SAWSBUCK_SPRING = "SAWSBUCK_SPRING",
  SAWSBUCK_SUMMER = "SAWSBUCK_SUMMER",
  SAWSBUCK_AUTUMN = "SAWSBUCK_AUTUMN",
  SAWSBUCK_WINTER = "SAWSBUCK_WINTER",
  SCATTERBUG = "SCATTERBUG",
  SCEPTILE = "SCEPTILE",
  SCIZOR = "SCIZOR",
  SCOLIPEDE = "SCOLIPEDE",
  SCORBUNNY = "SCORBUNNY",
  SCOVILLAIN = "SCOVILLAIN",
  SCRAFTY = "SCRAFTY",
  SCRAGGY = "SCRAGGY",
  SCREAM_TAIL = "SCREAM_TAIL",
  SCYTHER = "SCYTHER",
  SEADRA = "SEADRA",
  SEAKING = "SEAKING",
  SEALEO = "SEALEO",
  SEEDOT = "SEEDOT",
  SEEL = "SEEL",
  SEISMITOAD = "SEISMITOAD",
  SENTRET = "SENTRET",
  SERPERIOR = "SERPERIOR",
  SERVINE = "SERVINE",
  SEVIPER = "SEVIPER",
  SEWADDLE = "SEWADDLE",
  SHADOW_LUGIA = "SHADOW_LUGIA",
  SHADOW_MEWTWO = "SHADOW_MEWTWO",
  SHARPEDO = "SHARPEDO",
  SHAYMIN = "SHAYMIN",
  SHAYMIN_SKY = "SHAYMIN_SKY",
  SHEDINJA = "SHEDINJA",
  SHELGON = "SHELGON",
  SHELLDER = "SHELLDER",
  SHELLOS_EAST_SEA = "SHELLOS_EAST_SEA",
  SHELLOS_WEST_SEA = "SHELLOS_WEST_SEA",
  SHIELDON = "SHIELDON",
  SHIFTRY = "SHIFTRY",
  SHINX = "SHINX",
  SHROOMISH = "SHROOMISH",
  SHUCKLE = "SHUCKLE",
  SHUPPET = "SHUPPET",
  SIGILYPH = "SIGILYPH",
  SILCOON = "SILCOON",
  SILICOBRA = "SILICOBRA",
  SILVALLY = "SILVALLY",
  SILVALLY_FIGHTING = "SILVALLY_FIGHTING",
  SILVALLY_FLYING = "SILVALLY_FLYING",
  SILVALLY_POISON = "SILVALLY_POISON",
  SILVALLY_GROUND = "SILVALLY_GROUND",
  SILVALLY_ROCK = "SILVALLY_ROCK",
  SILVALLY_BUG = "SILVALLY_BUG",
  SILVALLY_GHOST = "SILVALLY_GHOST",
  SILVALLY_STEEL = "SILVALLY_STEEL",
  SILVALLY_FIRE = "SILVALLY_FIRE",
  SILVALLY_WATER = "SILVALLY_WATER",
  SILVALLY_GRASS = "SILVALLY_GRASS",
  SILVALLY_ELECTRIC = "SILVALLY_ELECTRIC",
  SILVALLY_PSYCHIC = "SILVALLY_PSYCHIC",
  SILVALLY_ICE = "SILVALLY_ICE",
  SILVALLY_DRAGON = "SILVALLY_DRAGON",
  SILVALLY_DARK = "SILVALLY_DARK",
  SILVALLY_FAIRY = "SILVALLY_FAIRY",
  SINISTEA = "SINISTEA",
  SIZZLIPEDE = "SIZZLIPEDE",
  SKARMORY = "SKARMORY",
  SKELEDIRGE = "SKELEDIRGE",
  SKIDDO = "SKIDDO",
  SKIPLOOM = "SKIPLOOM",
  SKITTY = "SKITTY",
  SKORUPI = "SKORUPI",
  SKRELP = "SKRELP",
  SKUNTANK = "SKUNTANK",
  SLAKING = "SLAKING",
  SLAKOTH = "SLAKOTH",
  SLIGOO = "SLIGOO",
  SLOWBRO = "SLOWBRO",
  SLOWKING = "SLOWKING",
  SLOWPOKE = "SLOWPOKE",
  SLUGMA = "SLUGMA",
  SLURPUFF = "SLURPUFF",
  SMEARGLE = "SMEARGLE",
  SMOLIV = "SMOLIV",
  SMOOCHUM = "SMOOCHUM",
  SNEASEL = "SNEASEL",
  SNEASLER = "SNEASLER",
  SNIVY = "SNIVY",
  SNOM = "SNOM",
  SNORLAX = "SNORLAX",
  SNORUNT = "SNORUNT",
  SNOVER = "SNOVER",
  SNUBULL = "SNUBULL",
  SOBBLE = "SOBBLE",
  SOLGALEO = "SOLGALEO",
  SOLOSIS = "SOLOSIS",
  SOLROCK = "SOLROCK",
  SPEAROW = "SPEAROW",
  SPECTRIER = "SPECTRIER",
  SPEWPA = "SPEWPA",
  SPHEAL = "SPHEAL",
  SPINARAK = "SPINARAK",
  SPINDA = "SPINDA",
  SPIRITOMB = "SPIRITOMB",
  SPOINK = "SPOINK",
  SPRIGATITO = "SPRIGATITO",
  SQUIRTLE = "SQUIRTLE",
  STAKATAKA = "STAKATAKA",
  STANTLER = "STANTLER",
  STARAPTOR = "STARAPTOR",
  STARAVIA = "STARAVIA",
  STARLY = "STARLY",
  STARMIE = "STARMIE",
  STARYU = "STARYU",
  STEELIX = "STEELIX",
  STEENEE = "STEENEE",
  STONJOURNER = "STONJOURNER",
  STOUTLAND = "STOUTLAND",
  STUNKY = "STUNKY",
  SUBSTITUTE = "SUBSTITUTE",
  SUDOWOODO = "SUDOWOODO",
  SUICUNE = "SUICUNE",
  SUNFLORA = "SUNFLORA",
  SUNKERN = "SUNKERN",
  SURSKIT = "SURSKIT",
  SWABLU = "SWABLU",
  SWADLOON = "SWADLOON",
  SWALOT = "SWALOT",
  SWAMPERT = "SWAMPERT",
  SWANNA = "SWANNA",
  SWELLOW = "SWELLOW",
  SWINUB = "SWINUB",
  SWIRLIX = "SWIRLIX",
  SWOOBAT = "SWOOBAT",
  SYLVEON = "SYLVEON",
  TADBULB = "TADBULB",
  TAILLOW = "TAILLOW",
  TALONFLAME = "TALONFLAME",
  TANDEMAUS = "TANDEMAUS",
  TANGELA = "TANGELA",
  TANGROWTH = "TANGROWTH",
  TAPU_BULU = "TAPU_BULU",
  TAPU_FINI = "TAPU_FINI",
  TAPU_KOKO = "TAPU_KOKO",
  TAPU_LELE = "TAPU_LELE",
  TATSUGIRI_CURLY = "TATSUGIRI_CURLY",
  TATSUGIRI_DROOPY = "TATSUGIRI_DROOPY",
  TATSUGIRI_STRETCHY = "TATSUGIRI_STRETCHY",
  TAUROS = "TAUROS",
  TAUROS_COMBAT_BREED = "TAUROS_COMBAT_BREED",
  TAUROS_BLAZE_BREED = "TAUROS_BLAZE_BREED",
  TAUROS_AQUA_BREED = "TAUROS_AQUA_BREED",
  TEDDIURSA = "TEDDIURSA",
  TENTACOOL = "TENTACOOL",
  TENTACRUEL = "TENTACRUEL",
  TEPIG = "TEPIG",
  TERRAKION = "TERRAKION",
  THIEVUL = "THIEVUL",
  THUNDURUS = "THUNDURUS",
  THWACKEY = "THWACKEY",
  TIMBURR = "TIMBURR",
  TINKATINK = "TINKATINK",
  TINKATON = "TINKATON",
  TINKATUFF = "TINKATUFF",
  //TIRTOUGA = "TIRTOUGA",
  TOGEDEMARU = "TOGEDEMARU",
  TOGEKISS = "TOGEKISS",
  TOGEPI = "TOGEPI",
  TOGETIC = "TOGETIC",
  TORCHIC = "TORCHIC",
  TORKOAL = "TORKOAL",
  TORNADUS = "TORNADUS",
  TORRACAT = "TORRACAT",
  TORTERRA = "TORTERRA",
  TOTODILE = "TOTODILE",
  //TOUCANNON = "TOUCANNON",
  TOXAPEX = "TOXAPEX",
  TOXEL = "TOXEL",
  TOXICROAK = "TOXICROAK",
  TOXTRICITY = "TOXTRICITY",
  TRANQUILL = "TRANQUILL",
  TRAPINCH = "TRAPINCH",
  TREECKO = "TREECKO",
  TREVENANT = "TREVENANT",
  TROPIUS = "TROPIUS",
  TRUBBISH = "TRUBBISH",
  //TRUMBEAK = "TRUMBEAK",
  TSAREENA = "TSAREENA",
  TURTONATOR = "TURTONATOR",
  TURTWIG = "TURTWIG",
  TYMPOLE = "TYMPOLE",
  TYNAMO = "TYNAMO",
  TYPE_NULL = "TYPE_NULL",
  TYPHLOSION = "TYPHLOSION",
  TYRANITAR = "TYRANITAR",
  TYRANTRUM = "TYRANTRUM",
  TYROGUE = "TYROGUE",
  TYRUNT = "TYRUNT",
  ULTRA_NECROZMA = "ULTRA_NECROZMA",
  UMBREON = "UMBREON",
  UNFEZANT = "UNFEZANT",
  UNOWN_A = "UNOWN_A",
  UNOWN_B = "UNOWN_B",
  UNOWN_C = "UNOWN_C",
  UNOWN_D = "UNOWN_D",
  UNOWN_E = "UNOWN_E",
  UNOWN_EXCLAMATION = "UNOWN_EXCLAMATION",
  UNOWN_F = "UNOWN_F",
  UNOWN_G = "UNOWN_G",
  UNOWN_H = "UNOWN_H",
  UNOWN_I = "UNOWN_I",
  UNOWN_J = "UNOWN_J",
  UNOWN_K = "UNOWN_K",
  UNOWN_L = "UNOWN_L",
  UNOWN_M = "UNOWN_M",
  UNOWN_N = "UNOWN_N",
  UNOWN_O = "UNOWN_O",
  UNOWN_P = "UNOWN_P",
  UNOWN_Q = "UNOWN_Q",
  UNOWN_QUESTION = "UNOWN_QUESTION",
  UNOWN_R = "UNOWN_R",
  UNOWN_S = "UNOWN_S",
  UNOWN_T = "UNOWN_T",
  UNOWN_U = "UNOWN_U",
  UNOWN_V = "UNOWN_V",
  UNOWN_W = "UNOWN_W",
  UNOWN_X = "UNOWN_X",
  UNOWN_Y = "UNOWN_Y",
  UNOWN_Z = "UNOWN_Z",
  URSALUNA = "URSALUNA",
  URSALUNA_BLOODMOON = "URSALUNA_BLOODMOON",
  URSARING = "URSARING",
  URSHIFU_RAPID = "URSHIFU_RAPID",
  URSHIFU_SINGLE = "URSHIFU_SINGLE",
  UXIE = "UXIE",
  VANILLISH = "VANILLISH",
  VANILLITE = "VANILLITE",
  VANILLUXE = "VANILLUXE",
  VAPOREON = "VAPOREON",
  VAROOM = "VAROOM",
  VELUZA = "VELUZA",
  VENIPEDE = "VENIPEDE",
  VENOMOTH = "VENOMOTH",
  VENONAT = "VENONAT",
  VENUSAUR = "VENUSAUR",
  VESPIQUEEN = "VESPIQUEEN",
  VIBRAVA = "VIBRAVA",
  VICTINI = "VICTINI",
  VICTREEBEL = "VICTREEBEL",
  VIGOROTH = "VIGOROTH",
  VIKAVOLT = "VIKAVOLT",
  VILEPLUME = "VILEPLUME",
  VIRIZION = "VIRIZION",
  VIVILLON = "VIVILLON",
  VIVILLON_ICY_SNOW = "VIVILLON_ICY_SNOW",
  VIVILLON_POLAR = "VIVILLON_POLAR",
  VIVILLON_TUNDRA = "VIVILLON_TUNDRA",
  VIVILLON_CONTINENTAL = "VIVILLON_CONTINENTAL",
  VIVILLON_GARDEN = "VIVILLON_GARDEN",
  VIVILLON_ELEGANT = "VIVILLON_ELEGANT",
  VIVILLON_MODERN = "VIVILLON_MODERN",
  VIVILLON_MARINE = "VIVILLON_MARINE",
  VIVILLON_ARCHIPELAGO = "VIVILLON_ARCHIPELAGO",
  VIVILLON_HIGH_PLAINS = "VIVILLON_HIGH_PLAINS",
  VIVILLON_SANDSTORM = "VIVILLON_SANDSTORM",
  VIVILLON_RIVER = "VIVILLON_RIVER",
  VIVILLON_MONSOON = "VIVILLON_MONSOON",
  VIVILLON_SAVANNA = "VIVILLON_SAVANNA",
  VIVILLON_SUN = "VIVILLON_SUN",
  VIVILLON_OCEAN = "VIVILLON_OCEAN",
  VIVILLON_JUNGLE = "VIVILLON_JUNGLE",
  VIVILLON_FANCY = "VIVILLON_FANCY",
  VIVILLON_POKE_BALL = "VIVILLON_POKE_BALL",
  VOLBEAT = "VOLBEAT",
  VOLCANION = "VOLCANION",
  VOLCARONA = "VOLCARONA",
  VOLTORB = "VOLTORB",
  VULLABY = "VULLABY",
  VULPIX = "VULPIX",
  WAILMER = "WAILMER",
  WAILORD = "WAILORD",
  WALKING_WAKE = "WALKING_WAKE",
  WALREIN = "WALREIN",
  WARTORTLE = "WARTORTLE",
  WATCHOG = "WATCHOG",
  WATTREL = "WATTREL",
  WEAVILE = "WEAVILE",
  WEEDLE = "WEEDLE",
  WEEPINBELL = "WEEPINBELL",
  WEEZING = "WEEZING",
  WHIMSICOTT = "WHIMSICOTT",
  WHIRLIPEDE = "WHIRLIPEDE",
  WHISCASH = "WHISCASH",
  WHISMUR = "WHISMUR",
  WIGGLYTUFF = "WIGGLYTUFF",
  WIGLETT = "WIGLETT",
  WUGTRIO = "WUGTRIO",
  WIMPOD = "WIMPOD",
  WINGULL = "WINGULL",
  WISHIWASHI = "WISHIWASHI",
  WISHIWASHI_SCHOOL = "WISHIWASHI_SCHOOL",
  WOBBUFFET = "WOBBUFFET",
  WOOBAT = "WOOBAT",
  WOOLOO = "WOOLOO",
  WOOPER = "WOOPER",
  WORMADAM_PLANT = "WORMADAM_PLANT",
  WORMADAM_SANDY = "WORMADAM_SANDY",
  WORMADAM_TRASH = "WORMADAM_TRASH",
  WURMPLE = "WURMPLE",
  WYNAUT = "WYNAUT",
  WYRDEER = "WYRDEER",
  XATU = "XATU",
  XERNEAS = "XERNEAS",
  XURKITREE = "XURKITREE",
  YAMASK = "YAMASK",
  YAMPER = "YAMPER",
  YANMA = "YANMA",
  YANMEGA = "YANMEGA",
  YVELTAL = "YVELTAL",
  ZACIAN = "ZACIAN",
  ZACIAN_CROWNED = "ZACIAN_CROWNED",
  ZANGOOSE = "ZANGOOSE",
  ZAPDOS = "ZAPDOS",
  ZEKROM = "ZEKROM",
  ZERAORA = "ZERAORA",
  ZIGZAGOON = "ZIGZAGOON",
  ZOROARK = "ZOROARK",
  ZORUA = "ZORUA",
  ZUBAT = "ZUBAT",
  ZWEILOUS = "ZWEILOUS",
  ZYGARDE_10 = "ZYGARDE_10",
  ZYGARDE_50 = "ZYGARDE_50",
  ZYGARDE_100 = "ZYGARDE_100"
}

export const PkmIndex: { [key in Pkm]: string } = {
  [Pkm.DEFAULT]: "0000",
  [Pkm.EGG]: "0000-0004",
  [Pkm.SUBSTITUTE]: "0000-0001",

  // Gen 1
  [Pkm.BULBASAUR]: "0001",
  [Pkm.IVYSAUR]: "0002",
  [Pkm.VENUSAUR]: "0003",
  [Pkm.CHARMANDER]: "0004",
  [Pkm.CHARMELEON]: "0005",
  [Pkm.CHARIZARD]: "0006",
  [Pkm.SQUIRTLE]: "0007",
  [Pkm.WARTORTLE]: "0008",
  [Pkm.BLASTOISE]: "0009",
  [Pkm.CATERPIE]: "0010",
  [Pkm.METAPOD]: "0011",
  [Pkm.BUTTERFREE]: "0012",
  [Pkm.WEEDLE]: "0013",
  [Pkm.KAKUNA]: "0014",
  [Pkm.BEEDRILL]: "0015",
  [Pkm.PIDGEY]: "0016",
  [Pkm.PIDGEOTTO]: "0017",
  [Pkm.PIDGEOT]: "0018",
  [Pkm.RATTATA]: "0019",
  [Pkm.ALOLAN_RATTATA]: "0019-0001",
  [Pkm.RATICATE]: "0020",
  [Pkm.ALOLAN_RATICATE]: "0020-0001",
  [Pkm.SPEAROW]: "0021",
  [Pkm.FEAROW]: "0022",
  [Pkm.EKANS]: "0023",
  [Pkm.ARBOK]: "0024",
  [Pkm.PIKACHU]: "0025",
  [Pkm.PIKACHU_SURFER]: "0025-9999",
  [Pkm.RAICHU]: "0026",
  [Pkm.ALOLAN_RAICHU]: "0026-0001",
  [Pkm.SANDSHREW]: "0027",
  [Pkm.ALOLAN_SANDSHREW]: "0027-0001",
  [Pkm.SANDSLASH]: "0028",
  [Pkm.ALOLAN_SANDSLASH]: "0028-0001",
  [Pkm.NIDORANF]: "0029",
  [Pkm.NIDORINA]: "0030",
  [Pkm.NIDOQUEEN]: "0031",
  [Pkm.NIDORANM]: "0032",
  [Pkm.NIDORINO]: "0033",
  [Pkm.NIDOKING]: "0034",
  [Pkm.CLEFAIRY]: "0035",
  [Pkm.CLEFABLE]: "0036",
  [Pkm.VULPIX]: "0037",
  [Pkm.NINETALES]: "0038",
  [Pkm.ALOLAN_VULPIX]: "0037-0001",
  [Pkm.ALOLAN_NINETALES]: "0038-0001",
  [Pkm.JIGGLYPUFF]: "0039",
  [Pkm.WIGGLYTUFF]: "0040",
  [Pkm.ZUBAT]: "0041",
  [Pkm.GOLBAT]: "0042",
  [Pkm.ODDISH]: "0043",
  [Pkm.GLOOM]: "0044",
  [Pkm.VILEPLUME]: "0045",
  [Pkm.PARAS]: "0046",
  [Pkm.PARASECT]: "0047",
  [Pkm.VENONAT]: "0048",
  [Pkm.VENOMOTH]: "0049",
  [Pkm.DIGLETT]: "0050",
  [Pkm.ALOLAN_DIGLETT]: "0050-0001",
  [Pkm.DUGTRIO]: "0051",
  [Pkm.ALOLAN_DUGTRIO]: "0051-0001",
  [Pkm.MEOWTH]: "0052",
  [Pkm.PERSIAN]: "0053",
  [Pkm.ALOLAN_MEOWTH]: "0052-0001",
  [Pkm.ALOLAN_PERSIAN]: "0053-0001",
  [Pkm.PSYDUCK]: "0054",
  [Pkm.GOLDUCK]: "0055",
  [Pkm.MANKEY]: "0056",
  [Pkm.PRIMEAPE]: "0057",
  [Pkm.GROWLITHE]: "0058",
  [Pkm.ARCANINE]: "0059",
  [Pkm.HISUI_GROWLITHE]: "0058-0001",
  [Pkm.HISUI_ARCANINE]: "0059-0001",
  [Pkm.POLIWAG]: "0060",
  [Pkm.POLIWHIRL]: "0061",
  [Pkm.POLIWRATH]: "0062",
  [Pkm.ABRA]: "0063",
  [Pkm.KADABRA]: "0064",
  [Pkm.ALAKAZAM]: "0065",
  [Pkm.MACHOP]: "0066",
  [Pkm.MACHOKE]: "0067",
  [Pkm.MACHAMP]: "0068",
  [Pkm.BELLSPROUT]: "0069",
  [Pkm.WEEPINBELL]: "0070",
  [Pkm.VICTREEBEL]: "0071",
  [Pkm.TENTACOOL]: "0072",
  [Pkm.TENTACRUEL]: "0073",
  [Pkm.GEODUDE]: "0074",
  [Pkm.GRAVELER]: "0075",
  [Pkm.GOLEM]: "0076",
  [Pkm.ALOLAN_GEODUDE]: "0074-0001",
  [Pkm.ALOLAN_GRAVELER]: "0075-0001",
  [Pkm.ALOLAN_GOLEM]: "0076-0001",
  [Pkm.PONYTA]: "0077",
  [Pkm.RAPIDASH]: "0078",
  [Pkm.GALARIAN_PONYTA]: "0077-0001",
  [Pkm.GALARIAN_RAPIDASH]: "0078-0001",
  [Pkm.SLOWPOKE]: "0079",
  [Pkm.GALARIAN_SLOWPOKE]: "0079-0001",
  [Pkm.SLOWBRO]: "0080",
  [Pkm.GALARIAN_SLOWBRO]: "0080-0001",
  [Pkm.MAGNEMITE]: "0081",
  [Pkm.MAGNETON]: "0082",
  [Pkm.FARFETCH_D]: "0083",
  [Pkm.GALARIAN_FARFETCH_D]: "0083-0001",
  [Pkm.DODUO]: "0084",
  [Pkm.DODRIO]: "0085",
  [Pkm.SEEL]: "0086",
  [Pkm.DEWGONG]: "0087",
  [Pkm.GRIMER]: "0088",
  [Pkm.MUK]: "0089",
  [Pkm.ALOLAN_GRIMER]: "0088-0001",
  [Pkm.ALOLAN_MUK]: "0089-0001",
  [Pkm.SHELLDER]: "0090",
  [Pkm.CLOYSTER]: "0091",
  [Pkm.GASTLY]: "0092",
  [Pkm.HAUNTER]: "0093",
  [Pkm.GENGAR]: "0094",
  [Pkm.ONIX]: "0095",
  [Pkm.DROWZEE]: "0096",
  [Pkm.HYPNO]: "0097",
  [Pkm.KRABBY]: "0098",
  [Pkm.KINGLER]: "0099",
  [Pkm.VOLTORB]: "0100",
  [Pkm.HISUI_VOLTORB]: "0100-0001",
  [Pkm.ELECTRODE]: "0101",
  [Pkm.HISUI_ELECTRODE]: "0101-0001",
  [Pkm.EXEGGCUTE]: "0102",
  [Pkm.EXEGGUTOR]: "0103",
  [Pkm.ALOLAN_EXEGGUTOR]: "0103-0001",
  [Pkm.CUBONE]: "0104",
  [Pkm.MAROWAK]: "0105",
  [Pkm.ALOLAN_MAROWAK]: "0105-0001",
  [Pkm.HITMONLEE]: "0106",
  [Pkm.HITMONCHAN]: "0107",
  [Pkm.LICKITUNG]: "0108",
  [Pkm.KOFFING]: "0109",
  [Pkm.WEEZING]: "0110",
  [Pkm.GALARIAN_WEEZING]: "0110-0001",
  [Pkm.RHYHORN]: "0111",
  [Pkm.RHYDON]: "0112",
  [Pkm.CHANSEY]: "0113",
  [Pkm.TANGELA]: "0114",
  [Pkm.KANGASKHAN]: "0115",
  [Pkm.HORSEA]: "0116",
  [Pkm.SEADRA]: "0117",
  [Pkm.GOLDEEN]: "0118",
  [Pkm.SEAKING]: "0119",
  [Pkm.STARYU]: "0120",
  [Pkm.STARMIE]: "0121",
  [Pkm.MR_MIME]: "0122",
  [Pkm.SCYTHER]: "0123",
  [Pkm.JYNX]: "0124",
  [Pkm.ELECTABUZZ]: "0125",
  [Pkm.MAGMAR]: "0126",
  [Pkm.PINSIR]: "0127",
  [Pkm.TAUROS]: "0128",
  [Pkm.TAUROS_COMBAT_BREED]: "0128-0001",
  [Pkm.TAUROS_BLAZE_BREED]: "0128-0002",
  [Pkm.TAUROS_AQUA_BREED]: "0128-0003",
  [Pkm.MAGIKARP]: "0129",
  [Pkm.GYARADOS]: "0130",
  [Pkm.LAPRAS]: "0131",
  [Pkm.DITTO]: "0132",
  [Pkm.EEVEE]: "0133",
  [Pkm.VAPOREON]: "0134",
  [Pkm.JOLTEON]: "0135",
  [Pkm.FLAREON]: "0136",
  [Pkm.PORYGON]: "0137",
  [Pkm.OMANYTE]: "0138",
  [Pkm.OMASTAR]: "0139",
  [Pkm.KABUTO]: "0140",
  [Pkm.KABUTOPS]: "0141",
  [Pkm.AERODACTYL]: "0142",
  [Pkm.SNORLAX]: "0143",
  [Pkm.ARTICUNO]: "0144",
  [Pkm.GALARIAN_ARTICUNO]: "0144-0001",
  [Pkm.ZAPDOS]: "0145",
  [Pkm.GALARIAN_ZAPDOS]: "0145-0001",
  [Pkm.MOLTRES]: "0146",
  [Pkm.GALARIAN_MOLTRES]: "0146-0001",
  [Pkm.DRATINI]: "0147",
  [Pkm.DRAGONAIR]: "0148",
  [Pkm.DRAGONITE]: "0149",
  [Pkm.MEWTWO]: "0150",
  [Pkm.SHADOW_MEWTWO]: "0150-0003",
  [Pkm.MEW]: "0151",

  // Gen 2
  [Pkm.CHIKORITA]: "0152",
  [Pkm.BAYLEEF]: "0153",
  [Pkm.MEGANIUM]: "0154",
  [Pkm.CYNDAQUIL]: "0155",
  [Pkm.QUILAVA]: "0156",
  [Pkm.TYPHLOSION]: "0157",
  [Pkm.HISUIAN_TYPHLOSION]: "0157-0001",
  [Pkm.TOTODILE]: "0158",
  [Pkm.CROCONAW]: "0159",
  [Pkm.FERALIGATR]: "0160",
  [Pkm.SENTRET]: "0161",
  [Pkm.FURRET]: "0162",
  [Pkm.HOOTHOOT]: "0163",
  [Pkm.NOCTOWL]: "0164",
  [Pkm.LEDYBA]: "0165",
  [Pkm.LEDIAN]: "0166",
  [Pkm.SPINARAK]: "0167",
  [Pkm.ARIADOS]: "0168",
  [Pkm.CROBAT]: "0169",
  [Pkm.CHINCHOU]: "0170",
  [Pkm.LANTURN]: "0171",
  [Pkm.PICHU]: "0172",
  [Pkm.CLEFFA]: "0173",
  [Pkm.IGGLYBUFF]: "0174",
  [Pkm.TOGEPI]: "0175",
  [Pkm.TOGETIC]: "0176",
  [Pkm.NATU]: "0177",
  [Pkm.XATU]: "0178",
  [Pkm.MAREEP]: "0179",
  [Pkm.FLAFFY]: "0180",
  [Pkm.AMPHAROS]: "0181",
  [Pkm.BELLOSSOM]: "0182",
  [Pkm.MARILL]: "0183",
  [Pkm.AZUMARILL]: "0184",
  [Pkm.SUDOWOODO]: "0185",
  [Pkm.POLITOED]: "0186",
  [Pkm.HOPPIP]: "0187",
  [Pkm.SKIPLOOM]: "0188",
  [Pkm.JUMPLUFF]: "0189",
  [Pkm.AIPOM]: "0190",
  [Pkm.SUNKERN]: "0191",
  [Pkm.SUNFLORA]: "0192",
  [Pkm.YANMA]: "0193",
  [Pkm.WOOPER]: "0194",
  [Pkm.PALDEA_WOOPER]: "0194-0002",
  [Pkm.QUAGSIRE]: "0195",
  [Pkm.ESPEON]: "0196",
  [Pkm.UMBREON]: "0197",
  [Pkm.MURKROW]: "0198",
  [Pkm.SLOWKING]: "0199",
  [Pkm.GALARIAN_SLOWKING]: "0199-0001",
  [Pkm.MISDREAVUS]: "0200",
  [Pkm.UNOWN_A]: "0201",
  [Pkm.UNOWN_B]: "0201-0001",
  [Pkm.UNOWN_C]: "0201-0002",
  [Pkm.UNOWN_D]: "0201-0003",
  [Pkm.UNOWN_E]: "0201-0004",
  [Pkm.UNOWN_F]: "0201-0005",
  [Pkm.UNOWN_G]: "0201-0006",
  [Pkm.UNOWN_H]: "0201-0007",
  [Pkm.UNOWN_I]: "0201-0008",
  [Pkm.UNOWN_J]: "0201-0009",
  [Pkm.UNOWN_K]: "0201-0010",
  [Pkm.UNOWN_L]: "0201-0011",
  [Pkm.UNOWN_M]: "0201-0012",
  [Pkm.UNOWN_N]: "0201-0013",
  [Pkm.UNOWN_O]: "0201-0014",
  [Pkm.UNOWN_P]: "0201-0015",
  [Pkm.UNOWN_Q]: "0201-0016",
  [Pkm.UNOWN_R]: "0201-0017",
  [Pkm.UNOWN_S]: "0201-0018",
  [Pkm.UNOWN_T]: "0201-0019",
  [Pkm.UNOWN_U]: "0201-0020",
  [Pkm.UNOWN_V]: "0201-0021",
  [Pkm.UNOWN_W]: "0201-0022",
  [Pkm.UNOWN_X]: "0201-0023",
  [Pkm.UNOWN_Y]: "0201-0024",
  [Pkm.UNOWN_Z]: "0201-0025",
  [Pkm.UNOWN_QUESTION]: "0201-0027",
  [Pkm.UNOWN_EXCLAMATION]: "0201-0026",
  [Pkm.WOBBUFFET]: "0202",
  [Pkm.GIRAFARIG]: "0203",
  [Pkm.PINECO]: "0204",
  [Pkm.FORRETRESS]: "0205",
  [Pkm.DUNSPARCE]: "0206",
  [Pkm.GLIGAR]: "0207",
  [Pkm.STEELIX]: "0208",
  //[Pkm.MEGA_STEELIX]: "0208-0001",
  [Pkm.SNUBULL]: "0209",
  [Pkm.GRANBULL]: "0210",
  [Pkm.QWILFISH]: "0211",
  [Pkm.HISUIAN_QWILFISH]: "0211-0001",
  [Pkm.SCIZOR]: "0212",
  [Pkm.SHUCKLE]: "0213",
  [Pkm.HERACROSS]: "0214",
  [Pkm.SNEASEL]: "0215",
  [Pkm.HISUI_SNEASEL]: "0215-0001",
  [Pkm.TEDDIURSA]: "0216",
  [Pkm.URSARING]: "0217",
  [Pkm.SLUGMA]: "0218",
  [Pkm.MAGCARGO]: "0219",
  [Pkm.SWINUB]: "0220",
  [Pkm.PILOSWINE]: "0221",
  [Pkm.CORSOLA]: "0222",
  [Pkm.GALAR_CORSOLA]: "0222-0001",
  [Pkm.REMORAID]: "0223",
  [Pkm.OCTILLERY]: "0224",
  [Pkm.DELIBIRD]: "0225",
  [Pkm.MANTINE]: "0226",
  [Pkm.SKARMORY]: "0227",
  [Pkm.HOUNDOUR]: "0228",
  [Pkm.HOUNDOOM]: "0229",
  //[Pkm.MEGA_HOUNDOOM]: "0229-0001",
  [Pkm.KINGDRA]: "0230",
  [Pkm.PHANPY]: "0231",
  [Pkm.DONPHAN]: "0232",
  [Pkm.PORYGON_2]: "0233",
  [Pkm.STANTLER]: "0234",
  [Pkm.SMEARGLE]: "0235",
  [Pkm.TYROGUE]: "0236",
  [Pkm.HITMONTOP]: "0237",
  [Pkm.SMOOCHUM]: "0238",
  [Pkm.ELEKID]: "0239",
  [Pkm.MAGBY]: "0240",
  [Pkm.MILTANK]: "0241",
  [Pkm.BLISSEY]: "0242",
  [Pkm.RAIKOU]: "0243",
  [Pkm.ENTEI]: "0244",
  [Pkm.SUICUNE]: "0245",
  [Pkm.LARVITAR]: "0246",
  [Pkm.PUPITAR]: "0247",
  [Pkm.TYRANITAR]: "0248",
  [Pkm.LUGIA]: "0249",
  [Pkm.SHADOW_LUGIA]: "0249-0001",
  [Pkm.HO_OH]: "0250",
  [Pkm.CELEBI]: "0251",

  // Gen 3
  [Pkm.TREECKO]: "0252",
  [Pkm.GROVYLE]: "0253",
  [Pkm.SCEPTILE]: "0254",
  [Pkm.TORCHIC]: "0255",
  [Pkm.COMBUSKEN]: "0256",
  [Pkm.BLAZIKEN]: "0257",
  [Pkm.MUDKIP]: "0258",
  [Pkm.MARSHTOMP]: "0259",
  [Pkm.SWAMPERT]: "0260",
  [Pkm.POOCHYENA]: "0261",
  [Pkm.MIGHTYENA]: "0262",
  [Pkm.ZIGZAGOON]: "0263",
  [Pkm.GALARIAN_ZIGZAGOON]: "0263-0001",
  [Pkm.LINOONE]: "0264",
  [Pkm.GALARIAN_LINOONE]: "0264-0001",
  [Pkm.WURMPLE]: "0265",
  [Pkm.SILCOON]: "0266",
  [Pkm.BEAUTIFLY]: "0267",
  [Pkm.CASCOON]: "0268",
  [Pkm.DUSTOX]: "0269",
  [Pkm.LOTAD]: "0270",
  [Pkm.LOMBRE]: "0271",
  [Pkm.LUDICOLO]: "0272",
  [Pkm.SEEDOT]: "0273",
  [Pkm.NUZLEAF]: "0274",
  [Pkm.SHIFTRY]: "0275",
  [Pkm.TAILLOW]: "0276",
  [Pkm.SWELLOW]: "0277",
  [Pkm.WINGULL]: "0278",
  [Pkm.PELIPPER]: "0279",
  [Pkm.RALTS]: "0280",
  [Pkm.KIRLIA]: "0281",
  [Pkm.GARDEVOIR]: "0282",
  [Pkm.SURSKIT]: "0283",
  [Pkm.MASQUERAIN]: "0284",
  [Pkm.SHROOMISH]: "0285",
  [Pkm.BRELOOM]: "0286",
  [Pkm.SLAKOTH]: "0287",
  [Pkm.VIGOROTH]: "0288",
  [Pkm.SLAKING]: "0289",
  [Pkm.NINCADA]: "0290",
  [Pkm.NINJASK]: "0291",
  [Pkm.SHEDINJA]: "0292",
  [Pkm.WHISMUR]: "0293",
  [Pkm.LOUDRED]: "0294",
  [Pkm.EXPLOUD]: "0295",
  [Pkm.MAKUHITA]: "0296",
  [Pkm.HARIYAMA]: "0297",
  [Pkm.AZURILL]: "0298",
  [Pkm.NOSEPASS]: "0299",
  [Pkm.SKITTY]: "0300",
  [Pkm.DELCATTY]: "0301",
  [Pkm.SABLEYE]: "0302",
  [Pkm.MEGA_SABLEYE]: "0302-0001",
  [Pkm.MAWILE]: "0303",
  [Pkm.ARON]: "0304",
  [Pkm.LAIRON]: "0305",
  [Pkm.AGGRON]: "0306",
  [Pkm.MEDITITE]: "0307",
  [Pkm.MEDICHAM]: "0308",
  [Pkm.ELECTRIKE]: "0309",
  [Pkm.MANECTRIC]: "0310",
  //[Pkm.MEGA_MANECTRIC]: "0310-0001",
  [Pkm.PLUSLE]: "0311",
  [Pkm.MINUN]: "0312",
  [Pkm.VOLBEAT]: "0313",
  [Pkm.ILLUMISE]: "0314",
  [Pkm.ROSELIA]: "0315",
  [Pkm.GULPIN]: "0316",
  [Pkm.SWALOT]: "0317",
  [Pkm.CARVANHA]: "0318",
  [Pkm.SHARPEDO]: "0319",
  [Pkm.WAILMER]: "0320",
  [Pkm.WAILORD]: "0321",
  [Pkm.NUMEL]: "0322",
  [Pkm.CAMERUPT]: "0323",
  //[Pkm.MEGA_CAMERUPT]: "0323-0001",
  [Pkm.TORKOAL]: "0324",
  [Pkm.SPOINK]: "0325",
  [Pkm.GRUMPIG]: "0326",
  [Pkm.SPINDA]: "0327",
  [Pkm.TRAPINCH]: "0328",
  [Pkm.VIBRAVA]: "0329",
  [Pkm.FLYGON]: "0330",
  [Pkm.CACNEA]: "0331",
  [Pkm.CACTURNE]: "0332",
  [Pkm.SWABLU]: "0333",
  [Pkm.ALTARIA]: "0334",
  //[Pkm.MEGA_ALTARIA]: "0334-0001",
  [Pkm.ZANGOOSE]: "0335",
  [Pkm.SEVIPER]: "0336",
  [Pkm.LUNATONE]: "0337",
  [Pkm.SOLROCK]: "0338",
  [Pkm.BARBOACH]: "0339",
  [Pkm.WHISCASH]: "0340",
  [Pkm.CORPHISH]: "0341",
  [Pkm.CRAWDAUNT]: "0342",
  [Pkm.BALTOY]: "0343",
  [Pkm.CLAYDOL]: "0344",
  [Pkm.LILEEP]: "0345",
  [Pkm.CRADILY]: "0346",
  [Pkm.ANORITH]: "0347",
  [Pkm.ARMALDO]: "0348",
  [Pkm.FEEBAS]: "0349",
  [Pkm.MILOTIC]: "0350",
  [Pkm.CASTFORM]: "0351",
  [Pkm.CASTFORM_SUN]: "0351-0001",
  [Pkm.CASTFORM_RAIN]: "0351-0002",
  [Pkm.CASTFORM_HAIL]: "0351-0003",
  [Pkm.KECLEON]: "0352",
  [Pkm.SHUPPET]: "0353",
  [Pkm.BANETTE]: "0354",
  //[Pkm.MEGA_BANETTE]: "0354-0001",
  [Pkm.DUSKULL]: "0355",
  [Pkm.DUSCLOPS]: "0356",
  [Pkm.TROPIUS]: "0357",
  [Pkm.CHIMECHO]: "0358",
  [Pkm.ABSOL]: "0359",
  [Pkm.WYNAUT]: "0360",
  [Pkm.SNORUNT]: "0361",
  [Pkm.GLALIE]: "0362",
  [Pkm.SPHEAL]: "0363",
  [Pkm.SEALEO]: "0364",
  [Pkm.WALREIN]: "0365",
  [Pkm.CLAMPERL]: "0366",
  [Pkm.HUNTAIL]: "0367",
  [Pkm.GOREBYSS]: "0368",
  [Pkm.RELICANTH]: "0369",
  [Pkm.LUVDISC]: "0370",
  [Pkm.BAGON]: "0371",
  [Pkm.SHELGON]: "0372",
  [Pkm.SALAMENCE]: "0373",
  [Pkm.BELDUM]: "0374",
  [Pkm.METANG]: "0375",
  [Pkm.METAGROSS]: "0376",
  [Pkm.REGICE]: "0378",
  [Pkm.REGIROCK]: "0377",
  [Pkm.REGISTEEL]: "0379",
  [Pkm.LATIAS]: "0380",
  [Pkm.LATIOS]: "0381",
  [Pkm.KYOGRE]: "0382",
  [Pkm.GROUDON]: "0383",
  [Pkm.RAYQUAZA]: "0384",
  [Pkm.PRIMAL_KYOGRE]: "0382-0001",
  [Pkm.PRIMAL_GROUDON]: "0383-0001",
  [Pkm.MEGA_RAYQUAZA]: "0384-0001",
  [Pkm.JIRACHI]: "0385",
  [Pkm.DEOXYS]: "0386",
  [Pkm.DEOXYS_DEFENSE]: "0386-0002",
  [Pkm.DEOXYS_ATTACK]: "0386-0001",
  [Pkm.DEOXYS_SPEED]: "0386-0003",

  // Gen 4
  [Pkm.TURTWIG]: "0387",
  [Pkm.GROTLE]: "0388",
  [Pkm.TORTERRA]: "0389",
  [Pkm.CHIMCHAR]: "0390",
  [Pkm.MONFERNO]: "0391",
  [Pkm.INFERNAPE]: "0392",
  [Pkm.PIPLUP]: "0393",
  [Pkm.PRINPLUP]: "0394",
  [Pkm.EMPOLEON]: "0395",
  [Pkm.STARLY]: "0396",
  [Pkm.STARAVIA]: "0397",
  [Pkm.STARAPTOR]: "0398",
  [Pkm.BIDOOF]: "0399",
  [Pkm.BIBAREL]: "0400",
  [Pkm.KRICKETOT]: "0401",
  [Pkm.KRICKETUNE]: "0402",
  [Pkm.SHINX]: "0403",
  [Pkm.LUXIO]: "0404",
  [Pkm.LUXRAY]: "0405",
  [Pkm.BUDEW]: "0406",
  [Pkm.ROSERADE]: "0407",
  [Pkm.CRANIDOS]: "0408",
  [Pkm.RAMPARDOS]: "0409",
  [Pkm.SHIELDON]: "0410",
  [Pkm.BASTIODON]: "0411",
  [Pkm.BURMY_PLANT]: "0412",
  [Pkm.BURMY_SANDY]: "0412-0001",
  [Pkm.BURMY_TRASH]: "0412-0002",
  [Pkm.WORMADAM_PLANT]: "0413",
  [Pkm.WORMADAM_SANDY]: "0413-0001",
  [Pkm.WORMADAM_TRASH]: "0413-0002",
  [Pkm.MOTHIM]: "0414",
  [Pkm.COMBEE]: "0415",
  [Pkm.VESPIQUEEN]: "0416",
  [Pkm.PACHIRISU]: "0417",
  [Pkm.BUIZEL]: "0418",
  [Pkm.FLOATZEL]: "0419",
  [Pkm.CHERUBI]: "0420",
  [Pkm.CHERRIM]: "0421",
  [Pkm.CHERRIM_SUNLIGHT]: "0421-0001",
  [Pkm.SHELLOS_WEST_SEA]: "0422",
  [Pkm.GASTRODON_WEST_SEA]: "0423",
  [Pkm.SHELLOS_EAST_SEA]: "0422-0001",
  [Pkm.GASTRODON_EAST_SEA]: "0423-0001",
  [Pkm.AMBIPOM]: "0424",
  [Pkm.DRIFLOON]: "0425",
  [Pkm.DRIFBLIM]: "0426",
  [Pkm.BUNEARY]: "0427",
  [Pkm.LOPUNNY]: "0428",
  //[Pkm.MEGA_LOPUNNY]: "0428-0001",
  [Pkm.MISMAGIUS]: "0429",
  [Pkm.HONCHKROW]: "0430",
  [Pkm.GLAMEOW]: "0431",
  [Pkm.PURUGLY]: "0432",
  [Pkm.CHINGLING]: "0433",
  [Pkm.STUNKY]: "0434",
  [Pkm.SKUNTANK]: "0435",
  [Pkm.BRONZOR]: "0436",
  [Pkm.BRONZONG]: "0437",
  [Pkm.BONSLEY]: "0438",
  [Pkm.MIME_JR]: "0439",
  [Pkm.HAPPINY]: "0440",
  [Pkm.CHATOT]: "0441",
  [Pkm.SPIRITOMB]: "0442",
  [Pkm.GIBLE]: "0443",
  [Pkm.GABITE]: "0444",
  [Pkm.GARCHOMP]: "0445",
  [Pkm.MUNCHLAX]: "0446",
  [Pkm.RIOLU]: "0447",
  [Pkm.LUCARIO]: "0448",
  [Pkm.HIPPOPOTAS]: "0449",
  [Pkm.HIPPODOWN]: "0450",
  [Pkm.SKORUPI]: "0451",
  [Pkm.DRAPION]: "0452",
  [Pkm.CROAGUNK]: "0453",
  [Pkm.TOXICROAK]: "0454",
  [Pkm.CARNIVINE]: "0455",
  [Pkm.FINNEON]: "0456",
  [Pkm.LUMINEON]: "0457",
  [Pkm.MANTYKE]: "0458",
  [Pkm.SNOVER]: "0459",
  [Pkm.ABOMASNOW]: "0460",
  //[Pkm.MEGA_ABOMASNOW]: "0460-0001",
  [Pkm.WEAVILE]: "0461",
  [Pkm.MAGNEZONE]: "0462",
  [Pkm.LICKILICKY]: "0463",
  [Pkm.RHYPERIOR]: "0464",
  [Pkm.TANGROWTH]: "0465",
  [Pkm.ELECTIVIRE]: "0466",
  [Pkm.MAGMORTAR]: "0467",
  [Pkm.TOGEKISS]: "0468",
  [Pkm.YANMEGA]: "0469",
  [Pkm.LEAFEON]: "0470",
  [Pkm.GLACEON]: "0471",
  [Pkm.GLISCOR]: "0472",
  [Pkm.MAMOSWINE]: "0473",
  [Pkm.PORYGON_Z]: "0474",
  [Pkm.GALLADE]: "0475",
  [Pkm.PROBOPASS]: "0476",
  [Pkm.DUSKNOIR]: "0477",
  [Pkm.FROSLASS]: "0478",
  [Pkm.ROTOM]: "0479",
  [Pkm.ROTOM_HEAT]: "0479-0001",
  [Pkm.ROTOM_WASH]: "0479-0002",
  [Pkm.ROTOM_FROST]: "0479-0003",
  [Pkm.ROTOM_FAN]: "0479-0004",
  [Pkm.ROTOM_MOW]: "0479-0005",
  [Pkm.ROTOM_DRONE]: "0479-0008",
  [Pkm.UXIE]: "0480",
  [Pkm.MESPRIT]: "0481",
  [Pkm.AZELF]: "0482",
  [Pkm.DIALGA]: "0483",
  [Pkm.PALKIA]: "0484",
  [Pkm.HEATRAN]: "0485",
  [Pkm.REGIGIGAS]: "0486",
  [Pkm.GIRATINA]: "0487",
  [Pkm.ORIGIN_GIRATINA]: "0487-0001",
  [Pkm.CRESSELIA]: "0488",
  [Pkm.PHIONE]: "0489",
  [Pkm.MANAPHY]: "0490",
  [Pkm.DARKRAI]: "0491",
  [Pkm.SHAYMIN]: "0492",
  [Pkm.SHAYMIN_SKY]: "0492-0001",
  [Pkm.ARCEUS]: "0493",
  [Pkm.ARCEUS_BUG]: "0493-0001",
  [Pkm.ARCEUS_DARK]: "0493-0002",
  [Pkm.ARCEUS_DRAGON]: "0493-0003",
  [Pkm.ARCEUS_ELECTRIC]: "0493-0004",
  [Pkm.ARCEUS_FIGHTING]: "0493-0005",
  [Pkm.ARCEUS_FIRE]: "0493-0006",
  [Pkm.ARCEUS_FLYING]: "0493-0007",
  [Pkm.ARCEUS_GHOST]: "0493-0008",
  [Pkm.ARCEUS_GRASS]: "0493-0009",
  [Pkm.ARCEUS_GROUND]: "0493-0010",
  [Pkm.ARCEUS_ICE]: "0493-0011",
  [Pkm.ARCEUS_POISON]: "0493-0012",
  [Pkm.ARCEUS_PSYCHIC]: "0493-0013",
  [Pkm.ARCEUS_ROCK]: "0493-0014",
  [Pkm.ARCEUS_STEEL]: "0493-0015",
  [Pkm.ARCEUS_WATER]: "0493-0016",
  [Pkm.ARCEUS_FAIRY]: "0493-0017",

  // Gen 5
  [Pkm.VICTINI]: "0494",
  [Pkm.SNIVY]: "0495",
  [Pkm.SERVINE]: "0496",
  [Pkm.SERPERIOR]: "0497",
  [Pkm.TEPIG]: "0498",
  [Pkm.PIGNITE]: "0499",
  [Pkm.EMBOAR]: "0500",
  [Pkm.OSHAWOTT]: "0501",
  [Pkm.DEWOTT]: "0502",
  [Pkm.SAMUROTT]: "0503",
  [Pkm.HISUI_SAMUROTT]: "0503-0001",
  [Pkm.PATRAT]: "0504",
  [Pkm.WATCHOG]: "0505",
  [Pkm.LILLIPUP]: "0506",
  [Pkm.HERDIER]: "0507",
  [Pkm.STOUTLAND]: "0508",
  [Pkm.PURRLOIN]: "0509",
  [Pkm.LIEPARD]: "0510",
  //[Pkm.PANSAGE]: "0511",
  //[Pkm.SIMISAGE]: "0512",
  //[Pkm.PANSEAR]: "0513",
  //[Pkm.SIMISEAR]: "0514",
  //[Pkm.PANPOUR]: "0515",
  //[Pkm.SIMIPOUR]: "0516",
  [Pkm.MUNNA]: "0517",
  [Pkm.MUSHARNA]: "0518",
  [Pkm.PIDOVE]: "0519",
  [Pkm.TRANQUILL]: "0520",
  [Pkm.UNFEZANT]: "0521",
  //[Pkm.BLITZLE]: "0522",
  //[Pkm.ZEBSTRIKA]: "0523",
  [Pkm.ROGGENROLA]: "0524",
  [Pkm.BOLDORE]: "0525",
  [Pkm.GIGALITH]: "0526",
  [Pkm.WOOBAT]: "0527",
  [Pkm.SWOOBAT]: "0528",
  [Pkm.DRILBUR]: "0529",
  [Pkm.EXCADRILL]: "0530",
  [Pkm.AUDINO]: "0531",
  [Pkm.TIMBURR]: "0532",
  [Pkm.PILLAR_WOOD]: "0532-0002",
  [Pkm.GURDURR]: "0533",
  [Pkm.PILLAR_IRON]: "0533-0002",
  [Pkm.CONKELDURR]: "0534",
  [Pkm.PILLAR_CONCRETE]: "0534-0002",
  [Pkm.TYMPOLE]: "0535",
  [Pkm.PALPITOAD]: "0536",
  [Pkm.SEISMITOAD]: "0537",
  //[Pkm.THROH]: "0538",
  //[Pkm.SAWK]: "0539",
  [Pkm.SEWADDLE]: "0540",
  [Pkm.SWADLOON]: "0541",
  [Pkm.LEAVANNY]: "0542",
  [Pkm.VENIPEDE]: "0543",
  [Pkm.WHIRLIPEDE]: "0544",
  [Pkm.SCOLIPEDE]: "0545",
  [Pkm.COTTONEE]: "0546",
  [Pkm.WHIMSICOTT]: "0547",
  [Pkm.PETILIL]: "0548",
  [Pkm.LILIGANT]: "0549",
  [Pkm.HISUIAN_LILLIGANT]: "0549-0001",
  [Pkm.BASCULIN_RED]: "0550",
  [Pkm.BASCULIN_BLUE]: "0550-0001",
  [Pkm.BASCULIN_WHITE]: "0550-0002",
  [Pkm.BASCULEGION_MALE]: "0902",
  [Pkm.BASCULEGION_FEMALE]: "0902-0000-0000-0002",
  [Pkm.SANDILE]: "0551",
  [Pkm.KROKOROK]: "0552",
  [Pkm.KROOKODILE]: "0553",
  [Pkm.DARUMAKA]: "0554",
  [Pkm.GALARIAN_DARUMAKA]: "0554-0001",
  [Pkm.DARMANITAN]: "0555",
  [Pkm.DARMANITAN_ZEN]: "0555-0001",
  [Pkm.GALARIAN_DARMANITAN]: "0555-0002",
  [Pkm.GALARIAN_DARMANITAN_ZEN]: "0555-0003",
  [Pkm.MARACTUS]: "0556",
  [Pkm.DWEBBLE]: "0557",
  [Pkm.CRUSTLE]: "0558",
  [Pkm.SCRAGGY]: "0559",
  [Pkm.SCRAFTY]: "0560",
  [Pkm.SIGILYPH]: "0561",
  [Pkm.YAMASK]: "0562",
  [Pkm.GALARIAN_YAMASK]: "0562-0001",
  [Pkm.COFAGRIGUS]: "0563",
  //[Pkm.TIRTOUGA]: "0564",
  //[Pkm.CARRACOSTA]: "0565",
  [Pkm.ARCHEN]: "0566",
  [Pkm.ARCHEOPS]: "0567",
  [Pkm.TRUBBISH]: "0568",
  [Pkm.GARBODOR]: "0569",
  [Pkm.ZORUA]: "0570",
  [Pkm.ZOROARK]: "0571",
  [Pkm.HISUI_ZORUA]: "0570-0001",
  [Pkm.HISUI_ZOROARK]: "0571-0001",
  [Pkm.MINCCINO]: "0572",
  [Pkm.CINCCINO]: "0573",
  [Pkm.GOTHITA]: "0574",
  [Pkm.GOTHORITA]: "0575",
  [Pkm.GOTHITELLE]: "0576",
  [Pkm.SOLOSIS]: "0577",
  [Pkm.DUOSION]: "0578",
  [Pkm.REUNICLUS]: "0579",
  [Pkm.DUCKLETT]: "0580",
  [Pkm.SWANNA]: "0581",
  [Pkm.VANILLITE]: "0582",
  [Pkm.VANILLISH]: "0583",
  [Pkm.VANILLUXE]: "0584",
  [Pkm.DEERLING_SPRING]: "0585",
  [Pkm.DEERLING_SUMMER]: "0585-0001",
  [Pkm.DEERLING_AUTUMN]: "0585-0002",
  [Pkm.DEERLING_WINTER]: "0585-0003",
  [Pkm.SAWSBUCK_SPRING]: "0586",
  [Pkm.SAWSBUCK_SUMMER]: "0586-0001",
  [Pkm.SAWSBUCK_AUTUMN]: "0586-0002",
  [Pkm.SAWSBUCK_WINTER]: "0586-0003",
  [Pkm.EMOLGA]: "0587",
  [Pkm.KARRABLAST]: "0588",
  [Pkm.ESCAVALIER]: "0589",
  //[Pkm.FOONGUS]: "0590",
  //[Pkm.AMOONGUSS]: "0591",
  //[Pkm.FRILLISH]: "0592",
  //[Pkm.JELLICENT]: "0593",
  //[Pkm.ALOMOMOLA]: "0594",
  [Pkm.JOLTIK]: "0595",
  [Pkm.GALVANTULA]: "0596",
  [Pkm.FERROSEED]: "0597",
  [Pkm.FERROTHORN]: "0598",
  [Pkm.KLINK]: "0599",
  [Pkm.KLANG]: "0600",
  [Pkm.KLINKLANG]: "0601",
  [Pkm.TYNAMO]: "0602",
  [Pkm.EELEKTRIK]: "0603",
  [Pkm.EELEKTROSS]: "0604",
  [Pkm.ELGYEM]: "0605",
  [Pkm.BEHEEYEM]: "0606",
  [Pkm.LITWICK]: "0607",
  [Pkm.LAMPENT]: "0608",
  [Pkm.CHANDELURE]: "0609",
  [Pkm.AXEW]: "0610",
  [Pkm.FRAXURE]: "0611",
  [Pkm.HAXORUS]: "0612",
  [Pkm.CUBCHOO]: "0613",
  [Pkm.BEARTIC]: "0614",
  [Pkm.CRYOGONAL]: "0615",
  //[Pkm.SHELMET]: "0616",
  //[Pkm.ACCELGOR]: "0617",
  //[Pkm.STUNFISK]: "0618",
  [Pkm.MIENFOO]: "0619",
  [Pkm.MIENSHAO]: "0620",
  [Pkm.DRUDDIGON]: "0621",
  [Pkm.GOLETT]: "0622",
  [Pkm.GOLURK]: "0623",
  [Pkm.PAWNIARD]: "0624",
  [Pkm.BISHARP]: "0625",
  [Pkm.RUFFLET]: "0627",
  [Pkm.BRAVIARY]: "0628",
  [Pkm.VULLABY]: "0629",
  [Pkm.MANDIBUZZ]: "0630",
  [Pkm.HEATMOR]: "0631",
  [Pkm.DURANT]: "0632",
  [Pkm.DEINO]: "0633",
  [Pkm.ZWEILOUS]: "0634",
  [Pkm.HYDREIGON]: "0635",
  [Pkm.LARVESTA]: "0636",
  [Pkm.VOLCARONA]: "0637",
  [Pkm.COBALION]: "0638",
  [Pkm.TERRAKION]: "0639",
  [Pkm.VIRIZION]: "0640",
  [Pkm.TORNADUS]: "0641",
  [Pkm.THUNDURUS]: "0642",
  [Pkm.RESHIRAM]: "0643",
  [Pkm.ZEKROM]: "0644",
  [Pkm.LANDORUS]: "0645",
  [Pkm.KYUREM]: "0646",
  [Pkm.KELDEO]: "0647",
  [Pkm.MELOETTA]: "0648",
  [Pkm.PIROUETTE_MELOETTA]: "0648-0001",
  [Pkm.GENESECT]: "0649",

  // Gen 6
  [Pkm.CHESPIN]: "0650",
  [Pkm.QUILLADIN]: "0651",
  [Pkm.CHESNAUGHT]: "0652",
  [Pkm.FENNEKIN]: "0653",
  [Pkm.BRAIXEN]: "0654",
  [Pkm.DELPHOX]: "0655",
  [Pkm.FROAKIE]: "0656",
  [Pkm.FROGADIER]: "0657",
  [Pkm.GRENINJA]: "0658",
  [Pkm.BUNNELBY]: "0659",
  [Pkm.DIGGERSBY]: "0660",
  [Pkm.FLETCHLING]: "0661",
  [Pkm.FLETCHINDER]: "0662",
  [Pkm.TALONFLAME]: "0663",
  [Pkm.SCATTERBUG]: "0664",
  [Pkm.SPEWPA]: "0665",
  [Pkm.VIVILLON]: "0666",
  [Pkm.VIVILLON_ICY_SNOW]: "0666-0001",
  [Pkm.VIVILLON_POLAR]: "0666-0002",
  [Pkm.VIVILLON_TUNDRA]: "0666-0003",
  [Pkm.VIVILLON_CONTINENTAL]: "0666-0004",
  [Pkm.VIVILLON_GARDEN]: "0666-0005",
  [Pkm.VIVILLON_ELEGANT]: "0666-0006",
  [Pkm.VIVILLON_MODERN]: "0666-0007",
  [Pkm.VIVILLON_MARINE]: "0666-0008",
  [Pkm.VIVILLON_ARCHIPELAGO]: "0666-0009",
  [Pkm.VIVILLON_HIGH_PLAINS]: "0666-0010",
  [Pkm.VIVILLON_SANDSTORM]: "0666-0011",
  [Pkm.VIVILLON_RIVER]: "0666-0012",
  [Pkm.VIVILLON_MONSOON]: "0666-0013",
  [Pkm.VIVILLON_SAVANNA]: "0666-0014",
  [Pkm.VIVILLON_SUN]: "0666-0015",
  [Pkm.VIVILLON_OCEAN]: "0666-0016",
  [Pkm.VIVILLON_JUNGLE]: "0666-0017",
  [Pkm.VIVILLON_FANCY]: "0666-0018",
  [Pkm.VIVILLON_POKE_BALL]: "0666-0019",
  //[Pkm.LITLEO]: "0667",
  //[Pkm.PYROAR]: "0668",
  [Pkm.FLABEBE]: "0669",
  [Pkm.FLOETTE]: "0670",
  [Pkm.FLORGES]: "0671",
  [Pkm.FLABEBE_YELLOW]: "0669-0001",
  [Pkm.FLOETTE_YELLOW]: "0670-0001",
  [Pkm.FLORGES_YELLOW]: "0671-0001",
  [Pkm.FLABEBE_ORANGE]: "0669-0002",
  [Pkm.FLOETTE_ORANGE]: "0670-0002",
  [Pkm.FLORGES_ORANGE]: "0671-0002",
  [Pkm.FLABEBE_BLUE]: "0669-0003",
  [Pkm.FLOETTE_BLUE]: "0670-0003",
  [Pkm.FLORGES_BLUE]: "0671-0003",
  [Pkm.FLABEBE_WHITE]: "0669-0004",
  [Pkm.FLOETTE_WHITE]: "0670-0004",
  [Pkm.FLORGES_WHITE]: "0671-0004",
  [Pkm.SKIDDO]: "0672",
  [Pkm.GOGOAT]: "0673",
  [Pkm.PANCHAM]: "0674",
  [Pkm.PANGORO]: "0675",
  [Pkm.FURFROU]: "0676",
  [Pkm.ESPURR]: "0677",
  [Pkm.MEOWSTIC_MALE]: "0678",
  [Pkm.MEOWSTIC_FEMALE]: "0678-0000-0000-0002",
  [Pkm.HONEDGE]: "0679",
  [Pkm.DOUBLADE]: "0680",
  [Pkm.AEGISLASH]: "0681",
  [Pkm.AEGISLASH_BLADE]: "0681-0001",
  //[Pkm.SPRITZEE]: "0682",
  //[Pkm.AROMATISSE]: "0683",
  [Pkm.SWIRLIX]: "0684",
  [Pkm.SLURPUFF]: "0685",
  [Pkm.INKAY]: "0686",
  [Pkm.MALAMAR]: "0687",
  [Pkm.BINACLE]: "0688",
  [Pkm.BARBARACLE]: "0689",
  [Pkm.SKRELP]: "0690",
  [Pkm.DRAGALGE]: "0691",
  [Pkm.CLAUNCHER]: "0692",
  [Pkm.CLAWITZER]: "0693",
  [Pkm.HELIOPTILE]: "0694",
  [Pkm.HELIOLISK]: "0695",
  [Pkm.TYRUNT]: "0696",
  [Pkm.TYRANTRUM]: "0697",
  [Pkm.AMAURA]: "0698",
  [Pkm.AURORUS]: "0699",
  [Pkm.SYLVEON]: "0700",
  [Pkm.HAWLUCHA]: "0701",
  [Pkm.DEDENNE]: "0702",
  [Pkm.CARBINK]: "0703",
  [Pkm.GOOMY]: "0704",
  [Pkm.SLIGOO]: "0705",
  [Pkm.GOODRA]: "0706",
  [Pkm.HISUI_SLIGGOO]: "0705-0001",
  [Pkm.HISUI_GOODRA]: "0706-0001",
  [Pkm.KLEFKI]: "0707",
  [Pkm.PHANTUMP]: "0708",
  [Pkm.TREVENANT]: "0709",
  [Pkm.PUMPKABOO]: "0710",
  [Pkm.GOURGEIST]: "0711",
  [Pkm.BERGMITE]: "0712",
  [Pkm.AVALUGG]: "0713",
  [Pkm.HISUI_AVALUGG]: "0713-0001",
  [Pkm.NOIBAT]: "0714",
  [Pkm.NOIVERN]: "0715",
  [Pkm.XERNEAS]: "0716",
  [Pkm.YVELTAL]: "0717",
  [Pkm.ZYGARDE_10]: "0718-0001",
  [Pkm.ZYGARDE_50]: "0718",
  [Pkm.ZYGARDE_100]: "0718-0002",
  [Pkm.DIANCIE]: "0719",
  [Pkm.HOOPA]: "0720",
  [Pkm.HOOPA_UNBOUND]: "0720-0001",
  [Pkm.VOLCANION]: "0721",
  [Pkm.ROWLET]: "0722",
  [Pkm.DARTIX]: "0723",
  [Pkm.DECIDUEYE]: "0724",
  [Pkm.LITTEN]: "0725",
  [Pkm.TORRACAT]: "0726",
  [Pkm.INCINEROAR]: "0727",
  [Pkm.POPPLIO]: "0728",
  [Pkm.BRIONNE]: "0729",
  [Pkm.PRIMARINA]: "0730",
  //[Pkm.PIKIPEK]: "0731",
  //[Pkm.TRUMBEAK]: "0732",
  //[Pkm.TOUCANNON]: "0733",
  //[Pkm.YUNGOOS]: "0734",
  //[Pkm.GUMSHOOS]: "0735",
  [Pkm.GRUBBIN]: "0736",
  [Pkm.CHARJABUG]: "0737",
  [Pkm.VIKAVOLT]: "0738",
  [Pkm.CRABRAWLER]: "0739",
  [Pkm.CRABOMINABLE]: "0740",
  //[Pkm.ORICORIO]: "0741",
  [Pkm.CUTIEFLY]: "0742",
  [Pkm.RIBOMBEE]: "0743",
  [Pkm.ROCKRUFF]: "0744",
  [Pkm.LYCANROC_DAY]: "0745",
  [Pkm.LYCANROC_DUSK]: "0745-0002",
  [Pkm.LYCANROC_NIGHT]: "0745-0001",
  [Pkm.WISHIWASHI]: "0746",
  [Pkm.WISHIWASHI_SCHOOL]: "0746-0001",
  [Pkm.MAREANIE]: "0747",
  [Pkm.TOXAPEX]: "0748",
  [Pkm.MUDBRAY]: "0749",
  [Pkm.MUDSDALE]: "0750",
  [Pkm.DEWPIDER]: "0751",
  [Pkm.ARAQUANID]: "0752",
  [Pkm.FOMANTIS]: "0753",
  [Pkm.LURANTIS]: "0754",
  //[Pkm.MORELULL]: "0755",
  //[Pkm.SHIINOTIC]: "0756",
  [Pkm.SALANDIT]: "0757",
  [Pkm.SALAZZLE]: "0758",
  [Pkm.STUFFUL]: "0759",
  [Pkm.BEWEAR]: "0760",
  [Pkm.BOUNSWEET]: "0761",
  [Pkm.STEENEE]: "0762",
  [Pkm.TSAREENA]: "0763",
  [Pkm.COMFEY]: "0764",
  //[Pkm.ORANGURU]: "0765",
  //[Pkm.PASSIMIAN]: "0766",
  [Pkm.WIMPOD]: "0767",
  [Pkm.GOLISOPOD]: "0768",
  [Pkm.SANDYGAST]: "0769",
  [Pkm.PALOSSAND]: "0770",
  [Pkm.PYUKUMUKU]: "0771",
  [Pkm.TYPE_NULL]: "0772",
  [Pkm.SILVALLY]: "0773",
  [Pkm.SILVALLY_FIGHTING]: "0773-0001",
  [Pkm.SILVALLY_FLYING]: "0773-0002",
  [Pkm.SILVALLY_POISON]: "0773-0003",
  [Pkm.SILVALLY_GROUND]: "0773-0004",
  [Pkm.SILVALLY_ROCK]: "0773-0005",
  [Pkm.SILVALLY_BUG]: "0773-0006",
  [Pkm.SILVALLY_GHOST]: "0773-0007",
  [Pkm.SILVALLY_STEEL]: "0773-0008",
  [Pkm.SILVALLY_FIRE]: "0773-0009",
  [Pkm.SILVALLY_WATER]: "0773-0010",
  [Pkm.SILVALLY_GRASS]: "0773-0011",
  [Pkm.SILVALLY_ELECTRIC]: "0773-0012",
  [Pkm.SILVALLY_PSYCHIC]: "0773-0013",
  [Pkm.SILVALLY_ICE]: "0773-0014",
  [Pkm.SILVALLY_DRAGON]: "0773-0015",
  [Pkm.SILVALLY_DARK]: "0773-0016",
  [Pkm.SILVALLY_FAIRY]: "0773-0017",
  [Pkm.MINIOR]: "0774",
  [Pkm.MINIOR_KERNEL_RED]: "0774-0001",
  [Pkm.MINIOR_KERNEL_BLUE]: "0774-0005",
  [Pkm.MINIOR_KERNEL_ORANGE]: "0774-0002",
  [Pkm.MINIOR_KERNEL_GREEN]: "0774-0004",
  //[Pkm.KOMALA]: "0775",
  [Pkm.TURTONATOR]: "0776",
  [Pkm.TOGEDEMARU]: "0777",
  [Pkm.MIMIKYU]: "0778",
  [Pkm.MIMIKYU_BUSTED]: "0778-0001",
  [Pkm.BRUXISH]: "0779",
  [Pkm.DRAMPA]: "0780",
  [Pkm.DHELMISE]: "0781",
  [Pkm.JANGMO_O]: "0782",
  [Pkm.HAKAMO_O]: "0783",
  [Pkm.KOMMO_O]: "0784",
  [Pkm.TAPU_KOKO]: "0785",
  [Pkm.TAPU_LELE]: "0786",
  [Pkm.TAPU_BULU]: "0787",
  [Pkm.TAPU_FINI]: "0788",
  [Pkm.COSMOG]: "0789",
  [Pkm.COSMOEM]: "0790",
  [Pkm.SOLGALEO]: "0791",
  [Pkm.LUNALA]: "0792",
  [Pkm.NIHILEGO]: "0793",
  [Pkm.BUZZWOLE]: "0794",
  [Pkm.PHEROMOSA]: "0795",
  [Pkm.XURKITREE]: "0796",
  [Pkm.CELESTEELA]: "0797",
  [Pkm.KARTANA]: "0798",
  [Pkm.GUZZLORD]: "0799",
  [Pkm.NECROZMA]: "0800",
  [Pkm.ULTRA_NECROZMA]: "0800-0003",
  [Pkm.MAGEARNA]: "0801",
  [Pkm.MARSHADOW]: "0802",
  [Pkm.POIPOLE]: "0803",
  [Pkm.NAGANADEL]: "0804",
  [Pkm.STAKATAKA]: "0805",
  [Pkm.BLACEPHALON]: "0806",
  [Pkm.ZERAORA]: "0807",
  [Pkm.MELTAN]: "0808",
  [Pkm.MELMETAL]: "0809",

  // Gen 8
  [Pkm.GROOKEY]: "0810",
  [Pkm.THWACKEY]: "0811",
  [Pkm.RILLABOOM]: "0812",
  [Pkm.SCORBUNNY]: "0813",
  [Pkm.RABOOT]: "0814",
  [Pkm.CINDERACE]: "0815",
  [Pkm.SOBBLE]: "0816",
  [Pkm.DRIZZILE]: "0817",
  [Pkm.INTELEON]: "0818",
  //[Pkm.SKWOVET]: "0819",
  //[Pkm.GREEDENT]: "0820",
  [Pkm.ROOKIDEE]: "0821",
  [Pkm.CORVISQUIRE]: "0822",
  [Pkm.CORVIKNIGHT]: "0823",
  [Pkm.BLIPBUG]: "0824",
  [Pkm.DOTTLER]: "0825",
  [Pkm.ORBEETLE]: "0826",
  [Pkm.NICKIT]: "0827",
  [Pkm.THIEVUL]: "0828",
  [Pkm.GOSSIFLEUR]: "0829",
  [Pkm.ELDEGOSS]: "0830",
  [Pkm.WOOLOO]: "0831",
  [Pkm.DUBWOOL]: "0832",
  [Pkm.CHEWTLE]: "0833",
  [Pkm.DREDNAW]: "0834",
  [Pkm.YAMPER]: "0835",
  [Pkm.BOLTUND]: "0836",
  //[Pkm.ROLYCOLY]: "0837",
  //[Pkm.CARKOL]: "0838",
  //[Pkm.COALOSSAL]: "0839",
  [Pkm.APPLIN]: "0840",
  [Pkm.FLAPPLE]: "0841",
  [Pkm.APPLETUN]: "0842",
  [Pkm.SILICOBRA]: "0843",
  [Pkm.SANDACONDA]: "0844",
  [Pkm.CRAMORANT]: "0845",
  [Pkm.ARROKUDA]: "0846",
  //[Pkm.BARRASKEWDA]: "0847",
  [Pkm.TOXEL]: "0848",
  [Pkm.TOXTRICITY]: "0849",
  [Pkm.SIZZLIPEDE]: "0850",
  [Pkm.CENTISKORCH]: "0851",
  [Pkm.CLOBBOPUS]: "0852",
  [Pkm.GRAPPLOCT]: "0853",
  [Pkm.SINISTEA]: "0854",
  [Pkm.POLTEAGEIST]: "0855",
  [Pkm.HATENNA]: "0856",
  [Pkm.HATTREM]: "0857",
  [Pkm.HATTERENE]: "0858",
  [Pkm.IMPIDIMP]: "0859",
  [Pkm.MORGREM]: "0860",
  [Pkm.GRIMMSNARL]: "0861",
  [Pkm.OBSTAGOON]: "0862",
  //[Pkm.PERRSERKER]: "0863",
  [Pkm.CURSOLA]: "0864",
  //[Pkm.SIRFETCHD]: "0865",
  //[Pkm.MR_RIME]: "0866",
  [Pkm.RUNERIGUS]: "0867",
  [Pkm.MILCERY]: "0868",
  [Pkm.ALCREMIE_VANILLA]: "0869",
  [Pkm.ALCREMIE_RUBY]: "0869-0007",
  [Pkm.ALCREMIE_MATCHA]: "0869-0014",
  [Pkm.ALCREMIE_MINT]: "0869-0021",
  [Pkm.ALCREMIE_LEMON]: "0869-0028",
  [Pkm.ALCREMIE_SALTED]: "0869-0035",
  [Pkm.ALCREMIE_RUBY_SWIRL]: "0869-0042",
  [Pkm.ALCREMIE_CARAMEL_SWIRL]: "0869-0049",
  [Pkm.ALCREMIE_RAINBOW_SWIRL]: "0869-0056",
  [Pkm.FALINKS_BRASS]: "0870-0002",
  [Pkm.FALINKS_TROOPER]: "0870-0003",
  [Pkm.PINCURCHIN]: "0871",
  [Pkm.SNOM]: "0872",
  [Pkm.FROSMOTH]: "0873",
  [Pkm.STONJOURNER]: "0874",
  [Pkm.EISCUE]: "0875",
  [Pkm.EISCUE_NOICE]: "0875-0001",
  [Pkm.INDEEDEE_MALE]: "0876",
  [Pkm.INDEEDEE_FEMALE]: "0876-0000-0000-0002",
  [Pkm.MORPEKO]: "0877",
  [Pkm.MORPEKO_HANGRY]: "0877-0001",
  //[Pkm.CUFANT]: "0878",
  //[Pkm.COPPERAJAH]: "0879",
  [Pkm.DRACOZOLT]: "0880",
  [Pkm.ARCTOZOLT]: "0881",
  [Pkm.DRACOVISH]: "0882",
  [Pkm.ARCTOVISH]: "0883",
  [Pkm.DURALUDON]: "0884",
  [Pkm.DREEPY]: "0885",
  [Pkm.DRAKLOAK]: "0886",
  [Pkm.DRAGAPULT]: "0887",
  [Pkm.ZACIAN]: "0888",
  [Pkm.ZACIAN_CROWNED]: "0888-0001",
  //[Pkm.ZAMAZENTA]: "0889",
  //[Pkm.ZAMAZENTA_CROWNED]: "0889-0001",
  [Pkm.ETERNATUS]: "0890",
  //[Pkm.ETERNATUS_ETERNAMAX]: "0890-0001",
  [Pkm.KUBFU]: "0891",
  [Pkm.URSHIFU_SINGLE]: "0892",
  [Pkm.URSHIFU_RAPID]: "0892-0001",
  //[Pkm.ZARUDE]: "0893",
  [Pkm.REGIELEKI]: "0894",
  [Pkm.REGIDRAGO]: "0895",
  [Pkm.GLASTRIER]: "0896",
  [Pkm.SPECTRIER]: "0897",
  //[Pkm.CALYREX]: "0898",
  //[Pkm.CALYREX_ICE]: "0898-0001",
  //[Pkm.CALYREX_SHADOW]: "0898-0002",
  [Pkm.WYRDEER]: "0899",
  [Pkm.KLEAVOR]: "0900",
  [Pkm.URSALUNA]: "0901",
  [Pkm.URSALUNA_BLOODMOON]: "0901-0001",
  //[Pkm.SNOMERAID]: "0902",
  [Pkm.SNEASLER]: "0903",
  [Pkm.OVERQWIL]: "0904",
  [Pkm.ENAMORUS]: "0905",

  // Gen 9
  [Pkm.SPRIGATITO]: "0906",
  [Pkm.FLORAGATO]: "0907",
  [Pkm.MEOWSCARADA]: "0908",
  [Pkm.FUECOCO]: "0909",
  [Pkm.CROCALOR]: "0910",
  [Pkm.SKELEDIRGE]: "0911",
  //[Pkm.QUAXLY]: "0912",
  //[Pkm.QUAXWELL]: "0913",
  //[Pkm.QUAQUAVAL]: "0914",
  [Pkm.LECHONK]: "0915",
  [Pkm.OINKOLOGNE_MALE]: "0916",
  //[Pkm.OINKOLOGNE_FEMALE]: "0916-0003",
  //[Pkm.TAROUNTULA]: "0917",
  //[Pkm.SPIDOPS]: "0918",
  [Pkm.NYMBLE]: "0919",
  [Pkm.LOKIX]: "0920",
  [Pkm.PAWMI]: "0921",
  [Pkm.PAWMO]: "0922",
  [Pkm.PAWMOT]: "0923",
  [Pkm.TANDEMAUS]: "0924",
  [Pkm.MAUSHOLD_THREE]: "0925-0001",
  [Pkm.MAUSHOLD_FOUR]: "0925",
  [Pkm.FIDOUGH]: "0926",
  [Pkm.DACHSBUN]: "0927",
  [Pkm.SMOLIV]: "0928",
  [Pkm.DOLLIV]: "0929",
  [Pkm.ARBOLIVA]: "0930",
  //[Pkm.SQUAWKABILLY]: "0931",
  [Pkm.NACLI]: "0932",
  [Pkm.NACLSTACK]: "0933",
  [Pkm.GARGANACL]: "0934",
  [Pkm.CHARCADET]: "0935",
  [Pkm.ARMAROUGE]: "0936",
  [Pkm.CERULEDGE]: "0937",
  [Pkm.TADBULB]: "0938",
  [Pkm.BELLIBOLT]: "0939",
  [Pkm.WATTREL]: "0940",
  [Pkm.KILOWATTREL]: "0941",
  //[Pkm.MASCHIFF]: "0942",
  //[Pkm.MABOSSTIFF]: "0943",
  //[Pkm.SHROODLE]: "0944",
  //[Pkm.GRAFAIAI]: "0945",
  //[Pkm.BRAMBLIN]: "0946",
  //[Pkm.BRAMBLEGHAST]: "0947",
  //[Pkm.TOEDSCOOL]: "0948",
  //[Pkm.TOEDSCRUEL]: "0949",
  //[Pkm.KLAWF]: "0950",
  [Pkm.CAPSAKID]: "0951",
  [Pkm.SCOVILLAIN]: "0952",
  //[Pkm.RELLOR]: "0953",
  //[Pkm.RABSCA]: "0954",
  //[Pkm.FLITTLE]: "0955",
  //[Pkm.ESPATHRA]: "0956",
  [Pkm.TINKATINK]: "0957",
  [Pkm.TINKATUFF]: "0958",
  [Pkm.TINKATON]: "0959",
  [Pkm.WIGLETT]: "0960",
  [Pkm.WUGTRIO]: "0961",
  //[Pkm.BOMBIRDIER]: "0962",
  [Pkm.FINIZEN]: "0963",
  [Pkm.PALAFIN]: "0964",
  [Pkm.PALAFIN_HERO]: "0964-0001",
  [Pkm.VAROOM]: "0965",
  [Pkm.REVAVROOM]: "0966",
  [Pkm.CYCLIZAR]: "0967",
  [Pkm.ORTHWORM]: "0968",
  [Pkm.GLIMMET]: "0969",
  [Pkm.GLIMMORA]: "0970",
  [Pkm.GREAVARD]: "0971",
  [Pkm.HOUNDSTONE]: "0972",
  //[Pkm.FLAMIGO]: "0973",
  [Pkm.CETODDLE]: "0974",
  [Pkm.CETITAN]: "0975",
  [Pkm.VELUZA]: "0976",
  [Pkm.DONDOZO]: "0977",
  [Pkm.TATSUGIRI_CURLY]: "0978",
  [Pkm.TATSUGIRI_STRETCHY]: "0978-0001",
  [Pkm.TATSUGIRI_DROOPY]: "0978-0002",
  [Pkm.ANNIHILAPE]: "0979",
  [Pkm.CLODSIRE]: "0980",
  [Pkm.FARIGIRAF]: "0981",
  [Pkm.DUDUNSPARCE]: "0982",
  [Pkm.KINGAMBIT]: "0983",
  [Pkm.GREAT_TUSK]: "0984",
  [Pkm.SCREAM_TAIL]: "0985",
  //[Pkm.BRUTE_BONNET]: "0986",
  [Pkm.FLUTTER_MANE]: "0987",
  //[Pkm.SLITHER_WING]: "0988",
  //[Pkm.SANDY_SHOCKS]: "0989",
  //[Pkm.IRON_THREADS]: "0990",
  [Pkm.IRON_BUNDLE]: "0991",
  [Pkm.IRON_HANDS]: "0992",
  //[Pkm.IRON_JUGULIS]: "0993",
  //[Pkm.IRON_MOTH]: "0994",
  [Pkm.IRON_THORNS]: "0995",
  [Pkm.FRIGIBAX]: "0996",
  [Pkm.ARCTIBAX]: "0997",
  [Pkm.BAXCALIBUR]: "0998",
  [Pkm.GIMMIGHOUL]: "0999-0001",
  [Pkm.GHOLDENGO]: "1000",
  //[Pkm.WO_CHIEN]: "1001",
  //[Pkm.CHIEN_PAO]: "1002",
  //[Pkm.TING_LU]: "1003",
  [Pkm.CHI_YU]: "1004",
  [Pkm.ROARING_MOON]: "1005",
  [Pkm.IRON_VALIANT]: "1006",
  //[Pkm.KORAIDON]: "1007",
  //[Pkm.MIRAIDON]: "1008",
  [Pkm.WALKING_WAKE]: "1009",
  //[Pkm.IRON_LEAVES]: "1010",
  [Pkm.DIPPLIN]: "1011",
  [Pkm.OKIDOGI]: "1014",
  [Pkm.MUNKIDORI]: "1015",
  [Pkm.FEZANDIPITI]: "1016",
  [Pkm.OGERPON_TEAL]: "1017",
  [Pkm.OGERPON_WELLSPRING]: "1017-0001",
  [Pkm.OGERPON_HEARTHFLAME]: "1017-0002",
  [Pkm.OGERPON_CORNERSTONE]: "1017-0003",
  [Pkm.OGERPON_TEAL_MASK]: "1017-0004",
  [Pkm.OGERPON_WELLSPRING_MASK]: "1017-0005",
  [Pkm.OGERPON_HEARTHFLAME_MASK]: "1017-0006",
  [Pkm.OGERPON_CORNERSTONE_MASK]: "1017-0007",
  [Pkm.ARCHALUDON]: "1018",
  [Pkm.HYDRAPPLE]: "1019",
  [Pkm.PECHARUNT]: "1025"
}

export const PkmByIndex: { [index: string]: Pkm } = Object.fromEntries(
  Object.entries(PkmIndex).map(([pkm, index]) => [index, pkm as Pkm])
)

export const PkmFamily: { [key in Pkm]: Pkm } = {
  [Pkm.EGG]: Pkm.EGG,
  [Pkm.BULBASAUR]: Pkm.BULBASAUR,
  [Pkm.IVYSAUR]: Pkm.BULBASAUR,
  [Pkm.VENUSAUR]: Pkm.BULBASAUR,
  [Pkm.CHARMANDER]: Pkm.CHARMANDER,
  [Pkm.CHARMELEON]: Pkm.CHARMANDER,
  [Pkm.CHARIZARD]: Pkm.CHARMANDER,
  [Pkm.SQUIRTLE]: Pkm.SQUIRTLE,
  [Pkm.WARTORTLE]: Pkm.SQUIRTLE,
  [Pkm.BLASTOISE]: Pkm.SQUIRTLE,
  [Pkm.SLOWPOKE]: Pkm.SLOWPOKE,
  [Pkm.SLOWBRO]: Pkm.SLOWPOKE,
  [Pkm.SLOWKING]: Pkm.SLOWPOKE,
  [Pkm.GEODUDE]: Pkm.GEODUDE,
  [Pkm.GRAVELER]: Pkm.GEODUDE,
  [Pkm.GOLEM]: Pkm.GEODUDE,
  [Pkm.AZURILL]: Pkm.AZURILL,
  [Pkm.MARILL]: Pkm.AZURILL,
  [Pkm.AZUMARILL]: Pkm.AZURILL,
  [Pkm.ZUBAT]: Pkm.ZUBAT,
  [Pkm.GOLBAT]: Pkm.ZUBAT,
  [Pkm.CROBAT]: Pkm.ZUBAT,
  [Pkm.AMPHAROS]: Pkm.MAREEP,
  [Pkm.MAREEP]: Pkm.MAREEP,
  [Pkm.FLAFFY]: Pkm.MAREEP,
  [Pkm.CLEFFA]: Pkm.CLEFFA,
  [Pkm.CLEFAIRY]: Pkm.CLEFFA,
  [Pkm.CLEFABLE]: Pkm.CLEFFA,
  [Pkm.IGGLYBUFF]: Pkm.IGGLYBUFF,
  [Pkm.JIGGLYPUFF]: Pkm.IGGLYBUFF,
  [Pkm.WIGGLYTUFF]: Pkm.IGGLYBUFF,
  [Pkm.CATERPIE]: Pkm.CATERPIE,
  [Pkm.METAPOD]: Pkm.CATERPIE,
  [Pkm.BUTTERFREE]: Pkm.CATERPIE,
  [Pkm.WEEDLE]: Pkm.WEEDLE,
  [Pkm.KAKUNA]: Pkm.WEEDLE,
  [Pkm.BEEDRILL]: Pkm.WEEDLE,
  [Pkm.PIDGEY]: Pkm.PIDGEY,
  [Pkm.PIDGEOTTO]: Pkm.PIDGEY,
  [Pkm.PIDGEOT]: Pkm.PIDGEY,
  [Pkm.HOPPIP]: Pkm.HOPPIP,
  [Pkm.SKIPLOOM]: Pkm.HOPPIP,
  [Pkm.JUMPLUFF]: Pkm.HOPPIP,
  [Pkm.SEEDOT]: Pkm.SEEDOT,
  [Pkm.NUZLEAF]: Pkm.SEEDOT,
  [Pkm.SHIFTRY]: Pkm.SEEDOT,
  [Pkm.STARLY]: Pkm.STARLY,
  [Pkm.STARAVIA]: Pkm.STARLY,
  [Pkm.STARAPTOR]: Pkm.STARLY,
  [Pkm.CHIKORITA]: Pkm.CHIKORITA,
  [Pkm.BAYLEEF]: Pkm.CHIKORITA,
  [Pkm.MEGANIUM]: Pkm.CHIKORITA,
  [Pkm.CYNDAQUIL]: Pkm.CYNDAQUIL,
  [Pkm.QUILAVA]: Pkm.CYNDAQUIL,
  [Pkm.TYPHLOSION]: Pkm.CYNDAQUIL,
  [Pkm.TOTODILE]: Pkm.TOTODILE,
  [Pkm.CROCONAW]: Pkm.TOTODILE,
  [Pkm.FERALIGATR]: Pkm.TOTODILE,
  [Pkm.TREECKO]: Pkm.TREECKO,
  [Pkm.GROVYLE]: Pkm.TREECKO,
  [Pkm.SCEPTILE]: Pkm.TREECKO,
  [Pkm.TORCHIC]: Pkm.TORCHIC,
  [Pkm.COMBUSKEN]: Pkm.TORCHIC,
  [Pkm.BLAZIKEN]: Pkm.TORCHIC,
  [Pkm.MUDKIP]: Pkm.MUDKIP,
  [Pkm.MARSHTOMP]: Pkm.MUDKIP,
  [Pkm.SWAMPERT]: Pkm.MUDKIP,
  [Pkm.TURTWIG]: Pkm.TURTWIG,
  [Pkm.GROTLE]: Pkm.TURTWIG,
  [Pkm.TORTERRA]: Pkm.TURTWIG,
  [Pkm.CHIMCHAR]: Pkm.CHIMCHAR,
  [Pkm.MONFERNO]: Pkm.CHIMCHAR,
  [Pkm.INFERNAPE]: Pkm.CHIMCHAR,
  [Pkm.PIPLUP]: Pkm.PIPLUP,
  [Pkm.PRINPLUP]: Pkm.PIPLUP,
  [Pkm.EMPOLEON]: Pkm.PIPLUP,
  [Pkm.NIDORANF]: Pkm.NIDORANF,
  [Pkm.NIDORINA]: Pkm.NIDORANF,
  [Pkm.NIDOQUEEN]: Pkm.NIDORANF,
  [Pkm.NIDORANM]: Pkm.NIDORANM,
  [Pkm.NIDORINO]: Pkm.NIDORANM,
  [Pkm.NIDOKING]: Pkm.NIDORANM,
  [Pkm.PICHU]: Pkm.PICHU,
  [Pkm.PIKACHU]: Pkm.PICHU,
  [Pkm.PIKACHU_SURFER]: Pkm.PICHU,
  [Pkm.RAICHU]: Pkm.PICHU,
  [Pkm.MACHOP]: Pkm.MACHOP,
  [Pkm.MACHOKE]: Pkm.MACHOP,
  [Pkm.MACHAMP]: Pkm.MACHOP,
  [Pkm.HORSEA]: Pkm.HORSEA,
  [Pkm.SEADRA]: Pkm.HORSEA,
  [Pkm.KINGDRA]: Pkm.HORSEA,
  [Pkm.TRAPINCH]: Pkm.TRAPINCH,
  [Pkm.VIBRAVA]: Pkm.TRAPINCH,
  [Pkm.FLYGON]: Pkm.TRAPINCH,
  [Pkm.SPHEAL]: Pkm.SPHEAL,
  [Pkm.SEALEO]: Pkm.SPHEAL,
  [Pkm.WALREIN]: Pkm.SPHEAL,
  [Pkm.ARON]: Pkm.ARON,
  [Pkm.LAIRON]: Pkm.ARON,
  [Pkm.AGGRON]: Pkm.ARON,
  [Pkm.MAGNEMITE]: Pkm.MAGNEMITE,
  [Pkm.MAGNETON]: Pkm.MAGNEMITE,
  [Pkm.MAGNEZONE]: Pkm.MAGNEMITE,
  [Pkm.RHYHORN]: Pkm.RHYHORN,
  [Pkm.RHYDON]: Pkm.RHYHORN,
  [Pkm.RHYPERIOR]: Pkm.RHYHORN,
  [Pkm.TOGEPI]: Pkm.TOGEPI,
  [Pkm.TOGETIC]: Pkm.TOGEPI,
  [Pkm.TOGEKISS]: Pkm.TOGEPI,
  [Pkm.DUSKULL]: Pkm.DUSKULL,
  [Pkm.DUSCLOPS]: Pkm.DUSKULL,
  [Pkm.DUSKNOIR]: Pkm.DUSKULL,
  [Pkm.LOTAD]: Pkm.LOTAD,
  [Pkm.LOMBRE]: Pkm.LOTAD,
  [Pkm.LUDICOLO]: Pkm.LOTAD,
  [Pkm.SHINX]: Pkm.SHINX,
  [Pkm.LUXIO]: Pkm.SHINX,
  [Pkm.LUXRAY]: Pkm.SHINX,
  [Pkm.POLIWAG]: Pkm.POLIWAG,
  [Pkm.POLIWHIRL]: Pkm.POLIWAG,
  [Pkm.POLITOED]: Pkm.POLIWAG,
  [Pkm.ABRA]: Pkm.ABRA,
  [Pkm.KADABRA]: Pkm.ABRA,
  [Pkm.ALAKAZAM]: Pkm.ABRA,
  [Pkm.GASTLY]: Pkm.GASTLY,
  [Pkm.HAUNTER]: Pkm.GASTLY,
  [Pkm.GENGAR]: Pkm.GASTLY,
  [Pkm.DRATINI]: Pkm.DRATINI,
  [Pkm.DRAGONAIR]: Pkm.DRATINI,
  [Pkm.DRAGONITE]: Pkm.DRATINI,
  [Pkm.LARVITAR]: Pkm.LARVITAR,
  [Pkm.PUPITAR]: Pkm.LARVITAR,
  [Pkm.TYRANITAR]: Pkm.LARVITAR,
  [Pkm.SLAKOTH]: Pkm.SLAKOTH,
  [Pkm.VIGOROTH]: Pkm.SLAKOTH,
  [Pkm.SLAKING]: Pkm.SLAKOTH,
  [Pkm.RALTS]: Pkm.RALTS,
  [Pkm.KIRLIA]: Pkm.RALTS,
  [Pkm.GARDEVOIR]: Pkm.RALTS,
  [Pkm.GALLADE]: Pkm.RALTS,
  [Pkm.BAGON]: Pkm.BAGON,
  [Pkm.SHELGON]: Pkm.BAGON,
  [Pkm.SALAMENCE]: Pkm.BAGON,
  [Pkm.BELDUM]: Pkm.BELDUM,
  [Pkm.METANG]: Pkm.BELDUM,
  [Pkm.METAGROSS]: Pkm.BELDUM,
  [Pkm.GIBLE]: Pkm.GIBLE,
  [Pkm.GABITE]: Pkm.GIBLE,
  [Pkm.GARCHOMP]: Pkm.GIBLE,
  [Pkm.ELEKID]: Pkm.ELEKID,
  [Pkm.ELECTABUZZ]: Pkm.ELEKID,
  [Pkm.ELECTIVIRE]: Pkm.ELEKID,
  [Pkm.MAGBY]: Pkm.MAGBY,
  [Pkm.MAGMAR]: Pkm.MAGBY,
  [Pkm.MAGMORTAR]: Pkm.MAGBY,
  [Pkm.MUNCHLAX]: Pkm.MUNCHLAX,
  [Pkm.SNORLAX]: Pkm.MUNCHLAX,
  [Pkm.GROWLITHE]: Pkm.GROWLITHE,
  [Pkm.ARCANINE]: Pkm.GROWLITHE,
  [Pkm.HISUI_GROWLITHE]: Pkm.HISUI_GROWLITHE,
  [Pkm.HISUI_ARCANINE]: Pkm.HISUI_GROWLITHE,
  [Pkm.ONIX]: Pkm.ONIX,
  [Pkm.STEELIX]: Pkm.ONIX,
  //[Pkm.MEGA_STEELIX]: Pkm.ONIX,
  [Pkm.SCYTHER]: Pkm.SCYTHER,
  [Pkm.SCIZOR]: Pkm.SCYTHER,
  [Pkm.KLEAVOR]: Pkm.SCYTHER,
  [Pkm.RIOLU]: Pkm.RIOLU,
  [Pkm.LUCARIO]: Pkm.RIOLU,
  [Pkm.EEVEE]: Pkm.EEVEE,
  [Pkm.VAPOREON]: Pkm.EEVEE,
  [Pkm.JOLTEON]: Pkm.EEVEE,
  [Pkm.FLAREON]: Pkm.EEVEE,
  [Pkm.ESPEON]: Pkm.EEVEE,
  [Pkm.UMBREON]: Pkm.EEVEE,
  [Pkm.LEAFEON]: Pkm.EEVEE,
  [Pkm.SYLVEON]: Pkm.EEVEE,
  [Pkm.GLACEON]: Pkm.EEVEE,
  [Pkm.MEDITITE]: Pkm.MEDITITE,
  [Pkm.MEDICHAM]: Pkm.MEDITITE,
  [Pkm.NUMEL]: Pkm.NUMEL,
  [Pkm.CAMERUPT]: Pkm.NUMEL,
  //[Pkm.MEGA_CAMERUPT]: Pkm.NUMEL,
  [Pkm.DITTO]: Pkm.DITTO,
  [Pkm.DARKRAI]: Pkm.DARKRAI,
  [Pkm.LITWICK]: Pkm.LITWICK,
  [Pkm.LAMPENT]: Pkm.LITWICK,
  [Pkm.CHANDELURE]: Pkm.LITWICK,
  [Pkm.BELLSPROUT]: Pkm.BELLSPROUT,
  [Pkm.WEEPINBELL]: Pkm.BELLSPROUT,
  [Pkm.VICTREEBEL]: Pkm.BELLSPROUT,
  [Pkm.SWINUB]: Pkm.SWINUB,
  [Pkm.PILOSWINE]: Pkm.SWINUB,
  [Pkm.MAMOSWINE]: Pkm.SWINUB,
  [Pkm.SNORUNT]: Pkm.SNORUNT,
  [Pkm.GLALIE]: Pkm.SNORUNT,
  [Pkm.FROSLASS]: Pkm.SNORUNT,
  [Pkm.SNOVER]: Pkm.SNOVER,
  [Pkm.ABOMASNOW]: Pkm.SNOVER,
  //[Pkm.MEGA_ABOMASNOW]: Pkm.SNOVER,
  [Pkm.VANILLITE]: Pkm.VANILLITE,
  [Pkm.VANILLISH]: Pkm.VANILLITE,
  [Pkm.VANILLUXE]: Pkm.VANILLITE,
  [Pkm.LARVESTA]: Pkm.LARVESTA,
  [Pkm.VOLCARONA]: Pkm.LARVESTA,
  [Pkm.LANDORUS]: Pkm.LANDORUS,
  [Pkm.TORNADUS]: Pkm.TORNADUS,
  [Pkm.THUNDURUS]: Pkm.THUNDURUS,
  [Pkm.ENAMORUS]: Pkm.ENAMORUS,
  [Pkm.KELDEO]: Pkm.KELDEO,
  [Pkm.TERRAKION]: Pkm.TERRAKION,
  [Pkm.VIRIZION]: Pkm.VIRIZION,
  [Pkm.COBALION]: Pkm.COBALION,
  [Pkm.MANAPHY]: Pkm.MANAPHY,
  [Pkm.ROTOM]: Pkm.ROTOM,
  [Pkm.ROTOM_HEAT]: Pkm.ROTOM,
  [Pkm.ROTOM_WASH]: Pkm.ROTOM,
  [Pkm.ROTOM_FROST]: Pkm.ROTOM,
  [Pkm.ROTOM_FAN]: Pkm.ROTOM,
  [Pkm.ROTOM_MOW]: Pkm.ROTOM,
  [Pkm.ROTOM_DRONE]: Pkm.ROTOM,
  [Pkm.SPIRITOMB]: Pkm.SPIRITOMB,
  [Pkm.ABSOL]: Pkm.ABSOL,
  [Pkm.LAPRAS]: Pkm.LAPRAS,
  [Pkm.LATIAS]: Pkm.LATIAS,
  [Pkm.LATIOS]: Pkm.LATIOS, // not the same family than latias so they count as two for their synergies
  [Pkm.MESPRIT]: Pkm.MESPRIT,
  [Pkm.AZELF]: Pkm.AZELF,
  [Pkm.UXIE]: Pkm.UXIE,
  [Pkm.MEWTWO]: Pkm.MEWTWO,
  [Pkm.SHADOW_MEWTWO]: Pkm.SHADOW_MEWTWO,
  [Pkm.KYUREM]: Pkm.KYUREM,
  [Pkm.RESHIRAM]: Pkm.RESHIRAM,
  [Pkm.ZEKROM]: Pkm.ZEKROM,
  [Pkm.CELEBI]: Pkm.CELEBI,
  [Pkm.VICTINI]: Pkm.VICTINI,
  [Pkm.JIRACHI]: Pkm.JIRACHI,
  [Pkm.ARCEUS]: Pkm.ARCEUS,
  [Pkm.ARCEUS_BUG]: Pkm.ARCEUS,
  [Pkm.ARCEUS_DARK]: Pkm.ARCEUS,
  [Pkm.ARCEUS_DRAGON]: Pkm.ARCEUS,
  [Pkm.ARCEUS_ELECTRIC]: Pkm.ARCEUS,
  [Pkm.ARCEUS_FIGHTING]: Pkm.ARCEUS,
  [Pkm.ARCEUS_FIRE]: Pkm.ARCEUS,
  [Pkm.ARCEUS_FLYING]: Pkm.ARCEUS,
  [Pkm.ARCEUS_GHOST]: Pkm.ARCEUS,
  [Pkm.ARCEUS_GRASS]: Pkm.ARCEUS,
  [Pkm.ARCEUS_GROUND]: Pkm.ARCEUS,
  [Pkm.ARCEUS_ICE]: Pkm.ARCEUS,
  [Pkm.ARCEUS_POISON]: Pkm.ARCEUS,
  [Pkm.ARCEUS_PSYCHIC]: Pkm.ARCEUS,
  [Pkm.ARCEUS_ROCK]: Pkm.ARCEUS,
  [Pkm.ARCEUS_STEEL]: Pkm.ARCEUS,
  [Pkm.ARCEUS_WATER]: Pkm.ARCEUS,
  [Pkm.ARCEUS_FAIRY]: Pkm.ARCEUS,
  [Pkm.SHAYMIN]: Pkm.SHAYMIN,
  [Pkm.CRESSELIA]: Pkm.CRESSELIA,
  [Pkm.HEATRAN]: Pkm.HEATRAN,
  [Pkm.HO_OH]: Pkm.HO_OH,
  [Pkm.REGICE]: Pkm.REGICE,
  [Pkm.REGISTEEL]: Pkm.REGISTEEL,
  [Pkm.REGIROCK]: Pkm.REGIROCK,
  [Pkm.ARTICUNO]: Pkm.ARTICUNO,
  [Pkm.GALARIAN_ARTICUNO]: Pkm.GALARIAN_ARTICUNO,
  [Pkm.ZAPDOS]: Pkm.ZAPDOS,
  [Pkm.GALARIAN_ZAPDOS]: Pkm.GALARIAN_ZAPDOS,
  [Pkm.MOLTRES]: Pkm.MOLTRES,
  [Pkm.GALARIAN_MOLTRES]: Pkm.GALARIAN_MOLTRES,
  [Pkm.AERODACTYL]: Pkm.AERODACTYL,
  [Pkm.GROUDON]: Pkm.GROUDON,
  [Pkm.KYOGRE]: Pkm.KYOGRE,
  [Pkm.RAYQUAZA]: Pkm.RAYQUAZA,
  [Pkm.MEGA_RAYQUAZA]: Pkm.RAYQUAZA,
  [Pkm.PALKIA]: Pkm.PALKIA,
  [Pkm.DIALGA]: Pkm.DIALGA,
  [Pkm.GIRATINA]: Pkm.GIRATINA,
  [Pkm.SUICUNE]: Pkm.SUICUNE,
  [Pkm.ENTEI]: Pkm.ENTEI,
  [Pkm.RAIKOU]: Pkm.RAIKOU,
  [Pkm.REGIGIGAS]: Pkm.REGIGIGAS,
  [Pkm.MAGIKARP]: Pkm.MAGIKARP,
  [Pkm.GYARADOS]: Pkm.MAGIKARP,
  [Pkm.RATTATA]: Pkm.RATTATA,
  [Pkm.ALOLAN_RATTATA]: Pkm.ALOLAN_RATTATA,
  [Pkm.RATICATE]: Pkm.RATTATA,
  [Pkm.ALOLAN_RATICATE]: Pkm.ALOLAN_RATTATA,
  [Pkm.LUGIA]: Pkm.LUGIA,
  [Pkm.SHADOW_LUGIA]: Pkm.LUGIA,
  [Pkm.CARVANHA]: Pkm.CARVANHA,
  [Pkm.SWABLU]: Pkm.SWABLU,
  [Pkm.PRIMAL_GROUDON]: Pkm.GROUDON,
  [Pkm.PRIMAL_KYOGRE]: Pkm.KYOGRE,
  [Pkm.FEAROW]: Pkm.SPEAROW,
  [Pkm.SPEAROW]: Pkm.SPEAROW,
  [Pkm.MEOWTH]: Pkm.MEOWTH,
  [Pkm.PERSIAN]: Pkm.MEOWTH,
  [Pkm.ALOLAN_MEOWTH]: Pkm.ALOLAN_MEOWTH,
  [Pkm.ALOLAN_PERSIAN]: Pkm.ALOLAN_MEOWTH,
  [Pkm.DEINO]: Pkm.DEINO,
  [Pkm.ZWEILOUS]: Pkm.DEINO,
  [Pkm.HYDREIGON]: Pkm.DEINO,
  [Pkm.SANDILE]: Pkm.SANDILE,
  [Pkm.KROKOROK]: Pkm.SANDILE,
  [Pkm.KROOKODILE]: Pkm.SANDILE,
  [Pkm.SOLOSIS]: Pkm.SOLOSIS,
  [Pkm.DUOSION]: Pkm.SOLOSIS,
  [Pkm.REUNICLUS]: Pkm.SOLOSIS,
  [Pkm.ODDISH]: Pkm.ODDISH,
  [Pkm.GLOOM]: Pkm.ODDISH,
  [Pkm.VILEPLUME]: Pkm.ODDISH,
  [Pkm.BELLOSSOM]: Pkm.BELLOSSOM,
  [Pkm.AMAURA]: Pkm.AMAURA,
  [Pkm.AURORUS]: Pkm.AMAURA,
  [Pkm.ANORITH]: Pkm.ANORITH,
  [Pkm.ARMALDO]: Pkm.ANORITH,
  [Pkm.ARCHEN]: Pkm.ARCHEN,
  [Pkm.ARCHEOPS]: Pkm.ARCHEN,
  [Pkm.SHIELDON]: Pkm.SHIELDON,
  [Pkm.BASTIODON]: Pkm.SHIELDON,
  //[Pkm.TIRTOUGA]: Pkm.TIRTOUGA,
  //[Pkm.CARRACOSTA]: Pkm.TIRTOUGA,
  [Pkm.LILEEP]: Pkm.LILEEP,
  [Pkm.CRADILY]: Pkm.LILEEP,
  [Pkm.KABUTO]: Pkm.KABUTO,
  [Pkm.KABUTOPS]: Pkm.KABUTO,
  [Pkm.OMANYTE]: Pkm.OMANYTE,
  [Pkm.OMASTAR]: Pkm.OMANYTE,
  [Pkm.CRANIDOS]: Pkm.CRANIDOS,
  [Pkm.RAMPARDOS]: Pkm.CRANIDOS,
  [Pkm.TYRUNT]: Pkm.TYRUNT,
  [Pkm.TYRANTRUM]: Pkm.TYRUNT,
  [Pkm.BUDEW]: Pkm.BUDEW,
  [Pkm.ROSELIA]: Pkm.BUDEW,
  [Pkm.ROSERADE]: Pkm.BUDEW,
  [Pkm.BUNEARY]: Pkm.BUNEARY,
  [Pkm.LOPUNNY]: Pkm.BUNEARY,
  //[Pkm.MEGA_LOPUNNY]: Pkm.BUNEARY,
  [Pkm.AXEW]: Pkm.AXEW,
  [Pkm.FRAXURE]: Pkm.AXEW,
  [Pkm.HAXORUS]: Pkm.AXEW,
  [Pkm.VENIPEDE]: Pkm.VENIPEDE,
  [Pkm.WHIRLIPEDE]: Pkm.VENIPEDE,
  [Pkm.SCOLIPEDE]: Pkm.VENIPEDE,
  [Pkm.PORYGON]: Pkm.PORYGON,
  [Pkm.PORYGON_2]: Pkm.PORYGON,
  [Pkm.PORYGON_Z]: Pkm.PORYGON,
  [Pkm.ELECTRIKE]: Pkm.ELECTRIKE,
  [Pkm.MANECTRIC]: Pkm.ELECTRIKE,
  //[Pkm.MEGA_MANECTRIC]: Pkm.ELECTRIKE,
  [Pkm.SHUPPET]: Pkm.SHUPPET,
  [Pkm.BANETTE]: Pkm.SHUPPET,
  //[Pkm.MEGA_BANETTE]: Pkm.SHUPPET,
  [Pkm.HONEDGE]: Pkm.HONEDGE,
  [Pkm.DOUBLADE]: Pkm.HONEDGE,
  [Pkm.AEGISLASH]: Pkm.HONEDGE,
  [Pkm.AEGISLASH_BLADE]: Pkm.HONEDGE,
  [Pkm.CUBONE]: Pkm.CUBONE,
  [Pkm.MAROWAK]: Pkm.CUBONE,
  [Pkm.ALOLAN_MAROWAK]: Pkm.CUBONE,
  [Pkm.WHISMUR]: Pkm.WHISMUR,
  [Pkm.LOUDRED]: Pkm.WHISMUR,
  [Pkm.EXPLOUD]: Pkm.WHISMUR,
  [Pkm.TYMPOLE]: Pkm.TYMPOLE,
  [Pkm.PALPITOAD]: Pkm.TYMPOLE,
  [Pkm.SEISMITOAD]: Pkm.TYMPOLE,
  [Pkm.SEWADDLE]: Pkm.SEWADDLE,
  [Pkm.SWADLOON]: Pkm.SEWADDLE,
  [Pkm.LEAVANNY]: Pkm.SEWADDLE,
  //[Pkm.PIKIPEK]: Pkm.PIKIPEK,
  //[Pkm.TRUMBEAK]: Pkm.PIKIPEK,
  //[Pkm.TOUCANNON]: Pkm.PIKIPEK,
  [Pkm.FLABEBE]: Pkm.FLABEBE,
  [Pkm.FLOETTE]: Pkm.FLABEBE,
  [Pkm.FLORGES]: Pkm.FLABEBE,
  [Pkm.FLABEBE_BLUE]: Pkm.FLABEBE_BLUE,
  [Pkm.FLOETTE_BLUE]: Pkm.FLABEBE_BLUE,
  [Pkm.FLORGES_BLUE]: Pkm.FLABEBE_BLUE,
  [Pkm.FLABEBE_ORANGE]: Pkm.FLABEBE_ORANGE,
  [Pkm.FLOETTE_ORANGE]: Pkm.FLABEBE_ORANGE,
  [Pkm.FLORGES_ORANGE]: Pkm.FLABEBE_ORANGE,
  [Pkm.FLABEBE_WHITE]: Pkm.FLABEBE_WHITE,
  [Pkm.FLOETTE_WHITE]: Pkm.FLABEBE_WHITE,
  [Pkm.FLORGES_WHITE]: Pkm.FLABEBE_WHITE,
  [Pkm.FLABEBE_YELLOW]: Pkm.FLABEBE_YELLOW,
  [Pkm.FLOETTE_YELLOW]: Pkm.FLABEBE_YELLOW,
  [Pkm.FLORGES_YELLOW]: Pkm.FLABEBE_YELLOW,
  [Pkm.JANGMO_O]: Pkm.JANGMO_O,
  [Pkm.HAKAMO_O]: Pkm.JANGMO_O,
  [Pkm.KOMMO_O]: Pkm.JANGMO_O,
  [Pkm.MELOETTA]: Pkm.MELOETTA,
  [Pkm.ALTARIA]: Pkm.SWABLU,
  //[Pkm.MEGA_ALTARIA]: Pkm.SWABLU,
  [Pkm.CASTFORM]: Pkm.CASTFORM,
  [Pkm.CASTFORM_SUN]: Pkm.CASTFORM,
  [Pkm.CASTFORM_RAIN]: Pkm.CASTFORM,
  [Pkm.CASTFORM_HAIL]: Pkm.CASTFORM,
  [Pkm.CORPHISH]: Pkm.CORPHISH,
  [Pkm.CRAWDAUNT]: Pkm.CORPHISH,
  [Pkm.JOLTIK]: Pkm.JOLTIK,
  [Pkm.GALVANTULA]: Pkm.JOLTIK,
  [Pkm.DEFAULT]: Pkm.DEFAULT,
  [Pkm.NINCADA]: Pkm.NINCADA,
  [Pkm.NINJASK]: Pkm.NINCADA,
  [Pkm.SHEDINJA]: Pkm.SHEDINJA,
  [Pkm.PONYTA]: Pkm.PONYTA,
  [Pkm.RAPIDASH]: Pkm.PONYTA,
  [Pkm.GALARIAN_PONYTA]: Pkm.GALARIAN_PONYTA,
  [Pkm.GALARIAN_RAPIDASH]: Pkm.GALARIAN_PONYTA,
  [Pkm.GENESECT]: Pkm.GENESECT,
  [Pkm.RELICANTH]: Pkm.RELICANTH,
  [Pkm.HATENNA]: Pkm.HATENNA,
  [Pkm.HATTREM]: Pkm.HATENNA,
  [Pkm.HATTERENE]: Pkm.HATENNA,
  [Pkm.FENNEKIN]: Pkm.FENNEKIN,
  [Pkm.BRAIXEN]: Pkm.FENNEKIN,
  [Pkm.DELPHOX]: Pkm.FENNEKIN,
  [Pkm.MAKUHITA]: Pkm.MAKUHITA,
  [Pkm.HARIYAMA]: Pkm.MAKUHITA,
  [Pkm.REGIELEKI]: Pkm.REGIELEKI,
  [Pkm.REGIDRAGO]: Pkm.REGIDRAGO,
  [Pkm.GUZZLORD]: Pkm.GUZZLORD,
  [Pkm.ETERNATUS]: Pkm.ETERNATUS,
  [Pkm.NOIBAT]: Pkm.NOIBAT,
  [Pkm.NOIVERN]: Pkm.NOIBAT,
  [Pkm.PUMPKABOO]: Pkm.PUMPKABOO,
  [Pkm.GOURGEIST]: Pkm.PUMPKABOO,
  [Pkm.CACNEA]: Pkm.CACNEA,
  [Pkm.CACTURNE]: Pkm.CACNEA,
  [Pkm.TAUROS]: Pkm.TAUROS,
  [Pkm.TAUROS_COMBAT_BREED]: Pkm.TAUROS,
  [Pkm.TAUROS_BLAZE_BREED]: Pkm.TAUROS,
  [Pkm.TAUROS_AQUA_BREED]: Pkm.TAUROS,
  [Pkm.HAPPINY]: Pkm.HAPPINY,
  [Pkm.CHANSEY]: Pkm.HAPPINY,
  [Pkm.BLISSEY]: Pkm.HAPPINY,
  [Pkm.TAPU_KOKO]: Pkm.TAPU_KOKO,
  [Pkm.TAPU_LELE]: Pkm.TAPU_LELE,
  [Pkm.STAKATAKA]: Pkm.STAKATAKA,
  [Pkm.BLACEPHALON]: Pkm.BLACEPHALON,
  [Pkm.HOUNDOUR]: Pkm.HOUNDOUR,
  [Pkm.HOUNDOOM]: Pkm.HOUNDOUR,
  //[Pkm.MEGA_HOUNDOOM]: Pkm.HOUNDOUR,
  [Pkm.CLAMPERL]: Pkm.CLAMPERL,
  [Pkm.HUNTAIL]: Pkm.CLAMPERL,
  [Pkm.GOREBYSS]: Pkm.CLAMPERL,
  [Pkm.SMOOCHUM]: Pkm.SMOOCHUM,
  [Pkm.JYNX]: Pkm.SMOOCHUM,
  [Pkm.SALANDIT]: Pkm.SALANDIT,
  [Pkm.SALAZZLE]: Pkm.SALANDIT,
  [Pkm.VENONAT]: Pkm.VENONAT,
  [Pkm.VENOMOTH]: Pkm.VENONAT,
  [Pkm.VOLTORB]: Pkm.VOLTORB,
  [Pkm.HISUI_VOLTORB]: Pkm.HISUI_VOLTORB,
  [Pkm.ELECTRODE]: Pkm.VOLTORB,
  [Pkm.HISUI_ELECTRODE]: Pkm.HISUI_VOLTORB,
  [Pkm.SLUGMA]: Pkm.SLUGMA,
  [Pkm.MAGCARGO]: Pkm.SLUGMA,
  [Pkm.SNEASEL]: Pkm.SNEASEL,
  [Pkm.WEAVILE]: Pkm.SNEASEL,
  [Pkm.CROAGUNK]: Pkm.CROAGUNK,
  [Pkm.TOXICROAK]: Pkm.CROAGUNK,
  [Pkm.CHINCHOU]: Pkm.CHINCHOU,
  [Pkm.LANTURN]: Pkm.CHINCHOU,
  [Pkm.POOCHYENA]: Pkm.POOCHYENA,
  [Pkm.MIGHTYENA]: Pkm.POOCHYENA,
  [Pkm.BRONZOR]: Pkm.BRONZOR,
  [Pkm.BRONZONG]: Pkm.BRONZOR,
  [Pkm.DRIFLOON]: Pkm.DRIFLOON,
  [Pkm.DRIFBLIM]: Pkm.DRIFLOON,
  [Pkm.SHROOMISH]: Pkm.SHROOMISH,
  [Pkm.BRELOOM]: Pkm.SHROOMISH,
  [Pkm.TENTACOOL]: Pkm.TENTACOOL,
  [Pkm.TENTACRUEL]: Pkm.TENTACOOL,
  [Pkm.SNUBULL]: Pkm.SNUBULL,
  [Pkm.GRANBULL]: Pkm.SNUBULL,
  [Pkm.SEVIPER]: Pkm.SEVIPER,
  [Pkm.VULPIX]: Pkm.VULPIX,
  [Pkm.NINETALES]: Pkm.VULPIX,
  [Pkm.ALOLAN_VULPIX]: Pkm.ALOLAN_VULPIX,
  [Pkm.ALOLAN_NINETALES]: Pkm.ALOLAN_VULPIX,
  [Pkm.BUIZEL]: Pkm.BUIZEL,
  [Pkm.FLOATZEL]: Pkm.BUIZEL,
  [Pkm.KECLEON]: Pkm.KECLEON,
  [Pkm.MAWILE]: Pkm.MAWILE,
  [Pkm.CARBINK]: Pkm.CARBINK,
  [Pkm.DIANCIE]: Pkm.CARBINK,
  [Pkm.CHATOT]: Pkm.CHATOT,
  [Pkm.GOOMY]: Pkm.GOOMY,
  [Pkm.SLIGOO]: Pkm.GOOMY,
  [Pkm.GOODRA]: Pkm.GOOMY,
  [Pkm.HISUI_SLIGGOO]: Pkm.GOOMY,
  [Pkm.HISUI_GOODRA]: Pkm.GOOMY,
  [Pkm.MEW]: Pkm.MEW,
  [Pkm.BOUNSWEET]: Pkm.BOUNSWEET,
  [Pkm.STEENEE]: Pkm.BOUNSWEET,
  [Pkm.TSAREENA]: Pkm.BOUNSWEET,
  [Pkm.VOLCANION]: Pkm.VOLCANION,
  [Pkm.APPLIN]: Pkm.APPLIN,
  [Pkm.APPLETUN]: Pkm.APPLIN,
  [Pkm.FLAPPLE]: Pkm.APPLIN,
  [Pkm.DIPPLIN]: Pkm.APPLIN,
  [Pkm.HYDRAPPLE]: Pkm.APPLIN,
  [Pkm.OSHAWOTT]: Pkm.OSHAWOTT,
  [Pkm.DEWOTT]: Pkm.OSHAWOTT,
  [Pkm.SAMUROTT]: Pkm.OSHAWOTT,
  [Pkm.HISUI_SAMUROTT]: Pkm.OSHAWOTT,
  [Pkm.SNOM]: Pkm.SNOM,
  [Pkm.FROSMOTH]: Pkm.SNOM,
  [Pkm.WAILMER]: Pkm.WAILMER,
  [Pkm.WAILORD]: Pkm.WAILMER,
  [Pkm.DREEPY]: Pkm.DREEPY,
  [Pkm.DRAKLOAK]: Pkm.DREEPY,
  [Pkm.DRAGAPULT]: Pkm.DREEPY,
  [Pkm.SNIVY]: Pkm.SNIVY,
  [Pkm.SERVINE]: Pkm.SNIVY,
  [Pkm.SERPERIOR]: Pkm.SNIVY,
  [Pkm.SCORBUNNY]: Pkm.SCORBUNNY,
  [Pkm.RABOOT]: Pkm.SCORBUNNY,
  [Pkm.CINDERACE]: Pkm.SCORBUNNY,
  [Pkm.POPPLIO]: Pkm.POPPLIO,
  [Pkm.BRIONNE]: Pkm.POPPLIO,
  [Pkm.PRIMARINA]: Pkm.POPPLIO,
  [Pkm.GOTHITA]: Pkm.GOTHITA,
  [Pkm.GOTHORITA]: Pkm.GOTHITA,
  [Pkm.GOTHITELLE]: Pkm.GOTHITA,
  [Pkm.SANDSHREW]: Pkm.SANDSHREW,
  [Pkm.SANDSLASH]: Pkm.SANDSHREW,
  [Pkm.ALOLAN_SANDSHREW]: Pkm.ALOLAN_SANDSHREW,
  [Pkm.ALOLAN_SANDSLASH]: Pkm.ALOLAN_SANDSHREW,
  [Pkm.FARFETCH_D]: Pkm.FARFETCH_D,
  [Pkm.GALARIAN_FARFETCH_D]: Pkm.GALARIAN_FARFETCH_D,
  [Pkm.UNOWN_A]: Pkm.UNOWN_A,
  [Pkm.UNOWN_B]: Pkm.UNOWN_A,
  [Pkm.UNOWN_C]: Pkm.UNOWN_A,
  [Pkm.UNOWN_D]: Pkm.UNOWN_A,
  [Pkm.UNOWN_E]: Pkm.UNOWN_A,
  [Pkm.UNOWN_F]: Pkm.UNOWN_A,
  [Pkm.UNOWN_G]: Pkm.UNOWN_A,
  [Pkm.UNOWN_H]: Pkm.UNOWN_A,
  [Pkm.UNOWN_I]: Pkm.UNOWN_A,
  [Pkm.UNOWN_J]: Pkm.UNOWN_A,
  [Pkm.UNOWN_K]: Pkm.UNOWN_A,
  [Pkm.UNOWN_L]: Pkm.UNOWN_A,
  [Pkm.UNOWN_M]: Pkm.UNOWN_A,
  [Pkm.UNOWN_N]: Pkm.UNOWN_A,
  [Pkm.UNOWN_O]: Pkm.UNOWN_A,
  [Pkm.UNOWN_P]: Pkm.UNOWN_A,
  [Pkm.UNOWN_Q]: Pkm.UNOWN_A,
  [Pkm.UNOWN_R]: Pkm.UNOWN_A,
  [Pkm.UNOWN_S]: Pkm.UNOWN_A,
  [Pkm.UNOWN_T]: Pkm.UNOWN_A,
  [Pkm.UNOWN_U]: Pkm.UNOWN_A,
  [Pkm.UNOWN_V]: Pkm.UNOWN_A,
  [Pkm.UNOWN_W]: Pkm.UNOWN_A,
  [Pkm.UNOWN_X]: Pkm.UNOWN_A,
  [Pkm.UNOWN_Y]: Pkm.UNOWN_A,
  [Pkm.UNOWN_Z]: Pkm.UNOWN_A,
  [Pkm.UNOWN_QUESTION]: Pkm.UNOWN_A,
  [Pkm.UNOWN_EXCLAMATION]: Pkm.UNOWN_A,
  [Pkm.TAPU_FINI]: Pkm.TAPU_FINI,
  [Pkm.TAPU_BULU]: Pkm.TAPU_BULU,
  [Pkm.DIGLETT]: Pkm.DIGLETT,
  [Pkm.ALOLAN_DIGLETT]: Pkm.ALOLAN_DIGLETT,
  [Pkm.DUGTRIO]: Pkm.DIGLETT,
  [Pkm.ALOLAN_DUGTRIO]: Pkm.ALOLAN_DIGLETT,
  [Pkm.ROWLET]: Pkm.ROWLET,
  [Pkm.DARTIX]: Pkm.ROWLET,
  [Pkm.DECIDUEYE]: Pkm.ROWLET,
  [Pkm.ZORUA]: Pkm.ZORUA,
  [Pkm.ZOROARK]: Pkm.ZORUA,
  [Pkm.FROAKIE]: Pkm.FROAKIE,
  [Pkm.FROGADIER]: Pkm.FROAKIE,
  [Pkm.GRENINJA]: Pkm.FROAKIE,
  [Pkm.TYROGUE]: Pkm.TYROGUE,
  [Pkm.HITMONLEE]: Pkm.TYROGUE,
  [Pkm.HITMONCHAN]: Pkm.TYROGUE,
  [Pkm.HITMONTOP]: Pkm.TYROGUE,
  [Pkm.MIMIKYU]: Pkm.MIMIKYU,
  [Pkm.MIMIKYU_BUSTED]: Pkm.MIMIKYU,
  [Pkm.GRIMER]: Pkm.GRIMER,
  [Pkm.MUK]: Pkm.GRIMER,
  [Pkm.SHARPEDO]: Pkm.CARVANHA,
  [Pkm.HISUI_ZORUA]: Pkm.HISUI_ZORUA,
  [Pkm.HISUI_ZOROARK]: Pkm.HISUI_ZORUA,
  [Pkm.ALOLAN_GRIMER]: Pkm.ALOLAN_GRIMER,
  [Pkm.ALOLAN_MUK]: Pkm.ALOLAN_GRIMER,
  [Pkm.PINECO]: Pkm.PINECO,
  [Pkm.FORRETRESS]: Pkm.PINECO,
  [Pkm.SEEL]: Pkm.SEEL,
  [Pkm.DEWGONG]: Pkm.SEEL,
  [Pkm.ALOLAN_GEODUDE]: Pkm.ALOLAN_GEODUDE,
  [Pkm.ALOLAN_GRAVELER]: Pkm.ALOLAN_GEODUDE,
  [Pkm.ALOLAN_GOLEM]: Pkm.ALOLAN_GEODUDE,
  [Pkm.EKANS]: Pkm.EKANS,
  [Pkm.ARBOK]: Pkm.EKANS,
  [Pkm.MIME_JR]: Pkm.MIME_JR,
  [Pkm.MR_MIME]: Pkm.MIME_JR,
  [Pkm.ORIGIN_GIRATINA]: Pkm.GIRATINA,
  [Pkm.PIROUETTE_MELOETTA]: Pkm.MELOETTA,
  [Pkm.MELTAN]: Pkm.MELTAN,
  [Pkm.MELMETAL]: Pkm.MELMETAL,
  [Pkm.HOOPA]: Pkm.HOOPA,
  [Pkm.HOOPA_UNBOUND]: Pkm.HOOPA,
  [Pkm.SILVALLY]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_FIGHTING]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_FLYING]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_POISON]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_GROUND]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_ROCK]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_BUG]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_GHOST]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_STEEL]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_FIRE]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_WATER]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_GRASS]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_ELECTRIC]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_PSYCHIC]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_ICE]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_DRAGON]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_DARK]: Pkm.TYPE_NULL,
  [Pkm.SILVALLY_FAIRY]: Pkm.TYPE_NULL,
  [Pkm.ZERAORA]: Pkm.ZERAORA,
  [Pkm.XERNEAS]: Pkm.XERNEAS,
  [Pkm.YVELTAL]: Pkm.YVELTAL,
  [Pkm.TYPE_NULL]: Pkm.TYPE_NULL,
  [Pkm.MARSHADOW]: Pkm.MARSHADOW,
  [Pkm.HOOTHOOT]: Pkm.HOOTHOOT,
  [Pkm.NOCTOWL]: Pkm.HOOTHOOT,
  [Pkm.BONSLEY]: Pkm.BONSLEY,
  [Pkm.SUDOWOODO]: Pkm.BONSLEY,
  [Pkm.PHIONE]: Pkm.PHIONE,
  [Pkm.COMBEE]: Pkm.COMBEE,
  [Pkm.VESPIQUEEN]: Pkm.COMBEE,
  [Pkm.SHUCKLE]: Pkm.SHUCKLE,
  [Pkm.TEPIG]: Pkm.TEPIG,
  [Pkm.PIGNITE]: Pkm.TEPIG,
  [Pkm.EMBOAR]: Pkm.TEPIG,
  [Pkm.WYNAUT]: Pkm.WYNAUT,
  [Pkm.WOBBUFFET]: Pkm.WYNAUT,
  [Pkm.LUNATONE]: Pkm.LUNATONE,
  [Pkm.SOLROCK]: Pkm.SOLROCK,
  [Pkm.POLIWRATH]: Pkm.POLIWAG,
  [Pkm.SHAYMIN_SKY]: Pkm.SHAYMIN,
  [Pkm.WURMPLE]: Pkm.WURMPLE,
  [Pkm.SILCOON]: Pkm.WURMPLE,
  [Pkm.BEAUTIFLY]: Pkm.WURMPLE,
  [Pkm.CASCOON]: Pkm.WURMPLE,
  [Pkm.DUSTOX]: Pkm.WURMPLE,
  [Pkm.TINKATINK]: Pkm.TINKATINK,
  [Pkm.TINKATUFF]: Pkm.TINKATINK,
  [Pkm.TINKATON]: Pkm.TINKATINK,
  [Pkm.PARAS]: Pkm.PARAS,
  [Pkm.PARASECT]: Pkm.PARAS,
  [Pkm.MILTANK]: Pkm.MILTANK,
  [Pkm.MANKEY]: Pkm.MANKEY,
  [Pkm.PRIMEAPE]: Pkm.MANKEY,
  [Pkm.ANNIHILAPE]: Pkm.MANKEY,
  [Pkm.SUNKERN]: Pkm.SUNKERN,
  [Pkm.SUNFLORA]: Pkm.SUNKERN,
  [Pkm.MARACTUS]: Pkm.MARACTUS,
  [Pkm.PLUSLE]: Pkm.PLUSLE,
  [Pkm.MINUN]: Pkm.MINUN,
  [Pkm.PINSIR]: Pkm.PINSIR,
  [Pkm.NATU]: Pkm.NATU,
  [Pkm.XATU]: Pkm.NATU,
  [Pkm.GLIGAR]: Pkm.GLIGAR,
  [Pkm.GLISCOR]: Pkm.GLIGAR,
  [Pkm.SHELLDER]: Pkm.SHELLDER,
  [Pkm.CLOYSTER]: Pkm.SHELLDER,
  [Pkm.SENTRET]: Pkm.SENTRET,
  [Pkm.FURRET]: Pkm.SENTRET,
  [Pkm.SPECTRIER]: Pkm.SPECTRIER,
  [Pkm.TORKOAL]: Pkm.TORKOAL,
  [Pkm.DELIBIRD]: Pkm.DELIBIRD,
  [Pkm.IRON_BUNDLE]: Pkm.IRON_BUNDLE,
  [Pkm.KARTANA]: Pkm.KARTANA,
  [Pkm.CHINGLING]: Pkm.CHINGLING,
  [Pkm.CHIMECHO]: Pkm.CHINGLING,
  [Pkm.ALOLAN_RAICHU]: Pkm.PICHU,
  [Pkm.DHELMISE]: Pkm.DHELMISE,
  [Pkm.KOFFING]: Pkm.KOFFING,
  [Pkm.WEEZING]: Pkm.KOFFING,
  [Pkm.GALARIAN_WEEZING]: Pkm.KOFFING,
  [Pkm.STARYU]: Pkm.STARYU,
  [Pkm.STARMIE]: Pkm.STARYU,
  [Pkm.NOSEPASS]: Pkm.NOSEPASS,
  [Pkm.PROBOPASS]: Pkm.NOSEPASS,
  [Pkm.WOOBAT]: Pkm.WOOBAT,
  [Pkm.SWOOBAT]: Pkm.WOOBAT,
  [Pkm.CLAUNCHER]: Pkm.CLAUNCHER,
  [Pkm.CLAWITZER]: Pkm.CLAUNCHER,
  [Pkm.YANMA]: Pkm.YANMA,
  [Pkm.YANMEGA]: Pkm.YANMA,
  [Pkm.HELIOPTILE]: Pkm.HELIOPTILE,
  [Pkm.HELIOLISK]: Pkm.HELIOPTILE,
  [Pkm.BIDOOF]: Pkm.BIDOOF,
  [Pkm.BIBAREL]: Pkm.BIDOOF,
  [Pkm.SPINDA]: Pkm.SPINDA,
  [Pkm.BALTOY]: Pkm.BALTOY,
  [Pkm.CLAYDOL]: Pkm.BALTOY,
  [Pkm.HERACROSS]: Pkm.HERACROSS,
  [Pkm.PURRLOIN]: Pkm.PURRLOIN,
  [Pkm.LIEPARD]: Pkm.PURRLOIN,
  [Pkm.BARBOACH]: Pkm.BARBOACH,
  [Pkm.WHISCASH]: Pkm.BARBOACH,
  [Pkm.SCRAGGY]: Pkm.SCRAGGY,
  [Pkm.SCRAFTY]: Pkm.SCRAGGY,
  [Pkm.FINNEON]: Pkm.FINNEON,
  [Pkm.LUMINEON]: Pkm.FINNEON,
  [Pkm.STUNKY]: Pkm.STUNKY,
  [Pkm.SKUNTANK]: Pkm.STUNKY,
  [Pkm.ILLUMISE]: Pkm.ILLUMISE,
  [Pkm.VOLBEAT]: Pkm.VOLBEAT,
  [Pkm.NECROZMA]: Pkm.NECROZMA,
  [Pkm.ULTRA_NECROZMA]: Pkm.NECROZMA,
  [Pkm.CHERUBI]: Pkm.CHERUBI,
  [Pkm.CHERRIM]: Pkm.CHERUBI,
  [Pkm.CHERRIM_SUNLIGHT]: Pkm.CHERUBI,
  [Pkm.MISDREAVUS]: Pkm.MISDREAVUS,
  [Pkm.MISMAGIUS]: Pkm.MISDREAVUS,
  [Pkm.DODUO]: Pkm.DODUO,
  [Pkm.DODRIO]: Pkm.DODUO,
  [Pkm.XURKITREE]: Pkm.XURKITREE,
  [Pkm.TANDEMAUS]: Pkm.TANDEMAUS,
  [Pkm.MAUSHOLD_THREE]: Pkm.TANDEMAUS,
  [Pkm.MAUSHOLD_FOUR]: Pkm.TANDEMAUS,
  [Pkm.KRICKETOT]: Pkm.KRICKETOT,
  [Pkm.KRICKETUNE]: Pkm.KRICKETOT,
  [Pkm.HIPPOPOTAS]: Pkm.HIPPOPOTAS,
  [Pkm.HIPPODOWN]: Pkm.HIPPOPOTAS,
  [Pkm.WINGULL]: Pkm.WINGULL,
  [Pkm.PELIPPER]: Pkm.WINGULL,
  [Pkm.NIHILEGO]: Pkm.NIHILEGO,
  [Pkm.SOBBLE]: Pkm.SOBBLE,
  [Pkm.DRIZZILE]: Pkm.SOBBLE,
  [Pkm.INTELEON]: Pkm.SOBBLE,
  [Pkm.TROPIUS]: Pkm.TROPIUS,
  [Pkm.EXEGGCUTE]: Pkm.EXEGGCUTE,
  [Pkm.EXEGGUTOR]: Pkm.EXEGGCUTE,
  [Pkm.ALOLAN_EXEGGUTOR]: Pkm.EXEGGCUTE,
  [Pkm.COMFEY]: Pkm.COMFEY,
  [Pkm.CARNIVINE]: Pkm.CARNIVINE,
  [Pkm.QWILFISH]: Pkm.QWILFISH,
  [Pkm.HISUIAN_QWILFISH]: Pkm.HISUIAN_QWILFISH,
  [Pkm.OVERQWIL]: Pkm.HISUIAN_QWILFISH,
  [Pkm.HISUIAN_TYPHLOSION]: Pkm.CYNDAQUIL,
  [Pkm.LILLIPUP]: Pkm.LILLIPUP,
  [Pkm.HERDIER]: Pkm.LILLIPUP,
  [Pkm.STOUTLAND]: Pkm.LILLIPUP,
  [Pkm.ZIGZAGOON]: Pkm.ZIGZAGOON,
  [Pkm.LINOONE]: Pkm.ZIGZAGOON,
  [Pkm.GALARIAN_ZIGZAGOON]: Pkm.GALARIAN_ZIGZAGOON,
  [Pkm.GALARIAN_LINOONE]: Pkm.GALARIAN_ZIGZAGOON,
  [Pkm.OBSTAGOON]: Pkm.GALARIAN_ZIGZAGOON,
  [Pkm.PHEROMOSA]: Pkm.PHEROMOSA,
  [Pkm.SABLEYE]: Pkm.SABLEYE,
  [Pkm.MEGA_SABLEYE]: Pkm.SABLEYE,
  [Pkm.DRACOVISH]: Pkm.DRACOVISH,
  [Pkm.CORSOLA]: Pkm.CORSOLA,
  [Pkm.GALAR_CORSOLA]: Pkm.CORSOLA,
  [Pkm.CURSOLA]: Pkm.CORSOLA,
  [Pkm.GIMMIGHOUL]: Pkm.GIMMIGHOUL,
  [Pkm.GHOLDENGO]: Pkm.GIMMIGHOUL,
  [Pkm.PHANTUMP]: Pkm.PHANTUMP,
  [Pkm.TREVENANT]: Pkm.PHANTUMP,
  [Pkm.SMEARGLE]: Pkm.SMEARGLE,
  [Pkm.TOXEL]: Pkm.TOXEL,
  [Pkm.TOXTRICITY]: Pkm.TOXEL,
  [Pkm.BRUXISH]: Pkm.BRUXISH,
  [Pkm.SUBSTITUTE]: Pkm.SUBSTITUTE,
  [Pkm.CYCLIZAR]: Pkm.CYCLIZAR,
  [Pkm.PAWNIARD]: Pkm.PAWNIARD,
  [Pkm.BISHARP]: Pkm.PAWNIARD,
  [Pkm.KINGAMBIT]: Pkm.PAWNIARD,
  [Pkm.MINIOR]: Pkm.MINIOR,
  [Pkm.MINIOR_KERNEL_RED]: Pkm.MINIOR,
  [Pkm.MINIOR_KERNEL_BLUE]: Pkm.MINIOR,
  [Pkm.MINIOR_KERNEL_ORANGE]: Pkm.MINIOR,
  [Pkm.MINIOR_KERNEL_GREEN]: Pkm.MINIOR,
  [Pkm.FEEBAS]: Pkm.FEEBAS,
  [Pkm.MILOTIC]: Pkm.FEEBAS,
  [Pkm.MORPEKO]: Pkm.MORPEKO,
  [Pkm.MORPEKO_HANGRY]: Pkm.MORPEKO,
  [Pkm.KANGASKHAN]: Pkm.KANGASKHAN,
  [Pkm.TEDDIURSA]: Pkm.TEDDIURSA,
  [Pkm.URSARING]: Pkm.TEDDIURSA,
  [Pkm.URSALUNA]: Pkm.TEDDIURSA,
  [Pkm.URSALUNA_BLOODMOON]: Pkm.TEDDIURSA,
  [Pkm.AIPOM]: Pkm.AIPOM,
  [Pkm.AMBIPOM]: Pkm.AIPOM,
  [Pkm.DEERLING_SPRING]: Pkm.DEERLING_SPRING,
  [Pkm.DEERLING_SUMMER]: Pkm.DEERLING_SUMMER,
  [Pkm.DEERLING_AUTUMN]: Pkm.DEERLING_AUTUMN,
  [Pkm.DEERLING_WINTER]: Pkm.DEERLING_WINTER,
  [Pkm.SAWSBUCK_SPRING]: Pkm.DEERLING_SPRING,
  [Pkm.SAWSBUCK_SUMMER]: Pkm.DEERLING_SUMMER,
  [Pkm.SAWSBUCK_AUTUMN]: Pkm.DEERLING_AUTUMN,
  [Pkm.SAWSBUCK_WINTER]: Pkm.DEERLING_WINTER,
  [Pkm.LICKITUNG]: Pkm.LICKITUNG,
  [Pkm.LICKILICKY]: Pkm.LICKITUNG,
  [Pkm.PATRAT]: Pkm.PATRAT,
  [Pkm.WATCHOG]: Pkm.PATRAT,
  [Pkm.SPINARAK]: Pkm.SPINARAK,
  [Pkm.ARIADOS]: Pkm.SPINARAK,
  [Pkm.DEWPIDER]: Pkm.DEWPIDER,
  [Pkm.ARAQUANID]: Pkm.DEWPIDER,
  [Pkm.ROCKRUFF]: Pkm.ROCKRUFF,
  [Pkm.LYCANROC_DAY]: Pkm.ROCKRUFF,
  [Pkm.LYCANROC_DUSK]: Pkm.ROCKRUFF,
  [Pkm.LYCANROC_NIGHT]: Pkm.ROCKRUFF,
  [Pkm.DRUDDIGON]: Pkm.DRUDDIGON,
  [Pkm.COSMOG]: Pkm.COSMOG,
  [Pkm.COSMOEM]: Pkm.COSMOG,
  [Pkm.SOLGALEO]: Pkm.COSMOG,
  [Pkm.LUNALA]: Pkm.COSMOG,
  [Pkm.MAGEARNA]: Pkm.MAGEARNA,
  [Pkm.IMPIDIMP]: Pkm.IMPIDIMP,
  [Pkm.MORGREM]: Pkm.IMPIDIMP,
  [Pkm.GRIMMSNARL]: Pkm.IMPIDIMP,
  [Pkm.DEOXYS]: Pkm.DEOXYS,
  [Pkm.DEOXYS_DEFENSE]: Pkm.DEOXYS,
  [Pkm.DEOXYS_ATTACK]: Pkm.DEOXYS,
  [Pkm.DEOXYS_SPEED]: Pkm.DEOXYS,
  [Pkm.CRABRAWLER]: Pkm.CRABRAWLER,
  [Pkm.CRABOMINABLE]: Pkm.CRABRAWLER,
  [Pkm.CUTIEFLY]: Pkm.CUTIEFLY,
  [Pkm.RIBOMBEE]: Pkm.CUTIEFLY,
  [Pkm.ZANGOOSE]: Pkm.ZANGOOSE,
  [Pkm.NICKIT]: Pkm.NICKIT,
  [Pkm.THIEVUL]: Pkm.NICKIT,
  [Pkm.DROWZEE]: Pkm.DROWZEE,
  [Pkm.HYPNO]: Pkm.DROWZEE,
  [Pkm.WATTREL]: Pkm.WATTREL,
  [Pkm.KILOWATTREL]: Pkm.WATTREL,
  [Pkm.STANTLER]: Pkm.STANTLER,
  [Pkm.WYRDEER]: Pkm.STANTLER,
  [Pkm.BURMY_PLANT]: Pkm.BURMY_PLANT,
  [Pkm.BURMY_SANDY]: Pkm.BURMY_SANDY,
  [Pkm.BURMY_TRASH]: Pkm.BURMY_TRASH,
  [Pkm.WORMADAM_PLANT]: Pkm.BURMY_PLANT,
  [Pkm.WORMADAM_SANDY]: Pkm.BURMY_SANDY,
  [Pkm.WORMADAM_TRASH]: Pkm.BURMY_TRASH,
  [Pkm.MOTHIM]: Pkm.BURMY_PLANT, // NOTE: converging evolution
  [Pkm.WOOPER]: Pkm.WOOPER,
  [Pkm.QUAGSIRE]: Pkm.WOOPER,
  [Pkm.PALDEA_WOOPER]: Pkm.PALDEA_WOOPER,
  [Pkm.CLODSIRE]: Pkm.PALDEA_WOOPER,
  [Pkm.FUECOCO]: Pkm.FUECOCO,
  [Pkm.CROCALOR]: Pkm.FUECOCO,
  [Pkm.SKELEDIRGE]: Pkm.FUECOCO,
  [Pkm.TANGELA]: Pkm.TANGELA,
  [Pkm.TANGROWTH]: Pkm.TANGELA,
  [Pkm.PSYDUCK]: Pkm.PSYDUCK,
  [Pkm.GOLDUCK]: Pkm.PSYDUCK,
  [Pkm.PHANPY]: Pkm.PHANPY,
  [Pkm.DONPHAN]: Pkm.PHANPY,
  [Pkm.SPOINK]: Pkm.SPOINK,
  [Pkm.GRUMPIG]: Pkm.SPOINK,
  [Pkm.SINISTEA]: Pkm.SINISTEA,
  [Pkm.POLTEAGEIST]: Pkm.SINISTEA,
  [Pkm.FERROSEED]: Pkm.FERROSEED,
  [Pkm.FERROTHORN]: Pkm.FERROSEED,
  [Pkm.GOLETT]: Pkm.GOLETT,
  [Pkm.GOLURK]: Pkm.GOLETT,
  [Pkm.TRUBBISH]: Pkm.TRUBBISH,
  [Pkm.GARBODOR]: Pkm.TRUBBISH,
  [Pkm.GRUBBIN]: Pkm.GRUBBIN,
  [Pkm.CHARJABUG]: Pkm.GRUBBIN,
  [Pkm.VIKAVOLT]: Pkm.GRUBBIN,
  [Pkm.SHELLOS_WEST_SEA]: Pkm.SHELLOS_WEST_SEA,
  [Pkm.GASTRODON_WEST_SEA]: Pkm.SHELLOS_WEST_SEA,
  [Pkm.SHELLOS_EAST_SEA]: Pkm.SHELLOS_EAST_SEA,
  [Pkm.GASTRODON_EAST_SEA]: Pkm.SHELLOS_EAST_SEA,
  [Pkm.MUNNA]: Pkm.MUNNA,
  [Pkm.MUSHARNA]: Pkm.MUNNA,
  [Pkm.RUFFLET]: Pkm.RUFFLET,
  [Pkm.BRAVIARY]: Pkm.RUFFLET,
  [Pkm.HEATMOR]: Pkm.HEATMOR,
  [Pkm.KLEFKI]: Pkm.KLEFKI,
  [Pkm.HAWLUCHA]: Pkm.HAWLUCHA,
  [Pkm.MIENFOO]: Pkm.MIENFOO,
  [Pkm.MIENSHAO]: Pkm.MIENFOO,
  [Pkm.STONJOURNER]: Pkm.STONJOURNER,
  [Pkm.HISUI_SNEASEL]: Pkm.HISUI_SNEASEL,
  [Pkm.SNEASLER]: Pkm.HISUI_SNEASEL,
  [Pkm.PYUKUMUKU]: Pkm.PYUKUMUKU,
  [Pkm.POIPOLE]: Pkm.POIPOLE,
  [Pkm.NAGANADEL]: Pkm.POIPOLE,
  [Pkm.CRAMORANT]: Pkm.CRAMORANT,
  [Pkm.ARROKUDA]: Pkm.ARROKUDA,
  [Pkm.WISHIWASHI]: Pkm.WISHIWASHI,
  [Pkm.WISHIWASHI_SCHOOL]: Pkm.WISHIWASHI,
  [Pkm.PAWMI]: Pkm.PAWMI,
  [Pkm.PAWMO]: Pkm.PAWMI,
  [Pkm.PAWMOT]: Pkm.PAWMI,
  [Pkm.GOLDEEN]: Pkm.GOLDEEN,
  [Pkm.SEAKING]: Pkm.GOLDEEN,
  [Pkm.LUVDISC]: Pkm.LUVDISC,
  [Pkm.AUDINO]: Pkm.AUDINO,
  [Pkm.PETILIL]: Pkm.PETILIL,
  [Pkm.LILIGANT]: Pkm.PETILIL,
  [Pkm.HISUIAN_LILLIGANT]: Pkm.PETILIL,
  [Pkm.MANTYKE]: Pkm.MANTYKE,
  [Pkm.MANTINE]: Pkm.MANTYKE,
  [Pkm.REMORAID]: Pkm.REMORAID,
  [Pkm.OCTILLERY]: Pkm.REMORAID,
  [Pkm.SIGILYPH]: Pkm.SIGILYPH,
  [Pkm.FRIGIBAX]: Pkm.FRIGIBAX,
  [Pkm.ARCTIBAX]: Pkm.FRIGIBAX,
  [Pkm.BAXCALIBUR]: Pkm.FRIGIBAX,
  [Pkm.BINACLE]: Pkm.BINACLE,
  [Pkm.BARBARACLE]: Pkm.BINACLE,
  [Pkm.SKARMORY]: Pkm.SKARMORY,
  [Pkm.DURANT]: Pkm.DURANT,
  [Pkm.OGERPON_TEAL]: Pkm.OGERPON_TEAL,
  [Pkm.OGERPON_TEAL_MASK]: Pkm.OGERPON_TEAL,
  [Pkm.OGERPON_WELLSPRING]: Pkm.OGERPON_TEAL,
  [Pkm.OGERPON_WELLSPRING_MASK]: Pkm.OGERPON_TEAL,
  [Pkm.OGERPON_HEARTHFLAME]: Pkm.OGERPON_TEAL,
  [Pkm.OGERPON_HEARTHFLAME_MASK]: Pkm.OGERPON_TEAL,
  [Pkm.OGERPON_CORNERSTONE]: Pkm.OGERPON_TEAL,
  [Pkm.OGERPON_CORNERSTONE_MASK]: Pkm.OGERPON_TEAL,
  [Pkm.IRON_HANDS]: Pkm.IRON_HANDS,
  [Pkm.ROOKIDEE]: Pkm.ROOKIDEE,
  [Pkm.CORVISQUIRE]: Pkm.ROOKIDEE,
  [Pkm.CORVIKNIGHT]: Pkm.ROOKIDEE,
  [Pkm.MURKROW]: Pkm.MURKROW,
  [Pkm.HONCHKROW]: Pkm.MURKROW,
  [Pkm.SANDYGAST]: Pkm.SANDYGAST,
  [Pkm.PALOSSAND]: Pkm.SANDYGAST,
  [Pkm.TURTONATOR]: Pkm.TURTONATOR,
  [Pkm.SKORUPI]: Pkm.SKORUPI,
  [Pkm.DRAPION]: Pkm.SKORUPI,
  [Pkm.DARUMAKA]: Pkm.DARUMAKA,
  [Pkm.DARMANITAN]: Pkm.DARUMAKA,
  [Pkm.DARMANITAN_ZEN]: Pkm.DARUMAKA,
  [Pkm.GALARIAN_DARUMAKA]: Pkm.GALARIAN_DARUMAKA,
  [Pkm.GALARIAN_DARMANITAN]: Pkm.GALARIAN_DARUMAKA,
  [Pkm.GALARIAN_DARMANITAN_ZEN]: Pkm.GALARIAN_DARUMAKA,
  [Pkm.KRABBY]: Pkm.KRABBY,
  [Pkm.KINGLER]: Pkm.KRABBY,
  [Pkm.SIZZLIPEDE]: Pkm.SIZZLIPEDE,
  [Pkm.CENTISKORCH]: Pkm.SIZZLIPEDE,
  [Pkm.ZYGARDE_10]: Pkm.ZYGARDE_10,
  [Pkm.ZYGARDE_50]: Pkm.ZYGARDE_10,
  [Pkm.ZYGARDE_100]: Pkm.ZYGARDE_10,
  [Pkm.STUFFUL]: Pkm.STUFFUL,
  [Pkm.BEWEAR]: Pkm.STUFFUL,
  [Pkm.GLIMMET]: Pkm.GLIMMET,
  [Pkm.GLIMMORA]: Pkm.GLIMMET,
  [Pkm.FLETCHLING]: Pkm.FLETCHLING,
  [Pkm.FLETCHINDER]: Pkm.FLETCHLING,
  [Pkm.TALONFLAME]: Pkm.FLETCHLING,
  [Pkm.VULLABY]: Pkm.VULLABY,
  [Pkm.MANDIBUZZ]: Pkm.VULLABY,
  [Pkm.INKAY]: Pkm.INKAY,
  [Pkm.MALAMAR]: Pkm.INKAY,
  [Pkm.TIMBURR]: Pkm.TIMBURR,
  [Pkm.GURDURR]: Pkm.TIMBURR,
  [Pkm.CONKELDURR]: Pkm.TIMBURR,
  [Pkm.PILLAR_WOOD]: Pkm.PILLAR_WOOD,
  [Pkm.PILLAR_IRON]: Pkm.PILLAR_IRON,
  [Pkm.PILLAR_CONCRETE]: Pkm.PILLAR_CONCRETE,
  [Pkm.ELGYEM]: Pkm.ELGYEM,
  [Pkm.BEHEEYEM]: Pkm.ELGYEM,
  [Pkm.LITTEN]: Pkm.LITTEN,
  [Pkm.TORRACAT]: Pkm.LITTEN,
  [Pkm.INCINEROAR]: Pkm.LITTEN,
  [Pkm.DRACOZOLT]: Pkm.DRACOZOLT,
  [Pkm.ARCTOZOLT]: Pkm.ARCTOZOLT,
  [Pkm.ARCTOVISH]: Pkm.ARCTOVISH,
  [Pkm.CRYOGONAL]: Pkm.CRYOGONAL,
  [Pkm.DRAMPA]: Pkm.DRAMPA,
  [Pkm.SKRELP]: Pkm.SKRELP,
  [Pkm.DRAGALGE]: Pkm.SKRELP,
  [Pkm.CUBCHOO]: Pkm.CUBCHOO,
  [Pkm.BEARTIC]: Pkm.CUBCHOO,
  [Pkm.NACLI]: Pkm.NACLI,
  [Pkm.NACLSTACK]: Pkm.NACLI,
  [Pkm.GARGANACL]: Pkm.NACLI,
  [Pkm.CAPSAKID]: Pkm.CAPSAKID,
  [Pkm.SCOVILLAIN]: Pkm.CAPSAKID,
  [Pkm.SWIRLIX]: Pkm.SWIRLIX,
  [Pkm.SLURPUFF]: Pkm.SWIRLIX,
  [Pkm.GULPIN]: Pkm.GULPIN,
  [Pkm.SWALOT]: Pkm.GULPIN,
  [Pkm.FIDOUGH]: Pkm.FIDOUGH,
  [Pkm.DACHSBUN]: Pkm.FIDOUGH,
  [Pkm.MILCERY]: Pkm.MILCERY,
  [Pkm.ALCREMIE_VANILLA]: Pkm.MILCERY,
  [Pkm.ALCREMIE_RUBY]: Pkm.MILCERY,
  [Pkm.ALCREMIE_MATCHA]: Pkm.MILCERY,
  [Pkm.ALCREMIE_MINT]: Pkm.MILCERY,
  [Pkm.ALCREMIE_LEMON]: Pkm.MILCERY,
  [Pkm.ALCREMIE_SALTED]: Pkm.MILCERY,
  [Pkm.ALCREMIE_RUBY_SWIRL]: Pkm.MILCERY,
  [Pkm.ALCREMIE_CARAMEL_SWIRL]: Pkm.MILCERY,
  [Pkm.ALCREMIE_RAINBOW_SWIRL]: Pkm.MILCERY,
  [Pkm.PECHARUNT]: Pkm.PECHARUNT,
  [Pkm.VELUZA]: Pkm.VELUZA,
  [Pkm.DURALUDON]: Pkm.DURALUDON,
  [Pkm.ARCHALUDON]: Pkm.DURALUDON,
  [Pkm.SPRIGATITO]: Pkm.SPRIGATITO,
  [Pkm.FLORAGATO]: Pkm.SPRIGATITO,
  [Pkm.MEOWSCARADA]: Pkm.SPRIGATITO,
  [Pkm.FOMANTIS]: Pkm.FOMANTIS,
  [Pkm.LURANTIS]: Pkm.FOMANTIS,
  [Pkm.ROARING_MOON]: Pkm.ROARING_MOON,
  [Pkm.CHARCADET]: Pkm.CHARCADET,
  [Pkm.ARMAROUGE]: Pkm.CHARCADET,
  [Pkm.CERULEDGE]: Pkm.CHARCADET,
  [Pkm.TYNAMO]: Pkm.TYNAMO,
  [Pkm.EELEKTRIK]: Pkm.TYNAMO,
  [Pkm.EELEKTROSS]: Pkm.TYNAMO,
  [Pkm.PIDOVE]: Pkm.PIDOVE,
  [Pkm.TRANQUILL]: Pkm.PIDOVE,
  [Pkm.UNFEZANT]: Pkm.PIDOVE,
  [Pkm.ZACIAN]: Pkm.ZACIAN,
  [Pkm.ZACIAN_CROWNED]: Pkm.ZACIAN,
  [Pkm.IRON_VALIANT]: Pkm.IRON_VALIANT,
  [Pkm.PANCHAM]: Pkm.PANCHAM,
  [Pkm.PANGORO]: Pkm.PANCHAM,
  [Pkm.GROOKEY]: Pkm.GROOKEY,
  [Pkm.THWACKEY]: Pkm.GROOKEY,
  [Pkm.RILLABOOM]: Pkm.GROOKEY,
  [Pkm.KUBFU]: Pkm.KUBFU,
  [Pkm.URSHIFU_SINGLE]: Pkm.KUBFU,
  [Pkm.URSHIFU_RAPID]: Pkm.KUBFU,
  [Pkm.SCREAM_TAIL]: Pkm.SCREAM_TAIL,
  [Pkm.INDEEDEE_FEMALE]: Pkm.INDEEDEE_FEMALE,
  [Pkm.INDEEDEE_MALE]: Pkm.INDEEDEE_MALE,
  [Pkm.COTTONEE]: Pkm.COTTONEE,
  [Pkm.WHIMSICOTT]: Pkm.COTTONEE,
  [Pkm.GIRAFARIG]: Pkm.GIRAFARIG,
  [Pkm.FARIGIRAF]: Pkm.GIRAFARIG,
  [Pkm.SKITTY]: Pkm.SKITTY,
  [Pkm.DELCATTY]: Pkm.SKITTY,
  [Pkm.GLAMEOW]: Pkm.GLAMEOW,
  [Pkm.PURUGLY]: Pkm.GLAMEOW,
  [Pkm.MINCCINO]: Pkm.MINCCINO,
  [Pkm.CINCCINO]: Pkm.MINCCINO,
  [Pkm.ESPURR]: Pkm.ESPURR,
  [Pkm.MEOWSTIC_MALE]: Pkm.ESPURR,
  [Pkm.MEOWSTIC_FEMALE]: Pkm.ESPURR,
  [Pkm.OKIDOGI]: Pkm.OKIDOGI,
  [Pkm.MUNKIDORI]: Pkm.MUNKIDORI,
  [Pkm.FEZANDIPITI]: Pkm.FEZANDIPITI,
  [Pkm.SURSKIT]: Pkm.SURSKIT,
  [Pkm.MASQUERAIN]: Pkm.SURSKIT,
  [Pkm.GOSSIFLEUR]: Pkm.GOSSIFLEUR,
  [Pkm.ELDEGOSS]: Pkm.GOSSIFLEUR,
  [Pkm.FURFROU]: Pkm.FURFROU,
  [Pkm.VAROOM]: Pkm.VAROOM,
  [Pkm.REVAVROOM]: Pkm.VAROOM,
  [Pkm.CELESTEELA]: Pkm.CELESTEELA,
  [Pkm.LEDYBA]: Pkm.LEDYBA,
  [Pkm.LEDIAN]: Pkm.LEDYBA,
  [Pkm.EMOLGA]: Pkm.EMOLGA,
  [Pkm.TAILLOW]: Pkm.TAILLOW,
  [Pkm.SWELLOW]: Pkm.TAILLOW,
  [Pkm.DRILBUR]: Pkm.DRILBUR,
  [Pkm.EXCADRILL]: Pkm.DRILBUR,
  [Pkm.ROGGENROLA]: Pkm.ROGGENROLA,
  [Pkm.BOLDORE]: Pkm.ROGGENROLA,
  [Pkm.GIGALITH]: Pkm.ROGGENROLA,
  [Pkm.TOGEDEMARU]: Pkm.TOGEDEMARU,
  [Pkm.FALINKS_BRASS]: Pkm.FALINKS_TROOPER,
  [Pkm.FALINKS_TROOPER]: Pkm.FALINKS_TROOPER,
  [Pkm.DEDENNE]: Pkm.DEDENNE,
  [Pkm.SILICOBRA]: Pkm.SILICOBRA,
  [Pkm.SANDACONDA]: Pkm.SILICOBRA,
  [Pkm.DUNSPARCE]: Pkm.DUNSPARCE,
  [Pkm.DUDUNSPARCE]: Pkm.DUNSPARCE,
  [Pkm.SMOLIV]: Pkm.SMOLIV,
  [Pkm.DOLLIV]: Pkm.SMOLIV,
  [Pkm.ARBOLIVA]: Pkm.SMOLIV,
  [Pkm.CHESPIN]: Pkm.CHESPIN,
  [Pkm.QUILLADIN]: Pkm.CHESPIN,
  [Pkm.CHESNAUGHT]: Pkm.CHESPIN,
  [Pkm.NYMBLE]: Pkm.NYMBLE,
  [Pkm.LOKIX]: Pkm.NYMBLE,
  [Pkm.BLIPBUG]: Pkm.BLIPBUG,
  [Pkm.DOTTLER]: Pkm.BLIPBUG,
  [Pkm.ORBEETLE]: Pkm.BLIPBUG,
  [Pkm.PACHIRISU]: Pkm.PACHIRISU,
  [Pkm.BUZZWOLE]: Pkm.BUZZWOLE,
  [Pkm.YAMASK]: Pkm.YAMASK,
  [Pkm.COFAGRIGUS]: Pkm.YAMASK,
  [Pkm.GALARIAN_YAMASK]: Pkm.GALARIAN_YAMASK,
  [Pkm.RUNERIGUS]: Pkm.GALARIAN_YAMASK,
  [Pkm.CHEWTLE]: Pkm.CHEWTLE,
  [Pkm.DREDNAW]: Pkm.CHEWTLE,
  [Pkm.GREAVARD]: Pkm.GREAVARD,
  [Pkm.HOUNDSTONE]: Pkm.GREAVARD,
  [Pkm.CLOBBOPUS]: Pkm.CLOBBOPUS,
  [Pkm.GRAPPLOCT]: Pkm.CLOBBOPUS,
  [Pkm.CHI_YU]: Pkm.CHI_YU,
  [Pkm.WIMPOD]: Pkm.WIMPOD,
  [Pkm.GOLISOPOD]: Pkm.WIMPOD,
  [Pkm.BASCULIN_RED]: Pkm.BASCULIN_RED,
  [Pkm.BASCULIN_BLUE]: Pkm.BASCULIN_BLUE,
  [Pkm.BASCULIN_WHITE]: Pkm.BASCULIN_WHITE,
  [Pkm.BASCULEGION_MALE]: Pkm.BASCULIN_WHITE,
  [Pkm.BASCULEGION_FEMALE]: Pkm.BASCULIN_WHITE,
  [Pkm.KLINK]: Pkm.KLINK,
  [Pkm.KLANG]: Pkm.KLINK,
  [Pkm.KLINKLANG]: Pkm.KLINK,
  [Pkm.GALARIAN_SLOWPOKE]: Pkm.GALARIAN_SLOWPOKE,
  [Pkm.GALARIAN_SLOWBRO]: Pkm.GALARIAN_SLOWPOKE,
  [Pkm.GALARIAN_SLOWKING]: Pkm.GALARIAN_SLOWPOKE,
  [Pkm.WIGLETT]: Pkm.WIGLETT,
  [Pkm.WUGTRIO]: Pkm.WIGLETT,
  [Pkm.FLUTTER_MANE]: Pkm.FLUTTER_MANE,
  [Pkm.WALKING_WAKE]: Pkm.WALKING_WAKE,
  [Pkm.ORTHWORM]: Pkm.ORTHWORM,
  [Pkm.IRON_THORNS]: Pkm.IRON_THORNS,
  [Pkm.TADBULB]: Pkm.TADBULB,
  [Pkm.BELLIBOLT]: Pkm.TADBULB,
  [Pkm.PINCURCHIN]: Pkm.PINCURCHIN,
  [Pkm.MUDBRAY]: Pkm.MUDBRAY,
  [Pkm.MUDSDALE]: Pkm.MUDBRAY,
  [Pkm.SKIDDO]: Pkm.SKIDDO,
  [Pkm.GOGOAT]: Pkm.SKIDDO,
  [Pkm.BUNNELBY]: Pkm.BUNNELBY,
  [Pkm.DIGGERSBY]: Pkm.BUNNELBY,
  [Pkm.SCATTERBUG]: Pkm.SCATTERBUG,
  [Pkm.SPEWPA]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_ICY_SNOW]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_POLAR]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_TUNDRA]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_CONTINENTAL]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_GARDEN]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_ELEGANT]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_MODERN]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_MARINE]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_ARCHIPELAGO]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_HIGH_PLAINS]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_SANDSTORM]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_RIVER]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_MONSOON]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_SAVANNA]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_SUN]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_OCEAN]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_JUNGLE]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_FANCY]: Pkm.SCATTERBUG,
  [Pkm.VIVILLON_POKE_BALL]: Pkm.SCATTERBUG,
  [Pkm.LECHONK]: Pkm.LECHONK,
  [Pkm.OINKOLOGNE_MALE]: Pkm.LECHONK,
  [Pkm.WOOLOO]: Pkm.WOOLOO,
  [Pkm.DUBWOOL]: Pkm.WOOLOO,
  [Pkm.YAMPER]: Pkm.YAMPER,
  [Pkm.BOLTUND]: Pkm.YAMPER,
  [Pkm.GREAT_TUSK]: Pkm.GREAT_TUSK,
  [Pkm.FINIZEN]: Pkm.FINIZEN,
  [Pkm.PALAFIN]: Pkm.FINIZEN,
  [Pkm.PALAFIN_HERO]: Pkm.FINIZEN,
  [Pkm.MAREANIE]: Pkm.MAREANIE,
  [Pkm.TOXAPEX]: Pkm.MAREANIE,
  [Pkm.DUCKLETT]: Pkm.DUCKLETT,
  [Pkm.SWANNA]: Pkm.DUCKLETT,
  [Pkm.GLASTRIER]: Pkm.GLASTRIER,
  [Pkm.DONDOZO]: Pkm.DONDOZO,
  [Pkm.TATSUGIRI_CURLY]: Pkm.TATSUGIRI_CURLY,
  [Pkm.TATSUGIRI_DROOPY]: Pkm.TATSUGIRI_DROOPY,
  [Pkm.TATSUGIRI_STRETCHY]: Pkm.TATSUGIRI_STRETCHY,
  [Pkm.CETODDLE]: Pkm.CETODDLE,
  [Pkm.CETITAN]: Pkm.CETODDLE,
  [Pkm.BERGMITE]: Pkm.BERGMITE,
  [Pkm.AVALUGG]: Pkm.BERGMITE,
  [Pkm.HISUI_AVALUGG]: Pkm.BERGMITE,
  [Pkm.KARRABLAST]: Pkm.KARRABLAST,
  [Pkm.ESCAVALIER]: Pkm.KARRABLAST,
  [Pkm.EISCUE]: Pkm.EISCUE,
  [Pkm.EISCUE_NOICE]: Pkm.EISCUE,
  [Pkm.DWEBBLE]: Pkm.DWEBBLE,
  [Pkm.CRUSTLE]: Pkm.DWEBBLE
}

export const PkmRegionalVariants: { [key in Pkm]?: readonly Pkm[] } = {
  [Pkm.RATTATA]: [Pkm.ALOLAN_RATTATA],
  [Pkm.GROWLITHE]: [Pkm.HISUI_GROWLITHE],
  [Pkm.VULPIX]: [Pkm.ALOLAN_VULPIX],
  [Pkm.GEODUDE]: [Pkm.ALOLAN_GEODUDE],
  [Pkm.DIGLETT]: [Pkm.ALOLAN_DIGLETT],
  [Pkm.ZORUA]: [Pkm.HISUI_ZORUA],
  [Pkm.GRIMER]: [Pkm.ALOLAN_GRIMER],
  [Pkm.NIDORANM]: [Pkm.NIDORANF],
  [Pkm.SNEASEL]: [Pkm.HISUI_SNEASEL],
  [Pkm.MEOWTH]: [Pkm.ALOLAN_MEOWTH],
  [Pkm.PONYTA]: [Pkm.GALARIAN_PONYTA],
  [Pkm.VOLTORB]: [Pkm.HISUI_VOLTORB],
  [Pkm.SANDSHREW]: [Pkm.ALOLAN_SANDSHREW],
  [Pkm.WOOPER]: [Pkm.PALDEA_WOOPER],
  [Pkm.FARFETCH_D]: [Pkm.GALARIAN_FARFETCH_D],
  [Pkm.ZIGZAGOON]: [Pkm.GALARIAN_ZIGZAGOON],
  [Pkm.ARTICUNO]: [Pkm.GALARIAN_ARTICUNO],
  [Pkm.ZAPDOS]: [Pkm.GALARIAN_ZAPDOS],
  [Pkm.MOLTRES]: [Pkm.GALARIAN_MOLTRES],
  [Pkm.QWILFISH]: [Pkm.HISUIAN_QWILFISH],
  [Pkm.YAMASK]: [Pkm.GALARIAN_YAMASK],
  [Pkm.SLOWPOKE]: [Pkm.GALARIAN_SLOWPOKE],
  [Pkm.WEEZING]: [Pkm.GALARIAN_WEEZING],
  [Pkm.SUICUNE]: [Pkm.WALKING_WAKE],
  [Pkm.SCYTHER]: [Pkm.SCIZOR, Pkm.KLEAVOR],
  [Pkm.TAUROS]: [
    Pkm.TAUROS_COMBAT_BREED,
    Pkm.TAUROS_BLAZE_BREED,
    Pkm.TAUROS_AQUA_BREED
  ],
  [Pkm.LUGIA]: [Pkm.SHADOW_LUGIA],
  [Pkm.MEWTWO]: [Pkm.SHADOW_MEWTWO],
  [Pkm.DARUMAKA]: [Pkm.GALARIAN_DARUMAKA]
} as const

export function isRegionalVariant(a: Pkm, b: Pkm): boolean {
  return (
    (PkmRegionalVariants[a]?.includes(b) ?? false) ||
    (PkmRegionalVariants[b]?.includes(a) ?? false)
  )
}

export const PkmRegionalBaseVariants: { [key in Pkm]?: Pkm } =
  Object.fromEntries(
    Object.entries(PkmRegionalVariants).flatMap(([base, variants]) =>
      variants.map((variant) => [variant, PkmFamily[base]])
    )
  ) as { [key in Pkm]?: Pkm }

export enum PkmDuo {
  LATIOS_LATIAS = "LATIOS_LATIAS",
  PLUSLE_MINUN = "PLUSLE_MINUN",
  ILLUMISE_VOLBEAT = "ILLUMISE_VOLBEAT",
  NINJASK_SHEDINJA = "NINJASK_SHEDINJA",
  INDEEDEE = "INDEEDEE",
  BASCULIN_RED_BLUE = "BASCULIN_RED_BLUE"
}

export type PkmProposition = Pkm | PkmDuo

export const PkmDuos = {
  [PkmDuo.LATIOS_LATIAS]: [Pkm.LATIOS, Pkm.LATIAS],
  [PkmDuo.PLUSLE_MINUN]: [Pkm.PLUSLE, Pkm.MINUN],
  [PkmDuo.ILLUMISE_VOLBEAT]: [Pkm.ILLUMISE, Pkm.VOLBEAT],
  [PkmDuo.NINJASK_SHEDINJA]: [Pkm.NINJASK, Pkm.SHEDINJA],
  [PkmDuo.INDEEDEE]: [Pkm.INDEEDEE_FEMALE, Pkm.INDEEDEE_MALE],
  [PkmDuo.BASCULIN_RED_BLUE]: [Pkm.BASCULIN_RED, Pkm.BASCULIN_BLUE]
}

export const Unowns: Pkm[] = [
  Pkm.UNOWN_A,
  Pkm.UNOWN_B,
  Pkm.UNOWN_C,
  Pkm.UNOWN_D,
  Pkm.UNOWN_E,
  Pkm.UNOWN_F,
  Pkm.UNOWN_G,
  Pkm.UNOWN_H,
  Pkm.UNOWN_I,
  Pkm.UNOWN_J,
  Pkm.UNOWN_K,
  Pkm.UNOWN_L,
  Pkm.UNOWN_M,
  Pkm.UNOWN_N,
  Pkm.UNOWN_O,
  Pkm.UNOWN_P,
  Pkm.UNOWN_Q,
  Pkm.UNOWN_R,
  Pkm.UNOWN_S,
  Pkm.UNOWN_T,
  Pkm.UNOWN_U,
  Pkm.UNOWN_V,
  Pkm.UNOWN_W,
  Pkm.UNOWN_X,
  Pkm.UNOWN_Y,
  Pkm.UNOWN_Z,
  Pkm.UNOWN_QUESTION,
  Pkm.UNOWN_EXCLAMATION
]

export const UnownsForScribble: Pkm[] = [
  Pkm.UNOWN_B,
  Pkm.UNOWN_C,
  Pkm.UNOWN_D,
  Pkm.UNOWN_G,
  Pkm.UNOWN_H,
  Pkm.UNOWN_I,
  Pkm.UNOWN_M,
  Pkm.UNOWN_N,
  Pkm.UNOWN_O,
  Pkm.UNOWN_R,
  Pkm.UNOWN_S,
  Pkm.UNOWN_T,
  Pkm.UNOWN_V,
  Pkm.UNOWN_W,
  Pkm.UNOWN_X,
  Pkm.UNOWN_Y,
  Pkm.UNOWN_Z,
  Pkm.UNOWN_EXCLAMATION,
  Pkm.UNOWN_QUESTION
]

export const NonPkm: Pkm[] = [
  Pkm.SUBSTITUTE,
  Pkm.EGG,
  Pkm.PILLAR_WOOD,
  Pkm.PILLAR_IRON,
  Pkm.PILLAR_CONCRETE,
  Pkm.DEFAULT
]

export const NON_PMD_PKM_INDEXES: string[] = [
  "0532-0002", // Pillar Wood
  "0533-0002", // Pillar Iron
  "0534-0002", // Pillar Concrete,
  "0025-9999" // Pikachu Surfer
]
